<template>
  <div class="pk-openbox-page">
    <!-- <div class="openbox-page">
      <div class="mySlide"><myslide></myslide></div>
    </div> -->
    <div
      class="openbox"
      :style="{
        backgroundImage: 'url(' + img + ')',
      }"
    >
      <div class="openbox yidong">
        <div class="kai-box">
          <!-- 单个盒子打开动画 v-if="openBoxState && kaiBox == 1" -->
          <div
            :class="[showNav == false ? 'kai-box-open2m' : 'kai-box-open2']"
            v-if="openBoxState && kaiBox == 1"
          >
            <div class="kai-warp11">
              <img class="dingbu" src="../assets/img/dingbu.png" alt="" />
              <img class="kaibox-line" src="../assets/img/shuxian.png" alt="" />
              <ul>
                <li
                  v-for="(item, index) in imgList"
                  :key="index"
                  :style="{
                    backgroundImage: 'url(' + item.background + ')',
                  }"
                >
                  <img :src="item.img" />
                </li>
              </ul>
              <img class="dibu" src="../assets/img/dibu.png" alt="" />
            </div>
          </div>

          <!-- 开盒子 -->
          <!-- 2个盒子打开动画  v-if="openBoxState && kaiBox != 1" -->

          <div
            :class="[showNav == false ? 'kai-box-open22m' : 'kai-box-open22']"
            v-if="openBoxState && kaiBox == 2"
          >
            <div class="kai-warp11">
              <img class="dingbu" src="../assets/img/dingbu.png" alt="" />
              <img class="kaibox-line" src="../assets/img/shuxian.png" alt="" />
              <div
                :class="{
                  'kaibox-warp kaibox-warp2 ': kaiBox == 2,
                }"
              >
                <ul class="kaibox-ul">
                  <li
                    :class="['kaibox-li', 'li' + kaiBox]"
                    v-for="(item, index) in imgList1"
                    :key="index"
                  >
                    <ul>
                      <li
                        v-for="(item1, index1) in item"
                        :key="index1"
                        :style="{
                          backgroundImage: 'url(' + item1.background + ')',
                        }"
                        :data="item1.name"
                      >
                        <img
                          :src="item1.img"
                          :class="{
                            'kaibox-img2': kaiBox == 2,
                          }"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <img class="dibu" src="../assets/img/dibu.png" alt="" />
            </div>
          </div>
          <!-- 3个盒子打开动画  v-if="openBoxState && kaiBox != 1" -->
          <div
            :class="[showNav == false ? 'kai-box-open3m' : 'kai-box-open3']"
            v-if="openBoxState && kaiBox == 3"
          >
            <div class="kai-warp1">
              <img class="dingbu" src="../assets/img/dibu.png" alt="" />
              <img class="kaibox-line" src="../assets/img/shuxian.png" alt="" />
              <div
                :class="{
                  'kaibox-warp kaibox-warp3': kaiBox == 3,
                }"
              >
                <ul class="kaibox-ul">
                  <li
                    class="kaibox-li"
                    v-for="(item, index) in imgList1"
                    :key="index"
                    :style="{
                      animation: 'run-li' + 1 + ' 7.5s',
                    }"
                  >
                    <ul>
                      <li
                        v-for="(item1, index1) in item"
                        :key="index1"
                        :style="{
                          backgroundImage: 'url(' + item1.background + ')',
                        }"
                        :data="item1.name"
                      >
                        <img
                          :src="item1.img"
                          :class="{
                            'kaibox-img3': kaiBox == 3,
                          }"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <img class="dibu" src="../assets/img/dibu.png" alt="" />
            </div>
          </div>
          <!-- 4个盒子打开动画  v-if="openBoxState && kaiBox != 1" -->
          <div
            :class="[showNav == false ? 'kai-box-open4m' : 'kai-box-open4']"
            v-if="openBoxState && kaiBox == 4"
          >
            <div class="kai-warp1">
              <img class="dingbu" src="../assets/img/dibu.png" alt="" />
              <img class="kaibox-line" src="../assets/img/shuxian.png" alt="" />
              <div
                :class="{
                  'kaibox-warp kaibox-warp4': kaiBox == 4,
                }"
              >
                <ul class="kaibox-ul">
                  <li
                    class="kaibox-li"
                    v-for="(item, index) in imgList1"
                    :key="index"
                    :style="{
                      animation: 'run-li' + 1 + ' 7.5s',
                    }"
                  >
                    <ul>
                      <li
                        v-for="(item1, index1) in item"
                        :key="index1"
                        :style="{
                          backgroundImage: 'url(' + item1.background + ')',
                        }"
                        :data="item1.name"
                      >
                        <img
                          :src="item1.img"
                          :class="{
                            'kaibox-img4': kaiBox == 4,
                          }"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <img class="dibu" src="../assets/img/dibu.png" alt="" />
            </div>
          </div>
          <!-- 5个盒子打开动画  v-if="openBoxState && kaiBox != 1" -->
          <div
            :class="[showNav == false ? 'kai-box-open5m' : 'kai-box-open5']"
            v-if="openBoxState && kaiBox == 5"
          >
            <div class="kai-warp1">
              <img class="dingbu" src="../assets/img/dibu.png" alt="" />
              <img class="kaibox-line" src="../assets/img/shuxian.png" alt="" />
              <div
                :class="{
                  'kaibox-warp kaibox-warp5': kaiBox == 5,
                }"
              >
                <ul class="kaibox-ul">
                  <li
                    class="kaibox-li"
                    v-for="(item, index) in imgList1"
                    :key="index"
                    :style="{
                      animation: 'run-li' + 1 + ' 7.5s',
                    }"
                  >
                    <ul>
                      <li
                        v-for="(item1, index1) in item"
                        :key="index1"
                        :style="{
                          backgroundImage: 'url(' + item1.background + ')',
                        }"
                        :data="item1.name"
                      >
                        <img
                          :src="item1.img"
                          :class="{
                            'kaibox-img5': kaiBox == 5,
                          }"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <img class="dibu" src="../assets/img/dibu.png" alt="" />
            </div>
          </div>
        </div>

        <!--中奖完成后盒子-->
        <div class="win-box" v-if="winState">
          <mywin
            :winList="winList"
            :winState="winState"
            @winexchange="winexchange($event)"
            @winget="winget($event)"
            @winX="winX($event)"
            @continue="continueOpen"
          ></mywin>
        </div>
        <div class="clear"></div>
        <!-- 箱子信息加载loading效果 -->
        <div
          v-show="loadFlag"
          v-loading="loadFlag"
          element-loading-text="拼命加载中"
          class="kai-masked"
        ></div>
        <!-- 箱子主体信息 -->
        <div v-show="box_name" class="kai-con" v-if="showNav">
          <div class="con-name">{{ caseDisplayName(box_name) }}</div>
          <div class="con-list">
            <ul>
              <li v-for="item in kaiBox1" :key="item">
                <div class="conlist-warp">
                  <div class="conlist-box">
                    <img src="@/assets/new/lottery_bg3.png" />
                  </div>
                  <div class="conlist-box1">
                    <img :src="box_obj.img_active" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="con-num" v-if="!isNewUser">
            <ul>
              <li
                v-for="(item, index) in kaiBoxNum"
                :key="index"
                :class="item.state ? 'con-num-check' : ''"
                @click="chooseNum(item.num)"
              >
                <span>{{ item.num }}</span>
              </li>
            </ul>
          </div>

          <div class="buy-container">
            <div class="con-btn" @click="buyBox()">
              <div class="con-btn1" v-if="!isNewUser">
                <img src="../assets/img/money.png" /><span>
                  {{ (price * kaiBox).toFixed(2) }}
                </span>
              </div>
              <div class="con-btn1" v-else>新用户免费打开箱子</div>
            </div>
            <img
              :src="
                require(`@/assets/img/open-box/${!cartState}-animation.png`)
              "
              class="img"
              alt=""
              @click="cartState = !cartState"
              srcset=""
            />
          </div>
        </div>
        <!-- 箱子主体信息 -->
        <div class="kai-conm" v-else style="margin-top: 0px">
          <div class="moblie-box-name">{{ caseDisplayName(box_name) }}</div>
          <div class="con-list" style="margin-top: 145px">
            <ul>
              <li v-for="item in kaiBox1" :key="item">
                <div class="conlist-warp">
                  <div class="conlist-box">
                    <img src="@/assets/new/lottery_bg3.png" />
                  </div>
                  <div class="conlist-box1">
                    <img :src="box_obj.img_active" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="con-num" v-if="!isNewUser">
            <ul>
              <li
                v-for="(item, index) in kaiBoxNum"
                :key="index"
                :class="item.state ? 'con-num-check' : ''"
                @click="chooseNum(item.num)"
              >
                <span>{{ item.num }}</span>
              </li>
            </ul>
          </div>

          <div class="buy-container">
            <div class="con-btn" @click="buyBox()">
              <div class="con-btn1" v-if="!isNewUser">
                <img src="../assets/img/money.png" /><span>
                  {{ (price * kaiBox).toFixed(2) }}
                </span>
              </div>
              <div class="con-btn1" v-else>新用户免费打开箱子</div>
            </div>
            <img
              :src="
                require(`@/assets/img/open-box/${!cartState}-animation.png`)
              "
              class="img"
              alt=""
              @click="cartState = !cartState"
              srcset=""
            />
          </div>
        </div>
        <div class="kai-num">
          <span></span>
        </div>
      </div>

      <section v-if="!openboxOnly" class="pk-target-battles">
        <article v-for="battle in targetBattles" :key="battle.id" class="pk-target-battle-card">
          <div class="pk-target-battle-head">
            <div>
              <span>玩家</span>
              <strong>{{ battle.players }}</strong>
            </div>
            <button>观看</button>
            <div>
              <span>{{ battle.rounds }} 回合</span>
              <strong>{{ battle.price }} <i></i></strong>
            </div>
          </div>
          <div class="pk-target-battle-cases">
            <span v-for="item in battle.cases" :key="item">{{ item }}</span>
          </div>
        </article>
      </section>

      <div class="pk-target-case" :class="{ 'pk-cheese-case': targetCase.consumeCurrency === 'cheese' }">
        <section v-if="targetCaseUnavailable" class="pk-target-unavailable">
          <strong>该箱子暂不可用</strong>
          <span>箱子可能已下架、被删除或暂时无法读取。</span>
          <button type="button" @click="$router.push({ path: caseListPath })">返回箱子列表</button>
        </section>
        <section v-else-if="targetCaseLoading" class="pk-target-unavailable">
          <strong>正在读取箱子数据</strong>
          <span>请稍候。</span>
        </section>
        <section v-else class="pk-target-panel">
          <button class="pk-target-back" type="button" @click="$router.push({ path: caseListPath })">返回 <span></span></button>
          <h1>{{ caseDisplayName(targetCase.name) }}</h1>
          <div class="pk-target-case-art">
            <img
              :key="targetCase.img + '-' + targetCaseDropKey"
              :class="{ dropping: targetCaseDropping }"
              :src="targetCase.img"
              :data-fallback="targetCase.fallback"
              alt=""
              @error="replaceBrokenImage"
            />
          </div>
          <div class="pk-target-amounts">
            <button
              v-for="amount in targetAmounts"
              :key="amount"
              :class="{ active: targetAmount === amount }"
              @click="selectTargetAmount(amount)"
            >
              {{ amount }}
            </button>
          </div>
          <div
            class="pk-target-reels"
            :class="'amount-' + targetAmount"
            :style="{
              '--pk-target-card-width': targetReelCardWidth + 'px',
              '--pk-target-card-gap': targetReelCardGap + 'px',
              '--pk-target-reel-start': targetReelStartOffset + 'px',
              '--pk-target-effect-image': targetCase.effect ? 'url(' + targetCase.effect + ')' : 'none',
            }"
          >
            <div
              v-for="row in targetReelRows"
              :key="targetSpinKey + '-' + row.id"
              class="pk-target-reel"
              :class="{
                full: row.layout === 'full',
                half: row.layout === 'half',
              }"
            >
              <div class="pk-target-reel-line"></div>
              <div class="pk-target-pointer pk-target-pointer-top"></div>
              <div class="pk-target-pointer pk-target-pointer-bottom"></div>
              <div class="pk-target-reel-viewport">
                <div
                  class="pk-target-reel-track"
                  :style="{
                    '--pk-target-reel-end': row.endOffset + 'px',
                  }"
                  :class="{
                    spinning: targetOpening,
                    fast: targetFast,
                    settled: targetFinished,
                  }"
                >
                  <div
                    v-for="(item, index) in row.items"
                    :key="row.id + '-' + item.name + index"
                    class="pk-target-reel-card"
                    :class="[rarityClass(targetReelItem(item)), { winner: targetFinished && index === row.winnerIndex, 'pk-hidden-gold-card': isMaskedHiddenGold(item) }]"
                     :style="targetReelCardStyle(item)"
                  >
                    <img :src="targetImage(item, 220)" :data-fallback="fallbackImage(item)" alt="" @error="replaceBrokenImage" />
                    <strong>{{ compactName(item.name) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pk-target-actions">
            <button :disabled="loading || targetOpening" @click="startTargetOpen(false)">
              {{ targetOpenActionLabel }}
              <i v-if="targetCase.consumeCurrency === 'pizza'"></i>
              <img v-else-if="targetCase.consumeCurrency === 'cheese'" class="pk-target-currency-icon" :src="cheeseIcon" alt="奶酪币" />
            </button>
            <button :disabled="loading || targetOpening" @click="startTargetOpen(true)">
              {{ targetFastOpenActionLabel }}
              <i v-if="targetCase.consumeCurrency === 'pizza'"></i>
              <img v-else-if="targetCase.consumeCurrency === 'cheese'" class="pk-target-currency-icon" :src="cheeseIcon" alt="奶酪币" />
            </button>
          </div>
        </section>

        <section v-if="!openboxOnly && !targetCaseLoading && !targetCaseUnavailable" class="pk-target-contract">
          <div class="pk-target-contract-copy">
            <h2>推荐用于合约</h2>
            <p>该箱子中的饰品可用于合约经典模式。</p>
          </div>
          <div class="pk-target-contract-box">
            <h3>可能的合约掉落</h3>
            <div class="pk-target-contract-list">
              <article v-for="item in targetContractDrops" :key="item.name" :class="[rarityClass(item), { 'pk-hidden-gold-card': item.is_hidden_gold }]">
                <img v-if="!item.is_hidden_gold" class="pk-target-grade-bg" :src="gradeImage(item)" alt="" @error="hideBrokenImage" />
                <img :src="targetImage(item, 220)" :data-fallback="fallbackImage(item)" alt="" @error="replaceBrokenImage" />
                <strong>{{ compactName(item.name) }}</strong>
                <em>{{ targetPrice(item.price) }}</em>
              </article>
            </div>
          </div>
        </section>

        <section v-if="!targetCaseLoading && !targetCaseUnavailable" class="pk-target-contains">
          <h2><i></i>箱内饰品</h2>
          <div class="pk-target-grid">
            <article
              v-for="item in targetSkins"
              :key="item.id || item.name"
              class="pk-target-card"
              :class="[rarityClass(item), { 'pk-dark-gold': isDarkGold(item), 'pk-hidden-gold-card': item.is_hidden_gold }]"
              tabindex="0"
            >
              <div class="pk-target-card-art">
                <img v-if="!item.is_hidden_gold" class="pk-target-grade-bg" :src="gradeImage(item)" alt="" @error="hideBrokenImage" />
                <img :src="targetImage(item, 220)" :data-fallback="fallbackImage(item)" alt="" @error="replaceBrokenImage" />
              </div>
              <div class="pk-target-card-price">
                <span>{{ targetChance(item) }}</span>
                <strong>{{ targetCardPrice(item) }}<i aria-hidden="true"></i></strong>
              </div>
              <div class="pk-target-card-copy">
                <span v-if="isStatTrak(item.name)">StatTrak™</span>
                <strong>{{ weaponName(item.name) }}</strong>
                <b>{{ skinName(item.name) }}</b>
                <em>{{ targetExterior(item) }}</em>
              </div>
            </article>
          </div>
          <article v-if="targetCase.hasHiddenReward" class="pk-target-hidden-reward">
            <span>隐藏奖励</span>
            <strong>神秘隐藏奖项</strong>
            <p>隐藏饰品在开奖前统一显示为神秘金图，只有中奖玩家能在自己的开奖结果与背包中看到真实饰品。</p>
            <i></i>
          </article>
        </section>

        <section v-if="!targetCaseLoading && !targetCaseUnavailable" class="pk-target-drop-activity">
          <article class="pk-target-drop-panel">
            <header>
              <div>
                <span>今日</span>
                <h2>最佳掉落</h2>
              </div>
              <em>按饰品价值排序</em>
            </header>
            <div v-if="targetTodayBest.length" class="pk-target-best-list">
              <div v-for="item in targetTodayBest" :key="'best-' + item.id" class="pk-target-best-card" :class="{ 'pk-hidden-gold-card': item.is_hidden_gold }">
                <img v-if="!item.is_hidden_gold" class="pk-target-grade-bg" :src="gradeImage(item)" alt="" @error="hideBrokenImage" />
                <img :src="targetDropImage(item)" :data-fallback="dropFallback(item)" alt="" @error="replaceBrokenImage" />
                <strong>{{ targetPrice(item.price) }}</strong>
                <span>{{ compactName(item.skin_name) }}</span>
              </div>
            </div>
            <p v-else class="pk-target-drop-empty">今日暂时没有该箱子的掉落记录</p>
          </article>

          <article class="pk-target-drop-panel">
            <header>
              <div>
                <span>实时</span>
                <h2>最近掉落</h2>
              </div>
              <em>最新 20 条记录</em>
            </header>
            <div v-if="targetRecentDrops.length" class="pk-target-recent-list">
              <div v-for="item in targetRecentDrops" :key="'recent-' + item.id" class="pk-target-recent-item" :class="{ 'pk-hidden-gold-card': item.is_hidden_gold }">
                <img class="pk-target-drop-avatar" :src="item.player_img" :data-fallback="defaultAvatar" alt="" @error="replaceBrokenImage" />
                <img v-if="!item.is_hidden_gold" class="pk-target-grade-bg" :src="gradeImage(item)" alt="" @error="hideBrokenImage" />
                <img class="pk-target-drop-skin" :src="targetDropImage(item)" :data-fallback="dropFallback(item)" alt="" @error="replaceBrokenImage" />
                <div>
                  <strong>{{ item.player_name }}</strong>
                  <span>{{ compactName(item.skin_name) }}</span>
                </div>
                <em>{{ targetPrice(item.price) }}</em>
              </div>
            </div>
            <p v-else class="pk-target-drop-empty">暂时没有该箱子的掉落记录</p>
          </article>
        </section>
      </div>

      <div class="box-list" v-if="box_name">
        <div class="boxlist-top">
          <div class="left">
            <span :class="winBoxState ? '' : 'span1'" @click="getBoxOrn"
              >包含以下皮肤</span
            >
            <span :class="winBoxState ? 'span1' : ''" @click="getWinPeo"
              >最近掉落</span
            >
          </div>
        </div>
        <div class="boxlist-bot" v-if="!winBoxState && showNav">
          <ul>
            <li
              v-for="(item, index) in skin_list"
              :key="index"
              class="card"
              :style="{
                backgroundImage: 'url(' + item.background + ')',
              }"
            >
              <div class="boxlist-warp">
                <div class="boxlist1-top">
                  <span class="ico">{{ item.exteriorName }}</span>
                  <img :src="item.img" />
                </div>
                <div class="boxlist1-top-desc">
                  <div class="list-pirce">
                    <div class="pirce-left">
                      <img src="../assets/new/money.png" />
                      <div>
                        <span>{{ item.price }}</span>
                        <!-- <span>{{ item.probability }}%</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="boxlist1-bot" :title="item.name">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="boxlist-botm" v-if="!winBoxState && !showNav">
          <div class="increase-rose" v-if="skins_types.length">
            <div
              class="rose-item"
              v-for="(item, index) in skins_types"
              :key="index"
            >
              <div
                class="point"
                :style="{
                  background: item.color,
                }"
              ></div>
              <span :style="{ color: item.color }"
                >{{ item.skins_type_probability }}%</span
              >
            </div>
          </div>
          <ul>
            <li
              v-for="(item, index) in skin_list"
              :key="index"
              class="card"
              :style="{
                backgroundImage: 'url(' + item.background + ')',
              }"
            >
              <div class="boxlist-warp">
                <div class="boxlist1-top">
                  <span class="ico">{{ item.exteriorName }}</span>
                  <img :src="item.img" />
                </div>

                <div class="boxlist1-top-desc">
                  <div class="list-pirce">
                    <div class="pirce-left">
                      <img src="../assets/new/money.png" />
                      <div>
                        <span>{{ item.price }}</span>
                        <!-- <span>{{ item.probability }}%</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="boxlist1-bot" :title="item.name">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="clear"></div>

        <div class="boxlist-bot" v-if="winBoxState && showNav">
          <div v-if="winBoxState" class="filter-user-type">
            <span
              :class="{ active_type: active_type == 0 }"
              @click="
                active_type = 0;
                getWinPeo();
              "
            >
              会员</span
            >
            <span
              :class="{ active_type: active_type == 1 }"
              @click="
                active_type = 1;
                getWinPeo();
              "
              >主播</span
            >
          </div>
          <div class="fliter-tab">
            <p>用户名</p>
            <p>获得饰品详情</p>
          </div>
          <div
            class="drop-item"
            v-for="(item, index) in skin_list1"
            :key="index"
          >
            <div class="user-info">
              <img :src="item.player_img" />
              <span>{{ item.player_name }}</span>
              <img v-if="item.image" class="border-image" :src="item.image" />
            </div>
            <img :src="item.imageUrl" style="width: 80px; margin-right: 15px" />
            <p :style="{ color: item.color }">
              {{ item.skin_name }}
            </p>
          </div>
        </div>
        <div class="boxlist-botm" v-if="winBoxState && !showNav">
          <div v-if="winBoxState" class="filter-user-type">
            <span
              :class="{ active_type: active_type == 0 }"
              @click="
                active_type = 0;
                getWinPeo();
              "
            >
              会员</span
            >
            <span
              :class="{ active_type: active_type == 1 }"
              @click="
                active_type = 1;
                getWinPeo();
              "
              >主播</span
            >
          </div>
          <div class="fliter-tab">
            <p>用户名</p>
            <p>获得饰品详情</p>
          </div>
          <div
            class="drop-item"
            v-for="(item, index) in skin_list1"
            :key="index"
          >
            <span class="user">
              <img :src="item.player_img" />
              <span>{{ item.player_name }}</span>
              <img v-if="item.image" class="border-image" :src="item.image" />
            </span>
            <img :src="item.imageUrl" style="width: 80px; margin-right: 15px" />
            <span :style="{ color: item.color, width: '200px' }">{{
              item.skin_name
            }}</span>
          </div>
        </div>
        <div class="clear"></div>
      </div>

      <!-- 分享-->
      <el-dialog
        title="分享链接"
        :visible.sync="dialogFormVisible"
        width="200px"
        class="share-hide"
      >
        <div class="share-btn">
          <el-input v-model="url" autocomplete="off"></el-input>
          <el-button class="btn" type="warning" @click="copyUrl()"
            >复制</el-button
          >
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- open_box2 -->
      <audio controls ref="notify" class="audio" style="display: none" preload="auto">
        <!-- <source src="../assets/audio/box3-9-11.mp3" /> -->
        <source src="../assets/audio/open_box_scroll.7134f.mp3" />
      </audio>

      <audio controls ref="notify1" class="audio" style="display: none" preload="auto">
        <source src="../assets/audio/14131.mp3" />
      </audio>

      <audio controls ref="targetPrizeBase" class="audio" style="display: none" preload="auto">
        <source src="../assets/audio/hp-win-case.mp3" />
      </audio>

      <audio controls ref="targetPrizeProfit" class="audio" style="display: none" preload="auto">
        <source src="../assets/audio/hp-win-profit.mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
import myslide from "@/components/my_slide_page.vue";
import mywin from "@/components/my_win.vue";
import Utils from "../assets/js/util.js";
import { OPENBOX_ONLY_LAUNCH } from "@/config";
export default {
  components: {
    myslide,
    mywin,
  },
  computed: {
    isNewUser() {
      return this.$route.query.box_id == "62";
    },
    targetOpenPrice() {
      const value = Number(this.targetCase.price) * this.targetAmount;
      return Number.isInteger(value) ? String(value) : value.toFixed(2);
    },
    targetConsumeCount() {
      return Number(this.targetCase.specialKeyCost || 0) * this.targetAmount;
    },
    targetReelStride() {
      return this.targetReelCardWidth + this.targetReelCardGap + 2;
    },
    targetReelStartOffset() {
      return this.targetReelStartItem * this.targetReelStride;
    },
    caseListPath() {
      return this.targetCase.consumeCurrency === "cheese" || this.$route.query.from === "cheese" ? "/Cheese" : "/Index";
    },
    targetOpenActionLabel() {
      if (this.targetCase.consumeCurrency === "cheese") {
        return `打开箱子 ${this.targetOpenPrice}`;
      }
      if (this.targetCase.consumeCurrency === "key") {
        return `使用 ${this.targetCase.specialKeyName || "钥匙"} x${this.targetConsumeCount}`;
      }
      return `打开箱子 ${this.targetOpenPrice}`;
    },
    targetFastOpenActionLabel() {
      if (this.targetCase.consumeCurrency === "cheese") {
        return `快速打开箱子 ${this.targetOpenPrice}`;
      }
      if (this.targetCase.consumeCurrency === "key") {
        return `快速使用 ${this.targetCase.specialKeyName || "钥匙"} x${this.targetConsumeCount}`;
      }
      return `快速打开箱子 ${this.targetOpenPrice}`;
    },
  },
  props: ["showNav"],
  data() {
    return {
      hotPizzaGradeImages: {
        1: require("../assets/hotpizza/grade-1.png"),
        2: require("../assets/hotpizza/grade-2.png"),
        3: require("../assets/hotpizza/grade-3.png"),
        4: require("../assets/hotpizza/grade-4.png"),
        5: require("../assets/hotpizza/grade-5.png"),
        6: require("../assets/hotpizza/grade-6.png"),
        7: require("../assets/hotpizza/grade-7.png"),
      },
      openboxOnly: OPENBOX_ONLY_LAUNCH,
      cheeseIcon: require("../assets/pizzaking/cheese-token.svg"),
      openPhone: true,
      img: "",
      img1: require("../assets/img/1mdpi.png"),
      cartState: false,
      skin_list1: [],
      winBoxState: false,
      loading: false,
      url: window.location.href,
      dialogFormVisible: false,
      funState: true,
      winState: false,
      openBoxState: false,
      box_id: this.$route.query.box_id,
      box_name: "",
      box_obj: {},
      price: 0,
      totalPrice: 0,
      skin_list: [],
      skins_types: [],
      targetCase: {
        name: "加载中",
        price: "0",
        img: require("../assets/hotpizza/hp-case-green.png"),
        effect: "",
        fallback: require("../assets/hotpizza/hp-case-green.png"),
        consumeCurrency: "pizza",
        specialKeyName: "",
        specialKeyCost: 0,
        hasHiddenReward: false,
      },
      targetBattles: [],
      targetBattleTimer: null,
      targetAmounts: [1, 2, 3, 4, 5, 10],
      targetAmount: 1,
      targetOpening: false,
      targetFast: false,
      targetFinished: false,
      targetSpinKey: 0,
      targetOpenTimer: null,
      targetSpinTickTimer: null,
      targetSpinFrame: null,
      targetSpinLastX: null,
      targetTickCursor: 0,
      targetReelCardWidth: 140,
      targetReelCardGap: 8,
      targetReelPointerPadding: 7,
      targetReelItemCount: 90,
      targetReelStartItem: 32,
      targetCaseDropKey: 0,
      targetCaseDropping: false,
      targetWinnerIndex: 74,
      targetWinner: null,
      targetOpeningResults: [],
      targetReelItems: [],
      targetReelRows: [],
      targetReelNeighborSignatures: {},
      targetTodayBest: [],
      targetRecentDrops: [],
      targetCaseUnavailable: false,
      targetCaseLoading: true,
      defaultAvatar: require("../assets/img/jiapeople.png"),
      targetSkins: [
        {
          name: "AK-47 | Leet Museo (Factory New)",
          price: "700.78",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0920h5SZlvTgDLfYkWNF18lwmO7Eu4-ljVe1-RI-YzqmcYTGdAY6aFmC8wO4xe3qjcC7vsyczXFqsnUl7S7D30vgp4yMCZE",
        },
        {
          name: "StatTrak™ AK-47 | The Empress (Factory New)",
          price: "463.74",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV09m7hJKOhOTLP7LWnn8f7p0gjrnDpdvxi1Xn80JqYGygLI_DdQJsMgyC_AO4xb_p0ce66ZXImmwj5Hei5N5mVw",
        },
        {
          name: "StatTrak™ Desert Eagle | Ocean Drive (Factory New)",
          price: "456.41",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposr-kLAtl7PDdTjlH7du6kb-AnuP3O4Tdn2xZ_Pp9i_vG8MKljFLtqUZuZ2-nJoGSegBsZVnT_FW8l-u51p-5tcvKziZrsikgtnyMgVXp1v8LytPO",
        },
        {
          name: "StatTrak™ AK-47 | Bloodsport (Factory New)",
          price: "444.41",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0966m4-PhOf7Ia_ummJW4NE_3rnHpdujjgK28kE5Y2Gid9WWdQ44YVHS-VS9wr--jJG6tJrAzCBh6D5iuyjdE47G3Q",
        },
        {
          name: "StatTrak™ AK-47 | Bloodsport (Minimal Wear)",
          price: "416.44",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0966m4-PhOf7Ia_ummJW4NE_3rnHpdujjgK28kE5Y2Gid9WWdQ44YVHS-VS9wr--jJG6tJrAzCBh6D5iuyjdE47G3Q",
        },
        {
          name: "StatTrak™ AK-47 | Leet Museo (Factory New)",
          price: "414.43",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0920h5SZlvTgDLfYkWNF18lwmO7Eu4-ljVe1-RI-YzqmcYTGdAY6aFmC8wO4xe3qjcC7vsyczXFqsnUl7S7D30vgp4yMCZE",
        },
        {
          name: "Desert Eagle | Ocean Drive (Factory New)",
          price: "385.34",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgposr-kLAtl7PDdTjlH7du6kb-AnuP3O4Tdn2xZ_Pp9i_vG8MKljFLtqUZuZ2-nJoGSegBsZVnT_FW8l-u51p-5tcvKziZrsikgtnyMgVXp1v8LytPO",
        },
        {
          name: "AK-47 | The Empress (Factory New)",
          price: "345.91",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV09m7hJKOhOTLP7LWnn8f7p0gjrnDpdvxi1Xn80JqYGygLI_DdQJsMgyC_AO4xb_p0ce66ZXImmwj5Hei5N5mVw",
        },
        {
          name: "StatTrak™ P90 | Asiimov (Factory New)",
          price: "336.82",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopuP1FAR17OORIXBD_9W_mY-dqPv9NLPF2DtS6ZJ33e_Cpd-niw3sqEY_MGzzItXGJlM3YwrT-QS7ye3p1J7ttJXXiSw09F9GDzA",
        },
        {
          name: "P90 | Asiimov (Factory New)",
          price: "304.21",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpopuP1FAR17OORIXBD_9W_mY-dqPv9NLPF2DtS6ZJ33e_Cpd-niw3sqEY_MGzzItXGJlM3YwrT-QS7ye3p1J7ttJXXiSw09F9GDzA",
        },
        {
          name: "StatTrak™ AK-47 | Bloodsport (Well-Worn)",
          price: "286.32",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0966m4-PhOf7Ia_um25V4dB8xO3Hpdn22lWxqUc9Zmr0J9XBIw89M1GGqFC8ybzvgMLvvJ6azSE1viM8pSGK5KY2J5A",
        },
        {
          name: "StatTrak™ AK-47 | Bloodsport (Field-Tested)",
          price: "286.20",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpot7HxfDhnwMzJemkV0966m4-PhOf7Ia_um25V4dB8xO3Hpdn22lWxqUc9Zmr0J9XBIw89M1GGqFC8ybzvgMLvvJ6azSE1viM8pSGK5KY2J5A",
        },
      ],
      targetContractDrops: [
        {
          name: "Butterfly Knife | Doppler Black Pearl (Factory New)",
          price: "16606.35",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0ebcZThQ6tCvq4GGqPX4Mrjahm5Q-slOh-jT94DwgU6xryw-DDWqc97RbA9vN1GD8gO2ybq7hsK9tZ_By3ZqsiJw7X3elxzj1xpPb7c506GZSVmAR_selHmOwYo",
        },
        {
          name: "Butterfly Knife | Doppler Ruby (Factory New)",
          price: "15210.18",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0ebcZThQ6tCvq4GGqOXhMaLum2pD6sl0g_PE8bP5gVO8v11kYjjzJ9KcIFI5YliDqAXoxbrsgpC9up_BmCM17nYh4SndzRLl1xwdcKUx0pRZROip",
        },
        {
          name: "Butterfly Knife | Gamma Doppler Emerald (Factory New)",
          price: "14782.44",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0ebcZThQ6tCvq4GGqPL5NqnQmm9u5cRjiOXE_JbwjGu4ohQ0J3f6JtPEegNrMwvUrwe6kLjsjcPtuJXJmnFguCMn5i7enkDkiRFIabM7m7XAHtBCTvK7",
        },
        {
          name: "Butterfly Knife | Doppler Sapphire (Factory New)",
          price: "13501.90",
          icon: "-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0ebcZThQ6tCvq4GGqOT1I6vZn3lU18hwmOvN8IXvjVCLqSwwOj6rYJiRdg42NAuE-lW5kri5hpbuvM7AzHtmsnMh4imPzUa3gB4aaOw9hfCeVxzAUJ5TOTzr",
        },
      ],
      value: true,
      kaiBox: 1,
      kaiBox1: 1,
      kaiBoxNum: [
        {
          num: 1,
          state: true,
        },
        {
          num: 2,
          state: false,
        },
        {
          num: 3,
          state: false,
        },
        {
          num: 4,
          state: false,
        },
        {
          num: 5,
          state: false,
        },
      ],
      winList: [],
      listBox: [],
      imgList: [],
      imgList1: [],
      loadFlag: true, // 页面加载Loading标识

      active_type: 0,
    };
  },
  watch: {
    kaiBox(val) {
      let _this = this;
      _this.totalPrice = (this.price * val).toFixed(2);
    },
    skin_list: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.caculateCardHeight();
          });
        }
      },
      deep: true,
    },
    skin_list1: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.caculateCardHeight();
          });
        }
      },
      deep: true,
    },
  },

  methods: {
    caseDisplayName(value) {
      const labels = {
        "Baby Bus": "婴儿巴士",
        Carnival: "狂欢嘉年华",
        "High end zone": "高端专区",
        "sniper god": "狙击之神",
        "Close call": "险中求胜",
        "Dream Chasing": "追逐梦想",
      };
      return labels[value] || value;
    },
    steamImage(icon, size) {
      return "https://steamcommunity-a.akamaihd.net/economy/image/" + icon + "/" + size + "fx" + size + "f";
    },
    normalizeAssetUrl(url) {
      return String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
    },
    caseImageUrl(url, fallback) {
      const image = this.normalizeAssetUrl(url);
      if (image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) {
        return fallback;
      }
      return image;
    },
    mapBackendSkin(item) {
      return {
        id: item.id,
        itemId: item.itemId || item.item_id,
        name: item.name,
        price: item.price,
        img: this.normalizeAssetUrl(item.img),
        background: this.normalizeAssetUrl(item.background),
        type_id: item.type_id,
        order: item.order,
        color_bg: item.type_id || item.order || 6,
        color: item.color,
        chance: item.probability_display,
        exterior: item.exteriorName,
        quality: item.quality,
        qualityName: item.qualityName,
        qualityColor: item.qualityColor,
        is_hidden_gold: Number(item.is_hidden_gold || 0) === 1,
        reveal_hidden_gold: Number(item.reveal_hidden_gold || 0) === 1,
      };
    },
    loadTargetCaseData() {
      const param = { box_id: this.box_id };
      this.$axios.post("/index/Box/boxInfo", this.$qs.stringify(param)).then((res) => {
        if (res.data.status != 1 || !res.data.data) {
          this.markTargetCaseUnavailable();
          return;
        }
        this.targetCaseUnavailable = false;
        this.targetCaseLoading = false;
        const data = res.data.data;
        const skins = data.box_skins.map((item) => this.mapBackendSkin(item));

        this.box_obj = data;
        this.box_name = data.name;
        this.price = data.price;
        this.totalPrice = data.price;
        this.skin_list = data.box_skins;
        this.skins_types = data.skins_types;
        const caseFallback = require("../assets/hotpizza/hp-case-green.png");
        const cleanCaseImages = {
          211: require("../assets/hotpizza/case-211-main-clean.png"),
        };
        this.targetCase = {
          name: data.name,
          price: String(data.price),
          img: cleanCaseImages[Number(data.id)] || this.caseImageUrl(data.img_main || data.img_active, caseFallback),
          effect: this.caseImageUrl(data.img_active, ""),
          fallback: caseFallback,
          consumeCurrency: data.consume_currency || "pizza",
          specialKeyName: data.special_key ? data.special_key.name : "",
          specialKeyCost: Number(data.special_key_cost || 0),
          hasHiddenReward: Number(data.has_hidden_gold || 0) === 1,
        };
        this.targetSkins = this.sortTargetItems(skins);
        this.targetContractDrops = skins
          .slice()
          .sort((left, right) => Number(right.price) - Number(left.price))
          .slice(0, 6);
        this.loadTargetCaseDrops();
        this.targetCaseDropKey += 1;
        this.startTargetCaseDrop();
        this.refreshTargetReels();
      }).catch(() => {
        this.markTargetCaseUnavailable();
      });
    },
    loadTargetBattles() {
      this.$axios.post("/index/Battle/battleList", this.$qs.stringify({ page: 1, pageSize: 8 })).then((res) => {
        if (res.data.status != 1 || !res.data.data || !res.data.data.battleList) return;
        this.targetBattles = res.data.data.battleList.slice(0, 3).map((battle) => {
          const boxes = battle.boxInfo || [];
          const cases = boxes.reduce((list, item) => {
            const key = item.id || item.box_id || item.name;
            const existing = list.find((entry) => entry.key === key);
            if (existing) {
              existing.count += 1;
            } else {
              list.push({ key, count: 1 });
            }
            return list;
          }, []).map((item) => `x${item.count}`);
          const price = boxes.reduce((total, item) => total + Number(item.price || 0), 0).toFixed(2);
          const playerCount = (battle.player_info || []).filter((item) => item && item.id).length;
          return {
            id: battle.id,
            players: `${playerCount}/${battle.mode || 2}`,
            rounds: battle.status == 3 ? "已结束" : boxes.length,
            price,
            cases,
          };
        });
      });
    },
    sortTargetItems(items) {
      return items.slice().sort((left, right) => {
        const priceCompare = Number(right.price || 0) - Number(left.price || 0);
        if (priceCompare !== 0) return priceCompare;
        return String(left.name || "").localeCompare(String(right.name || ""));
      });
    },
    targetSlug(name) {
      return this.plainName(name).replace(/\s*\([^)]*\)\s*$/, "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
    },
    targetImage(item, size) {
      if (item.img) {
        return this.normalizeAssetUrl(item.img);
      }
      return this.steamImage(item.icon, size);
    },
    gradeNumber(item) {
      const gradeByColor = {
        "#F8F8FF": 1,
        "#B0C4DE": 2,
        "#87CEEB": 2,
        "#4169E1": 3,
        "#6495ED": 3,
        "#9370DB": 4,
        "#DA70D6": 4,
        "#FF1493": 5,
        "#FF69B4": 5,
        "#DC143C": 6,
        "#FF4500": 6,
        "#FFA500": 7,
        "#FFD700": 7,
      };
      const colorGrade = gradeByColor[String(item.color || "").toUpperCase()];
      if (colorGrade) return colorGrade;
      const gradeByType = { 1: 7, 5: 6, 4: 4, 6: 3, 7: 1 };
      const typeGrade = gradeByType[Number(item.type_id || item.color_bg)];
      if (typeGrade) return typeGrade;
      const numericGrade = Number(item.order);
      return numericGrade >= 1 && numericGrade <= 7 ? numericGrade : 1;
    },
    gradeImage(item) {
      const backendBackground = this.normalizeAssetUrl(
        item.background || (item.imageUrl ? item.img : "")
      );
      return backendBackground || this.hotPizzaGradeImages[this.gradeNumber(item)];
    },
    rarityClass(item) {
      return "pk-grade-" + this.gradeNumber(item);
    },
    fallbackImage(item) {
      const name = item.name;
      if (name.indexOf("Butterfly Knife") !== -1) {
        if (name.indexOf("Ruby") !== -1) {
          return require("../assets/hotpizza/hp-knife-ruby.png");
        }
        if (name.indexOf("Emerald") !== -1) {
          return require("../assets/hotpizza/hp-knife-emerald.png");
        }
        if (name.indexOf("Sapphire") !== -1) {
          return require("../assets/hotpizza/hp-knife-sapphire.png");
        }
        return require("../assets/hotpizza/hp-knife-black-pearl.png");
      }
      if (name.indexOf("Desert Eagle") !== -1) {
        return require("../assets/hotpizza/hp-m4-cyan.png");
      }
      if (name.indexOf("P90") !== -1) {
        return require("../assets/hotpizza/hp-mp9-red.png");
      }
      if (name.indexOf("Bloodsport") !== -1) {
        return require("../assets/hotpizza/hp-awp-fire.png");
      }
      return require("../assets/hotpizza/hp-ak-green.png");
    },
    replaceBrokenImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    hideBrokenImage(event) {
      event.target.style.display = "none";
    },
    targetChance(item) {
      if (item.chance === undefined || item.chance === null || item.chance === "") {
        return "--";
      }
      return Number(item.chance).toFixed(6).replace(/\.?0+$/, "") + "%";
    },
    plainName(name) {
      return String(name)
        .replace(/^★?\s*StatTrak™\s*/i, "")
        .replace(/\s*[（(]\s*★?\s*StatTrak™\s*[）)]/gi, "");
    },
    isStatTrak(name) {
      return /StatTrak™/i.test(String(name));
    },
    isDarkGold(item) {
      const quality = [item.qualityName, item.quality, item.name].filter(Boolean).join(" ");
      return /暗金|StatTrak™/i.test(quality);
    },
    weaponName(name) {
      return this.plainName(name).split("|")[0].trim();
    },
    skinName(name) {
      const parts = this.plainName(name).split("|");
      return (parts[1] || parts[0]).replace(/\s*\([^)]*\)\s*$/, "").trim();
    },
    exteriorName(name) {
      const match = String(name).match(/\(([^)]+)\)$/);
      return match ? match[1] : "";
    },
    targetExterior(item) {
      return item.exterior || this.exteriorName(item.name);
    },
    compactName(name) {
      return this.skinName(name);
    },
    targetPrice(price) {
      return Number(price).toFixed(2);
    },
    targetCardPrice(item) {
      return item && item.is_hidden_gold ? "???" : this.targetPrice(item.price);
    },
    targetDropImage(item) {
      return this.normalizeAssetUrl(item.imageUrl || item.img);
    },
    dropFallback(item) {
      return this.fallbackImage({ name: item.skin_name || item.name || "" });
    },
    loadTargetCaseDrops() {
      const request = (mode) =>
        this.$axios.post(
          "/index/Box/caseDrops",
          this.$qs.stringify({ box_id: this.box_id, mode, pageSize: 20 })
        );

      request("best").then((res) => {
        if (res.data.status === 1) {
          this.targetTodayBest = res.data.data.list;
        }
      });
      request("recent").then((res) => {
        if (res.data.status === 1) {
          this.targetRecentDrops = res.data.data.list;
        }
      });
    },
    startTargetCaseDrop() {
      this.targetCaseDropping = false;
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.targetCaseDropping = true;
        }, 220);
      });
    },
    selectTargetAmount(amount) {
      this.targetAmount = amount;
      this.kaiBox = amount;
      this.targetFinished = false;
      this.targetOpeningResults = [];
      this.targetSpinKey += 1;
      this.refreshTargetReels();
    },
    targetSkinKey(skin) {
      if (!skin) return "";
      return String(skin.id || skin.itemId || skin.item_id || skin.name || skin.img || "");
    },
    targetReelItem(item) {
      if (item && item.reveal_hidden_gold) return item;
      const itemId = String(item.id || item.itemId || item.item_id || "");
      const itemName = String(item.name || "");
      const itemImage = this.normalizeAssetUrl(item.img);
      return this.targetSkins.find((skin) => {
        const skinId = String(skin.id || skin.itemId || skin.item_id || "");
        return (itemId && skinId === itemId) || (!itemId && skin.name === itemName && skin.img === itemImage);
      }) || item;
    },
    isMaskedHiddenGold(item) {
      const targetItem = this.targetReelItem(item);
      return targetItem.is_hidden_gold && !targetItem.reveal_hidden_gold;
    },
    targetRarityStyle(item) {
      return item.color ? { "--pk-grade-glow": `${item.color}3d` } : {};
    },
    targetReelCardStyle(item) {
      const targetItem = this.targetReelItem(item);
      return Object.assign({}, this.targetRarityStyle(targetItem), {
        "--pk-target-grade-image": this.isMaskedHiddenGold(targetItem) ? "none" : `url(${this.gradeImage(targetItem)})`,
      });
    },
    randomTargetSkin(excludedKeys) {
      const excluded = excludedKeys || [];
      const candidates = this.targetSkins.filter((skin) => !excluded.includes(this.targetSkinKey(skin)));
      const pool = candidates.length ? candidates : this.targetSkins;
      return pool[Math.floor(Math.random() * pool.length)];
    },
    buildTargetReelItems(rowIndex) {
      if (!this.targetSkins.length) return [];
      const list = [];
      let previousKey = "";
      for (let index = 0; index < this.targetReelItemCount; index += 1) {
        const skin = this.randomTargetSkin(previousKey ? [previousKey] : []);
        list.push(skin);
        previousKey = this.targetSkinKey(skin);
      }

      const winner = this.targetOpeningResults[rowIndex] || this.randomTargetSkin([]);
      const winnerKey = this.targetSkinKey(winner);
      list[this.targetWinnerIndex] = winner;

      if (this.targetSkins.length > 1) {
        let left = null;
        let right = null;
        let signature = "";
        const previousSignature = this.targetReelNeighborSignatures[rowIndex] || "";
        for (let attempt = 0; attempt < 20; attempt += 1) {
          left = this.randomTargetSkin([winnerKey]);
          const leftKey = this.targetSkinKey(left);
          right = this.randomTargetSkin([winnerKey, leftKey]);
          signature = `${leftKey}|${this.targetSkinKey(right)}`;
          if (signature !== previousSignature) break;
        }
        list[this.targetWinnerIndex - 1] = left;
        list[this.targetWinnerIndex + 1] = right;
        this.$set(this.targetReelNeighborSignatures, rowIndex, signature);
      }
      return list;
    },
    markTargetCaseUnavailable() {
      this.targetCaseUnavailable = true;
      this.targetCaseLoading = false;
      this.targetSkins = [];
      this.targetContractDrops = [];
      this.targetTodayBest = [];
      this.targetRecentDrops = [];
      this.targetReelRows = [];
      this.targetReelItems = [];
    },
    targetReelLayout(rowIndex) {
      if (this.targetAmount === 5) {
        return rowIndex === 2 ? "full" : "half";
      }
      if (this.targetAmount === 10) {
        return "half";
      }
      return "full";
    },
    buildTargetReelRows() {
      const rows = [];
      const cardWidth = this.targetReelCardWidth + 2;
      const stride = this.targetReelStride;
      const trackWidth = cardWidth * this.targetReelItemCount +
        this.targetReelCardGap * (this.targetReelItemCount - 1);
      for (let index = 0; index < this.targetAmount; index += 1) {
        const layout = this.targetReelLayout(index);
        const winnerPoint = Math.round(
          this.targetReelPointerPadding +
          (cardWidth - this.targetReelPointerPadding * 2) *
          (0.42 + (index % 3) * 0.08)
        );
        rows.push({
          id: index + 1,
          layout,
          endOffset: Math.round(trackWidth / 2 - (this.targetWinnerIndex * stride + winnerPoint)),
          winnerIndex: this.targetWinnerIndex,
          items: this.buildTargetReelItems(index),
        });
      }
      return rows;
    },
    refreshTargetReels() {
      this.targetReelRows = this.buildTargetReelRows();
      this.targetReelItems = this.targetReelRows[0].items;
      this.targetWinner = this.targetReelItems[this.targetWinnerIndex];
    },
    updateTargetReelMetrics() {
      const width = window.innerWidth;
      const metrics = width > 1920 ? [198, 10, 12] : width > 1470 ? [177, 8, 9] : [140, 8, 7];
      this.targetReelCardWidth = metrics[0];
      this.targetReelCardGap = metrics[1];
      this.targetReelPointerPadding = metrics[2];
      this.targetReelItemCount = width <= 600 ? 36 : 90;
      this.targetWinnerIndex = width <= 600 ? 28 : 74;
      this.targetReelStartItem = width <= 600 ? 8 : 32;
      if (!this.targetOpening) this.refreshTargetReels();
    },
    applyTargetOpenResult(data) {
      this.winList = data;
      this.targetOpeningResults = data.skins_info.map((item) => this.targetReelItem(this.mapBackendSkin(item)));
      this.loadTargetCaseDrops();
      this.$root.$emit("live-drop-refresh");
      this.$root.$emit("box-count-refresh", { box_id: this.box_id, count: this.targetAmount });
      this.$store.commit("getMoney", Number(data.total_amount).toFixed(2));
      Utils.$emit("money", data.total_amount);
      if (data.cheese_coin !== undefined) {
        this.$store.commit("getCheese", Number(data.cheese_coin).toFixed(2));
        Utils.$emit("cheese", data.cheese_coin);
      }
      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      userInfo.total_amount = data.total_amount;
      if (data.cheese_coin !== undefined) {
        userInfo.cheese_coin = data.cheese_coin;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    startTargetOpen(fast) {
      if (!this.$store.state.token) {
        this.$store.commit("getLogin", true);
        return;
      }
      if (this.loading || this.targetOpening) return;
      if (this.targetCaseLoading || this.targetCaseUnavailable || !this.targetSkins.length) {
        this.$message.warning("箱子数据尚未准备完成，请稍后重试");
        return;
      }
      this.targetFast = fast;
      this.stopTargetSpinTicks();
      this.stopTargetPrizeSounds();
      this.playAlarmStop();
      this.playAlarm2();
      this.targetOpening = false;
      this.targetFinished = false;
      this.winState = false;
      this.loading = true;
      this.kaiBox = this.targetAmount;
      const param = {
        box_id: this.box_id,
        num: this.targetAmount,
        cartState: this.cartState,
      };
      this.$axios
        .post("/index/Box/buyBox", this.$qs.stringify(param))
        .then((res) => {
          const data = res.data;
          this.loading = false;
          if (data.status != 1) {
            this.$message({ message: data.msg || "打开箱子失败，请稍后重试", type: "warning" });
            return;
          }
          this.applyTargetOpenResult(data.data);
          this.targetSpinKey += 1;
          this.refreshTargetReels();
          this.$nextTick(() => {
            if (fast) {
              this.targetOpening = false;
              this.targetFinished = true;
              this.targetWinner = this.targetReelItems[this.targetWinnerIndex];
              this.winState = true;
              this.playTargetPrizeSound();
              return;
            }
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                this.targetOpening = true;
                this.startTargetSpinTicks();
                window.clearTimeout(this.targetOpenTimer);
                this.targetOpenTimer = window.setTimeout(() => {
                  this.stopTargetSpinTicks();
                  this.targetOpening = false;
                  this.targetFinished = true;
                  this.targetWinner = this.targetReelItems[this.targetWinnerIndex];
                  this.winState = true;
                  this.playTargetPrizeSound();
                }, 5500);
              });
            });
          });
        })
        .catch(() => {
          this.loading = false;
          this.targetOpening = false;
          this.playAlarmStop();
          this.$message.error("网络异常，打开箱子请求未完成，请重试");
        });
    },
    refreshMoney() {
      this.$parent.selfLogin();
    },
    caculateCardHeight() {
      const els = document.querySelectorAll(".card");
      if (els[0]) {
        const width = window.getComputedStyle(els[0]).getPropertyValue("width");
        els.forEach((el) => {
          el.style.height = (238 / 154) * width.split("px")[0] + "px";
        });
      }
    },
    //请求背景图片
    getBack() {
      let _this = this;
      _this.$axios.post("/index/Setting/background").then((res) => {
        if (res.data.status == 1) {
          this.img = res.data.data.img;
          if (!this.img) {
            this.img = this.img1;
          }
        }
      });
    },
    //音乐 过程
    playAlarm(durationMs = 6880) {
      this.$refs.notify.currentTime = 0;
      this.$refs.notify.playbackRate = 6880 / durationMs;
      this.$refs.notify.play();
    },
    //音乐 过程关闭
    playAlarmStop() {
      this.$refs.notify.pause();
      this.$refs.notify.currentTime = 0;
    },
    //音乐 结果
    playAlarm1() {
      this.$refs.notify1.currentTime = 0;
      this.$refs.notify1.play();
    },
    //音乐 结果暂停
    playAlarm2() {
      this.$refs.notify1.pause();
      this.$refs.notify1.currentTime = 0;
    },
    startTargetSpinTicks() {
      this.stopTargetSpinTicks();
      this.targetTickCursor = 0;
      this.targetSpinLastX = null;
      this.targetSpinTickTimer = window.setTimeout(() => {
        const update = () => {
          const track = this.$el.querySelector(".pk-target-reel-track.spinning");
          if (!track || !this.targetOpening) return;
          const transform = window.getComputedStyle(track).transform;
          const currentX = transform && transform !== "none" ? new DOMMatrixReadOnly(transform).m41 : 0;
          const stride = this.targetReelStride;
          if (this.targetSpinLastX === null) this.targetSpinLastX = currentX;
          while (currentX <= this.targetSpinLastX - stride) {
            this.playTargetTick();
            this.targetSpinLastX -= stride;
          }
          this.targetSpinFrame = window.requestAnimationFrame(update);
        };
        this.targetSpinFrame = window.requestAnimationFrame(update);
      }, 100);
    },
    stopTargetSpinTicks() {
      window.clearTimeout(this.targetSpinTickTimer);
      window.cancelAnimationFrame(this.targetSpinFrame);
      this.targetSpinTickTimer = null;
      this.targetSpinFrame = null;
      this.targetSpinLastX = null;
      (this._targetTickPool || []).forEach((sound) => {
        sound.pause();
        sound.currentTime = 0;
      });
    },
    playTargetTick() {
      const pool = this._targetTickPool;
      const sound = pool[this.targetTickCursor % pool.length];
      const enabled = localStorage.getItem("pizzaking-sound-enabled") !== "0";
      if (!enabled) return;
      sound.pause();
      sound.volume = Number(localStorage.getItem("pizzaking-sound-volume") || 50) / 100;
      sound.currentTime = 0;
      const playback = sound.play();
      if (playback) playback.catch(() => {});
      this.targetTickCursor += 1;
    },
    playTargetPrizeSound() {
      if (localStorage.getItem("pizzaking-sound-enabled") === "0") return;
      const prizeTotal = this.targetOpeningResults.reduce((total, item) => total + Number(item.price || 0), 0);
      const cost = Number(this.targetCase.price || 0) * this.targetAmount;
      const sound = cost >= prizeTotal ? this.$refs.targetPrizeBase : this.$refs.targetPrizeProfit;
      sound.pause();
      sound.volume = Number(localStorage.getItem("pizzaking-sound-volume") || 50) / 100;
      sound.currentTime = 0;
      const playback = sound.play();
      if (playback) playback.catch(() => {});
    },
    stopTargetPrizeSounds() {
      [this.$refs.targetPrizeBase, this.$refs.targetPrizeProfit].forEach((sound) => {
        sound.pause();
        sound.currentTime = 0;
      });
    },

    //点击包含以下皮肤
    getBoxOrn() {
      this.winBoxState = false;
      //this.getBoxInfo();
      let _this = this;
      let param = {
        box_id: _this.box_id,
      };
      _this.$axios
        .post("/index/Box/boxInfo", _this.$qs.stringify(param))
        .then((res) => {
          if (res.data && res.data.status == 1 && res.data.data) {
            _this.skin_list = res.data.data.box_skins;
          }
        });
    },
    //最近掉落
    getWinPeo() {
      this.winBoxState = true;
      let param = {
        page: 1,
        pageSize: 20,
        box_id: this.box_id,
        type: this.active_type,
      };
      this.$axios
        .post("/index/Box/lately", this.$qs.stringify(param))
        .then((res) => {
          let data = res.data;
          // console.log(data);
          if (data.status == 1) {
            this.skin_list1 = data.data.list;
          }
        });
    },
    //分享复制
    copyUrl() {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = window.location.href; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
      this.dialogFormVisible = false;
    },
    //盲盒信息
    getBoxInfo(id) {
      let _this = this;
      let param = {
        box_id: id ? id : _this.box_id,
      };
      _this.$axios
        .post("/index/Box/boxInfo", _this.$qs.stringify(param))
        .then((res) => {
          if (res.data && res.data.status == 1 && res.data.data) {
            //  console.log(res.data);
            this.loadFlag = false;
            this.box_obj = res.data.data;
            _this.box_name = res.data.data.name;
            _this.price = _this.totalPrice = res.data.data.price;
            _this.skin_list = res.data.data.box_skins;
            _this.skins_types = res.data.data.skins_types;
          }
        });
    },
    //购买盲盒
    buyBox() {
      this.loading = true;
      let _this = this;
      let param = {
        box_id: _this.$route.query.box_id,
        num: _this.kaiBox,

        cartState: this.cartState,
      };
      _this.$axios
        .post("/index/Box/buyBox", _this.$qs.stringify(param))
        .then((res) => {
          if (res.data.status == 1) {
            //console.log(res.data);
            this.$store.commit(
              "getMoney",
              Number(res.data.data.total_amount).toFixed(2)
            );
            console.log(res.data.data.total_amount, "钱");
            Utils.$emit("money", res.data.data.total_amount);
            //let player_box_skin_id = res.data.data.player_box_skin_id;
            let imgCopy = JSON.parse(JSON.stringify(this.skin_list));
            if (!this.cartState) {
              this.playAlarm(); // 播放音乐
            }
            if (this.kaiBox == 1) {
              let imgCopy1 = [];
              for (let i = 0; i < Math.floor(80 / imgCopy.length) + 1; i++) {
                for (let j = 0; j < imgCopy.length; j++) {
                  imgCopy1.push(imgCopy[j]);
                }
              }
              imgCopy1 = imgCopy1.slice(0, 80);
              imgCopy1 = this.getRandomArr(imgCopy1, 80);
              this.imgList = imgCopy1;
              // console.log(this.imgList.length);
            } else if (this.kaiBox == 2) {
              let imgCopy2 = [];
              for (let i = 0; i < this.kaiBox; i++) {
                this.imgList1.push(imgCopy);
              }
              for (
                let i = 0;
                i < Math.floor(100 / this.imgList1[0].length) + 1;
                i++
              ) {
                for (let j = 0; j < this.imgList1[0].length; j++) {
                  imgCopy2.push(this.imgList1[0][j]);
                }
              }
              imgCopy2 = imgCopy2.slice(0, 100);
              for (let i = 0; i < this.imgList1.length; i++) {
                this.imgList1[i] = imgCopy2;
                this.imgList1[i] = this.getRandomArr(this.imgList1[i], 100);
              }
            } else {
              let imgCopy2 = [];
              for (let i = 0; i < this.kaiBox; i++) {
                this.imgList1.push(imgCopy);
              }
              for (
                let i = 0;
                i < Math.floor(150 / this.imgList1[0].length) + 1;
                i++
              ) {
                for (let j = 0; j < this.imgList1[0].length; j++) {
                  imgCopy2.push(this.imgList1[0][j]);
                }
              }
              imgCopy2 = imgCopy2.slice(0, 150);
              for (let i = 0; i < this.imgList1.length; i++) {
                this.imgList1[i] = imgCopy2;
                this.imgList1[i] = this.getRandomArr(this.imgList1[i], 150);
              }
            }

            //开盲盒
            //_this.getBoxResult(player_box_skin_id);
            this.loading = false;
            this.$root.$emit("box-count-refresh", { box_id: this.box_id, count: this.kaiBox });
            if (res.data.data.skins_info.length == 1) {
              this.imgList[62] = res.data.data.skins_info[0];
              if (!this.showNav) {
                this.imgList[60] = res.data.data.skins_info[0];
              }
              _this.setStyle(1);
            } else if (res.data.data.skins_info.length == 2) {
              let data = res.data.data.skins_info;
              let imgListCopy = JSON.parse(JSON.stringify(this.imgList1));

              for (let i = 0; i < data.length; i++) {
                imgListCopy[i][42] = data[i];
                if (!this.showNav) {
                  imgListCopy[i][85] = data[i];
                }
              }
              this.imgList1 = imgListCopy;
              _this.setStyle(2);
            } else if (res.data.data.skins_info.length == 3) {
              let data = res.data.data.skins_info;
              let imgListCopy = JSON.parse(JSON.stringify(this.imgList1));

              for (let i = 0; i < data.length; i++) {
                imgListCopy[i][34] = data[i];
                if (!this.showNav) {
                  for (let z = 0; z < 81; z++) {
                    imgListCopy[i][80] = data[i];
                  }
                }
              }
              this.imgList1 = imgListCopy;
              var length = res.data.data.skins_info.length;
              _this.setStyle(3, length);
            } else if (res.data.data.skins_info.length == 4) {
              let data = res.data.data.skins_info;
              let imgListCopy = JSON.parse(JSON.stringify(this.imgList1));
              for (let i = 0; i < data.length; i++) {
                imgListCopy[i][41] = data[i];
                if (!this.showNav) {
                  imgListCopy[i][89] = data[i];
                }
              }
              this.imgList1 = imgListCopy;
              _this.setStyle(4, length);
            } else if (res.data.data.skins_info.length == 5) {
              let data = res.data.data.skins_info;
              let imgListCopy = JSON.parse(JSON.stringify(this.imgList1));

              for (let i = 0; i < data.length; i++) {
                imgListCopy[i][54] = data[i];
                if (!this.showNav) {
                  imgListCopy[i][123] = data[i];
                }
              }
              this.imgList1 = imgListCopy;
              _this.setStyle(5, length);
            }
            _this.winList = res.data.data;

            //是否开启动画
            if (this.cartState) {
              _this.winState = true;
              // this.playAlarmStop(); // 关闭音乐
              this.playAlarm1();
              // this.playAlarm();
            } else {
              _this.openBoxState = true;
              var length = res.data.data.skins_info.length;
              _this.setStyle("", length);
              setTimeout(() => {
                _this.openBoxState = false;
                _this.winState = true;
                this.imgList = [];
                this.imgList1 = [];
                // this.playAlarm(); 开启动画音乐
                // this.playAlarmStop(); // 关闭音乐
                // this.playAlarm1(); // 钱币音效
              }, 8000 + 200 * length);
              setTimeout(() => {
                this.playAlarmStop(); // 关闭音乐
              }, 6600 + 200 * length);
            }
          } else {
            this.loading = false;
            let msg = res.data.msg;
            if (msg.indexOf("当前余额不足") != -1) {
              this.$message({
                message: msg,
                type: "warning",
              });
              return;
            }
            if (msg == "玩家信息错误") {
              this.$message({
                message: "请先登录",
                type: "warning",
              });
              this.$store.commit("getLogin", true);
              return;
            }
            if (msg == "新用户仅限于新用户开箱/萌新开箱") {
              this.$message({
                message: msg,
                type: "warning",
              });
              return;
            }
            if (msg == "新注册用户仅限开箱一次") {
              this.$message({
                message: msg,
                type: "warning",
              });
              return;
            }
            if (msg == "当天仅限开箱一次") {
              this.$message({
                message: msg,
                type: "warning",
              });
              return;
            }
            if (msg == "购买失败，请联系客服") {
              this.$message("购买失败，请联系客服处理");
              return;
            }
            this.$message({
              message: msg,
              type: "warning",
            });
          }
        });
    },

    //开盒规则
    goOpenboxRule() {
      this.$router.push({
        path: `/OpenboxRule`,
      });
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    chooseNum(num) {
      // 默认只为一个 不做修改了
      this.kaiBox = num;

      for (let i = 0; i < this.kaiBoxNum.length; i++) {
        if (this.kaiBoxNum[i].num <= num) {
          this.kaiBoxNum[i].state = true;
        } else {
          this.kaiBoxNum[i].state = false;
        }
      }
    },
    //子组件修改父组件
    winexchange(msg) {
      this.winState = msg;
    },
    winget(msg) {
      this.winState = msg;
    },
    winX(msg) {
      this.winState = msg;
    },
    continueOpen() {
      this.winState = false;
      this.targetFinished = false;
      this.targetOpeningResults = [];
      this.targetSpinKey += 1;
      this.refreshTargetReels();
      this.startTargetCaseDrop();
    },
    setStyle(index, num) {
      let style = document.createElement("style");
      style.setAttribute("type", "text/css");
      document.head.appendChild(style);
      let sheet = style.sheet;
      console.log(index);
      if (index == 1) {
        // let random = Math.floor(Math.random() * 190) + 11905;
        let random = 12000;
        // console.log(random);
        sheet.insertRule(
          `@keyframes run` +
            index +
            `{
							0% {
							  left: 0;
							}
							100% {
							  left: -` +
            random +
            `px
							}
						}`,
          0
        );
      } else if (index == 2) {
        for (var i = 0; i < num; i++) {
          if (this.showNav) {
            var random = 8000;
            // var random = Math.floor(Math.random() * 190) + 9905;
          } else {
            //屏幕小于600的宽度
            var random = 4800;
            // var random = Math.floor(Math.random() * 90) + 5955;
          }
          console.log(random);
          sheet.insertRule(
            `@keyframes run-li` +
              i +
              `{
							  0% {
								left: 0;
							  }
							  100% {
								left: -` +
              random +
              `px
							  }
						  }`,
            0
          );
        }
      } else if (index == 3) {
        console.log(num);
        for (var i = 0; i < num; i++) {
          if (this.showNav) {
            var random = 12000;
            // var random = Math.floor(Math.random() * 190) + 9905;
          } else {
            //屏幕小于600的宽度
            var random = 6000;
            // var random = Math.floor(Math.random() * 90) + 5955;
          }
          console.log(random);
          sheet.insertRule(
            `@keyframes run-li` +
              i +
              `{
					        0% {
					          top: 0;
					        }
					        100% {
					          top: -` +
              random +
              `px
					        }
					    }`,
            0
          );
        }
      } else if (index == 4) {
        for (var i = 0; i < num; i++) {
          if (this.openPhone == true) {
            var random = 8000;
            // var random = Math.floor(Math.random() * 190) + 9905;
          } else {
            //屏幕小于600的宽度
            var random = 6000;
            // var random = Math.floor(Math.random() * 90) + 5955;
          }
          sheet.insertRule(
            `@keyframes run-li` +
              i +
              `{
					        0% {
					          top: 0;
					        }
					        100% {
					          top: -` +
              random +
              `px
					        }
					    }`,
            0
          );
        }
      } else if (index == 5) {
        for (var i = 0; i < num; i++) {
          if (this.openPhone == true) {
            var random = 6000;
            // var random = Math.floor(Math.random() * 190) + 9905;
          } else {
            //屏幕小于600的宽度
            var random = 6000;
            // var random = Math.floor(Math.random() * 90) + 5955;
          }
          sheet.insertRule(
            `@keyframes run-li` +
              i +
              `{
					        0% {
					          top: 0;
					        }
					        100% {
					          top: -` +
              random +
              `px
					        }
					    }`,
            0
          );
        }
      } else {
        for (var i = 0; i < num; i++) {
          if (this.openPhone == true) {
            var random = 6000;
            // var random = Math.floor(Math.random() * 190) + 9905;
          } else {
            //屏幕小于600的宽度
            var random = 6000;
            // var random = Math.floor(Math.random() * 90) + 5955;
          }
          sheet.insertRule(
            `@keyframes run-li` +
              i +
              `{
					        0% {
					          top: 0;
					        }
					        100% {
					          top: -` +
              random +
              `px
					        }
					    }`,
            0
          );
        }
      }
    },
  },
  mounted() {
    //判断屏幕宽度
    // console.log(document.body.clientWidth);
    this._targetTickPool = Array.from({ length: 8 }, () => {
      const sound = new Audio(require("../assets/audio/hp-case-spin.wav"));
      sound.preload = "auto";
      sound.load();
      return sound;
    });
    this.updateTargetReelMetrics();
    this.targetSkins = this.sortTargetItems(this.targetSkins);
    this.refreshTargetReels();
    this.loadTargetCaseData();
    if (!this.openboxOnly) {
      this.loadTargetBattles();
      this.targetBattleTimer = window.setInterval(this.loadTargetBattles, 15000);
    }
    this.startTargetCaseDrop();
    if (document.body.clientWidth < 600) {
      this.openPhone = false;
    }

    let _this = this;
    _this.getBoxInfo();
    _this.getBack();
    // _this.setStyle(5,5)

    //计算卡片高度
    this._targetResizeHandler = () => {
      this.caculateCardHeight();
      this.updateTargetReelMetrics();
    };
    window.addEventListener("resize", this._targetResizeHandler);
    let param = {
      page: 1,
      pageSize: 20,
      type: this.active_type,
      box_id: this.box_id,
    };
    this.$axios
      .post("/index/Box/lately", this.$qs.stringify(param))
      .then((res) => {
        let data = res.data;
        // console.log(data);
        if (data.status == 1) {
          this.skin_list1 = data.data.list;
      }
    });
  },
  beforeDestroy() {
    window.clearInterval(this.targetBattleTimer);
    window.clearTimeout(this.targetOpenTimer);
    window.removeEventListener("resize", this._targetResizeHandler);
    this.stopTargetSpinTicks();
    (this._targetTickPool || []).forEach((sound) => {
      sound.pause();
      sound.currentTime = 0;
    });
    this.playAlarmStop();
    this.playAlarm2();
    this.stopTargetPrizeSounds();
  },
};
</script>

<style lang="less" scoped>
::v-deep {
  .el-switch__label--left {
    margin-right: 20px;
    color: #fff !important;
  }

  .el-switch__core {
    background-color: #00888a;
    border: 1px solid #00888a;
    height: 14px;

    &:after {
      height: 28px;
      width: 28px;
      top: -8px;
      left: -10px;
      background-color: #09ebaf;
    }
  }

  .el-switch.is-checked .el-switch__core {
    border-color: #00888a;
    background-color: #00888a;
  }
}

@media screen and (max-width: 375px) {
  .boxlist-botm ul {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)) !important;
  }
}

.border-image {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 60px !important;
  height: 60px !important;
  transform: translate(-30px, -30px);
}
.filter-user-type {
  display: flex;
  border: 3px solid #ffc400;
  width: max-content;
  margin-top: 20px;
  span {
    display: block;
    padding: 10px 40px;
    color: #fff;
    border: 3px solid #ffc400;
    font-size: 20px;
    cursor: pointer;
  }
  .active_type {
    background-color: #ffc400;
    color: #000000;
    font-weight: bold;
  }
}
.fliter-tab {
  display: flex;
  padding: 20px 20px 20px 35px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  p {
    color: #fff;
    font-size: 1.6vw;
    width: 50%;
  }
  p:nth-child(1) {
    color: #fff;
  }
}
.drop-item {
  display: flex;
  // justify-content: space-between;
  background-color: #181c28;
  align-content: center;
  padding: 20px;
  width: 50%;
  .user {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0;
  }
  img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-right: 3px;
  }
  span:nth-child(2) {
    color: #fff;
  }
  span {
    color: #ffc400;
    font-size: 20px;
    // padding-left: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 20vw;
    display: flex;
  }
  p {
    color: #fff;
    display: flex;
    // justify-content: center;
    align-items: center;
    width: 50%;
  }
  .user-info {
    display: flex;
    position: relative;
    width: 50%;
    span {
      color: #fff;
      padding-left: 2px;
    }
  }
}
.drop-item:nth-child(2n) {
  background-color: #20222a;
}
.bax_num_bg {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.mySlide {
  padding-top: 19vw;
}
.openbox-page {
  background: url("../assets/95/header2.png") no-repeat;
  width: 100%;
  overflow: hidden;
  background-size: 100%;
  border-bottom: 0.16vw solid #ffc400;
}

.openbox {
  width: 100%;
  background-position: center 0;
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* 兼容Webkit内核浏览器如Chrome和Safari */
  padding-bottom: 35px;
  /* 兼容Opera */
  zoom: 1;
  overflow: hidden;
  overflow-y: auto;
  // background: url("../assets/new/openbox2.png");
  background: url("../assets/img/open-box/f685fe85d816fc917a7ff3ec0574c42.png");
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  // background-color: #000;
  // .mySlide{
  // 	margin-top: 25px;
  // }
  .switch-name {
    color: #848492;
    font-size: 16px;
    margin-right: 5px;
  }

  .switch2 {
    margin-right: 10px;
  }

  .audio {
    display: none;
  }

  .kai-box {
    position: relative;
    padding: 16px;
    // background-image: url("../assets/new/bg.png");
    // background-size: 600px auto;
    // background-repeat: no-repeat;
    // background-position: center 100px;
    .kai-share {
      float: right;
      color: #848492;
      font-size: 15px;
      font-weight: 600;
      padding: 9px 22px;
      background-color: #333542;
      border-radius: 5px;
    }
    .kai-share:hover {
      background-color: #3a3f50;
      cursor: pointer;
    }
  }

  //测试开盒子 单个
  .kai-box-open2 {
    position: absolute;
    padding-bottom: 500px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 106;

    .kai-warp11 {
      position: absolute;
      width: 1000px;
      height: 150px;
      top: 50%;
      left: 50%;
      margin-left: -500px;

      // background-color: #fff;
      // overflow: hidden;
      .kaibox-line {
        position: absolute;
        width: 8px;
        height: 210px;
        left: 50%;
        top: -30px;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 50%;
        left: 25%;
        top: -80px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        bottom: -80px;
        z-index: 99;
      }

      ul {
        position: absolute;
        left: 0;
        top: 0;
        width: 16000px;
        display: flex;
        flex-wrap: nowrap;
        z-index: 20;
        animation: run4 8s;
        animation-timing-function: cubic-bezier(
          0.4,
          0.89,
          0.63,
          1
        ); //动画慢 快 慢
        animation-iteration-count: 1; //播放几次动画
        animation-delay: 0s; //动画运行前等待时间
        animation-fill-mode: forwards; //动画结束 是否保持

        li {
          width: 200px;
          height: 150px;
          background-image: url("../assets/img/box-skins-null.jpg");
          background-size: 100% 100%;

          img {
            margin-left: 10%;
            margin-top: 10%;
            width: 80%;
            height: 80%;
          }
        }

        .li1 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .li2 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }
      }

      @keyframes run4 {
        0% {
          left: 0;
        }

        100% {
          left: -12000px;
        }
      }
    }
  }

  //测试开盒子 单个
  .kai-box-open2m {
    position: absolute;
    padding-bottom: 550px;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 106;

    .kai-warp11 {
      position: absolute;
      width: 1000px;
      height: 150px;
      top: 50%;
      left: 38%;
      margin-left: -500px;

      // background-color: #fff;
      // overflow: hidden;
      .kaibox-line {
        position: absolute;
        width: 8px;
        height: 100px;
        left: 54.4%;
        top: -10px;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 38.6%;
        left: 35%;
        top: -60px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 38.6%;
        left: 35%;
        bottom: 20px;
        transform: rotate(180deg);
      }

      ul {
        position: absolute;
        top: 0;
        width: 16000px;
        display: flex;
        flex-wrap: nowrap;
        z-index: 20;
        animation: run44 8s;
        animation-timing-function: cubic-bezier(
          0.4,
          0.89,
          0.63,
          1
        ); //动画慢 快 慢
        animation-iteration-count: 1; //播放几次动画
        animation-delay: 0s; //动画运行前等待时间
        animation-fill-mode: forwards; //动画结束 是否保持

        li {
          width: 100px;
          height: 75px;
          background-image: url("../assets/img/box-skins-null.jpg");
          background-size: 100% 100%;

          img {
            margin-left: 10%;
            margin-top: 10%;
            width: 80%;
            height: 80%;
          }
        }

        .li1 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .li2 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }
      }

      @keyframes run44 {
        0% {
          left: 0;
        }

        100% {
          left: -5500px;
        }
      }
    }
  }

  .kai-box-open22 {
    position: absolute;
    padding-bottom: 500px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 66;

    .kai-warp11 {
      position: absolute;
      width: 1000px;
      height: 150px;
      top: 50%;
      left: 50%;
      margin-left: -500px;

      // background-color: #fff;
      // overflow: hidden;
      .kaibox-line {
        position: absolute;
        width: 8px;
        height: 360px;
        left: 50%;
        top: -180px;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 50%;
        left: 25%;
        top: -220px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        bottom: -60px;
        z-index: 99;
      }

      .kaibox-warp2 {
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            margin-top: -150px;
          }

          .kaibox-li:nth-child(2) {
            animation-timing-function: cubic-bezier(
              0.4,
              0.95,
              0.76,
              1
            ) !important; //动画慢 快 慢
            // animation-delay: 0.25s !important;
          }
        }
      }

      .kaibox-ul {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        position: relative;

        .kaibox-li {
          //overflow: hidden;
          position: absolute;
          left: 0;
          top: 0;
          animation: run5 8s;
          animation-iteration-count: 1 !important; //播放几次动画
          animation-delay: 0s; //动画运行前等待时间
          animation-fill-mode: forwards !important; //动画结束 是否保持

          // animation-timing-function: ease;
          // animation-iteration-count: 1;
          // animation-fill-mode: forwards;
          ul {
            width: 20000px;
            display: flex;
            flex-wrap: nowrap;
            z-index: 20;

            li {
              width: 200px;
              height: 150px;
              background-image: url("../assets/img/box-skins-null.jpg");
              background-size: 100% 100%;

              // border: 1px solid #fff;
              img {
                margin-left: 2%;
                margin-top: 10px;
                width: 95%;
                max-height: 180px;
              }
            }

            .li1 {
              background-image: url("../assets/img/box-skins-golden.jpg");
            }

            .li2 {
              background-image: url("../assets/img/box-skins-violet.jpg");
            }
          }
        }
      }

      @keyframes run5 {
        0% {
          left: 0;
        }

        100% {
          left: -8000px;
        }
      }
    }
  }

  .kai-box-open22m {
    position: absolute;
    padding-bottom: 500px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 106;

    .kai-warp11 {
      position: absolute;
      width: 1000px;
      height: 150px;
      top: 50%;
      left: 50%;
      margin-left: -500px;

      // background-color: #fff;
      // overflow: hidden;
      .kaibox-line {
        position: absolute;
        width: 8px;
        height: 180px;
        left: 50%;
        top: -90px;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 50%;
        left: 25%;
        top: -140px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        bottom: 10px;
        left: 7px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp2 {
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            margin-top: -75px;
          }

          .kaibox-li:nth-child(2) {
            animation-timing-function: cubic-bezier(
              0.4,
              0.95,
              0.76,
              1
            ) !important; //动画慢 快 慢
            // animation-delay: 0.25s !important;
          }
        }
      }

      .kaibox-ul {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        position: relative;

        .kaibox-li {
          //overflow: hidden;
          margin-left: -45px;
          position: absolute;
          left: 0;
          top: 0;
          animation: run5 8s;
          animation-iteration-count: 1 !important; //播放几次动画
          animation-delay: 0s; //动画运行前等待时间
          animation-fill-mode: forwards !important; //动画结束 是否保持

          // animation-timing-function: ease;
          // animation-iteration-count: 1;
          // animation-fill-mode: forwards;
          ul {
            width: 20000px;
            display: flex;
            flex-wrap: nowrap;
            z-index: 20;

            li {
              width: 100px;
              height: 75px;
              background-image: url("../assets/img/box-skins-null.jpg");
              background-size: 100% 100%;

              // border: 1px solid #fff;
              img {
                margin-left: 2%;
                width: 95%;
                max-height: 180px;
                margin-top: 5px !important;
              }
            }

            .li1 {
              background-image: url("../assets/img/box-skins-golden.jpg");
            }

            .li2 {
              background-image: url("../assets/img/box-skins-violet.jpg");
            }
          }
        }
      }

      @keyframes run5 {
        0% {
          left: 0;
        }

        100% {
          left: -8000px;
        }
      }
    }
  }

  //测试开多个盒子
  .kai-box-open3 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 870px;
      left: 120px;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 130px;
      display: flex;
      justify-content: center;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 860px;
        transform: rotate(270deg);
        left: 40%;
        top: -29%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 100%;
        left: -70px;
        top: -15px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        left: -70px;
        bottom: -15px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 480px;
        padding-top: 60px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 290px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 240px;
                height: 180px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;

                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 10px;
                  width: 95%;
                  max-height: 180px;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp3 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 240px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 480px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }

  //测试开多个盒子
  .kai-box-open3m {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 350px;
      left: 50%;
      margin-left: -150px;
      margin-top: 130px;
      // overflow: hidden;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 340px;
        transform: rotate(270deg);
        left: 42%;
        top: -34%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 120%;
        left: -70px;
        top: -8px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 120%;
        left: -70px;
        bottom: -7px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 140px;
        padding-top: 62px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 290px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 100px;
                height: 75px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;

                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 5px !important;
                  width: 95% !important;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp3 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 100px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 200px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }

  //测试开多个盒子
  .kai-box-open4 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 870px;
      left: 120px;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 130px;
      display: flex;
      justify-content: center;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 860px;
        transform: rotate(270deg);
        left: 41.5%;
        top: -28%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 100%;
        left: -70px;
        top: -15px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        left: -70px;
        bottom: -15px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 490px;
        padding-top: 50px;
        margin-left: -60px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 250px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 200px;
                height: 150px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;

                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 10px;
                  width: 95%;
                  max-height: 180px;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp4 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            left: 0;
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 200px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 400px;
            animation-delay: 0.45s !important;
          }

          .kaibox-li:nth-child(4) {
            left: 600px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }

  //测试开多个盒子
  .kai-box-open4m {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 350px;
      left: 50%;
      margin-left: -110px;
      margin-top: 130px;
      // overflow: hidden;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 380px;
        transform: rotate(270deg);
        left: 31%;
        top: -50%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 120%;
        left: -100px;
        top: -7px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 120%;
        left: -100px;
        bottom: -7px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 142px;
        padding-top: 50px;
        margin-left: -65px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 250px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 90px;
                height: 67.5px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;
                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 10px !important;
                  width: 95%;
                  max-height: 180px;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp4 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            left: 0;
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 90px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 180px;
            animation-delay: 0.45s !important;
          }

          .kaibox-li:nth-child(4) {
            left: 270px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }

  //测试开多个盒子
  .kai-box-open5 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 870px;
      left: 120px;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 130px;
      display: flex;
      justify-content: center;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 860px;
        transform: rotate(270deg);
        left: 41.5%;
        top: -37.5%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 100%;
        left: -70px;
        top: -15px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        left: -70px;
        bottom: -15px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 400px;
        padding-top: 102px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 250px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 150px;
                height: 112.5px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;

                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 10px;
                  width: 95%;
                  max-height: 180px;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp5 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 150px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 300px;
            animation-delay: 0.45s !important;
          }

          .kaibox-li:nth-child(4) {
            left: 450px;
            animation-delay: 0.45s !important;
          }

          .kaibox-li:nth-child(5) {
            left: 600px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }

  //测试开多个盒子
  .kai-box-open5m {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 870px;
    margin-top: 32px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 106;

    .kai-warp1 {
      position: absolute;
      width: 350px;
      left: 50%;
      margin-left: -110px;
      margin-top: 130px;
      // overflow: hidden;
      // overflow: hidden;

      .kaibox-line {
        position: absolute;
        width: 5px;
        height: 370px;
        transform: rotate(270deg);
        left: 30.5%;
        top: -40%;
        z-index: 99;
      }

      .dingbu {
        position: absolute;
        width: 100%;
        left: -70px;
        top: -8px;
        z-index: 99;
      }

      .dibu {
        position: absolute;
        width: 100%;
        left: -70px;
        bottom: -5px;
        transform: rotate(180deg);
        z-index: 99;
      }

      .kaibox-warp {
        height: 152px;
        padding-top: 50px;
        margin-left: -65px;
        overflow: hidden;
        width: 100%;

        .kaibox-ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          position: relative;

          .kaibox-li {
            //overflow: hidden;
            width: 250px;
            position: absolute;
            top: 0;
            left: 0;
            animation: run5 8s;
            animation-timing-function: cubic-bezier(
              0.4,
              0.89,
              0.63,
              1
            ) !important; //动画慢 快 慢
            animation-iteration-count: 1 !important; //播放几次动画
            animation-delay: 0s; //动画运行前等待时间
            animation-fill-mode: forwards !important; //动画结束 是否保持

            // animation-timing-function: ease;
            // animation-iteration-count: 1;
            // animation-fill-mode: forwards;
            ul {
              li {
                width: 70px;
                height: 49px;
                background-image: url("../assets/img/box-skins-null.jpg");
                background-size: 100% 100%;
                // border: 1px solid #fff;
                img {
                  margin-left: 2%;
                  margin-top: 3px !important;
                  width: 95%;
                  max-height: 180px;
                }
              }

              .li1 {
                background-image: url("../assets/img/box-skins-golden.jpg");
              }

              .li2 {
                background-image: url("../assets/img/box-skins-violet.jpg");
              }
            }
          }
        }
      }

      .kaibox-warp5 {
        //width: 900px;
        .kaibox-ul {
          .kaibox-li:nth-child(1) {
            left: 0;
            animation-delay: 0.15s !important;
          }

          .kaibox-li:nth-child(2) {
            left: 70px;
            animation-delay: 0.3s !important;
          }

          .kaibox-li:nth-child(3) {
            left: 140px;
            animation-delay: 0.45s !important;
          }

          .kaibox-li:nth-child(4) {
            left: 210px;
            animation-delay: 0.45s !important;
          }
          .kaibox-li:nth-child(5) {
            left: 280px;
            animation-delay: 0.45s !important;
          }
        }
      }

      // @keyframes run5 {
      //   0% {
      //     top: 0;
      //   }
      //   100% {
      //     //50
      //     top: -10000px;
      //   }
      // }
    }
  }
  // .kai-box-open4 {
  // 	position: absolute;
  // 	top: 0;
  // 	left: 0;
  // 	width: 100%;
  // 	height: 100%;
  // 	background-color: rgba(0, 0, 0, 0.5);
  // 	z-index: 66;

  // 	.kai-warp1 {
  // 		position: absolute;
  // 		width: 100%;
  // 		height: 120px;
  // 		top: 30%;
  // 		left: 0;
  // 		display: flex;
  // 		justify-content: center;

  // 		.kaibox-line {
  // 			width: 100%;
  // 			height: 2px;
  // 			position: absolute;
  // 			top: 59px;
  // 			left: 0;
  // 			z-index: 99;
  // 			background-color: #fff;
  // 		}

  // 		.kaibox-warp {
  // 			overflow: hidden;
  // 			width: 100%;

  // 			.kaibox-ul {
  // 				width: 100%;
  // 				display: flex;
  // 				flex-wrap: nowrap;
  // 				position: relative;

  // 				.kaibox-li {
  // 					//overflow: hidden;
  // 					width: 20%;
  // 					position: absolute;
  // 					top: 0;
  // 					left: 0;
  // 					animation: run6 10s;
  // 					animation-timing-function: cubic-bezier(0.4,
  // 							0.89,
  // 							0.63,
  // 							0.93) !important; //动画慢 快 慢
  // 					animation-iteration-count: 1 !important; //播放几次动画
  // 					animation-delay: 0s; //动画运行前等待时间
  // 					animation-fill-mode: forwards !important; //动画结束 是否保持

  // 					ul {
  // 						li {
  // 							width: 100%;
  // 							height: 120px;
  // 							background-image: url("../assets/img/box-skins-null.jpg");
  // 							background-size: 100% 100%;

  // 							// border: 1px solid #fff;
  // 							img {
  // 								// margin-left: 2%;
  // 								margin-top: 10px;
  // 								width: 95%;
  // 								max-height: 100px;
  // 							}
  // 						}

  // 						.li1 {
  // 							background-image: url("../assets/img/box-skins-golden.jpg");
  // 						}

  // 						.li2 {
  // 							background-image: url("../assets/img/box-skins-violet.jpg");
  // 						}
  // 					}
  // 				}
  // 			}
  // 		}

  // 		.kaibox-warp2 {

  // 			//width: 600px;
  // 			.kaibox-ul {
  // 				.kaibox-li:nth-child(1) {
  // 					left: 30%;
  // 					animation-delay: 0.25s !important;
  // 				}

  // 				.kaibox-li:nth-child(2) {
  // 					left: 49.5%;
  // 					animation-delay: 0.5s !important;
  // 				}
  // 			}
  // 		}

  // 		.kaibox-warp3 {

  // 			//width: 900px;
  // 			.kaibox-ul {
  // 				.kaibox-li:nth-child(1) {
  // 					left: 20%;
  // 					animation-delay: 0.15s !important;
  // 				}

  // 				.kaibox-li:nth-child(2) {
  // 					left: 39.5%;
  // 					animation-delay: 0.3s !important;
  // 				}

  // 				.kaibox-li:nth-child(3) {
  // 					left: 59%;
  // 					animation-delay: 0.45s !important;
  // 				}
  // 			}
  // 		}

  // 		.kaibox-warp4 {

  // 			//width: 1200px;
  // 			.kaibox-ul {
  // 				.kaibox-li:nth-child(1) {
  // 					left: 10%;
  // 					animation-delay: 0.15s !important;
  // 				}

  // 				.kaibox-li:nth-child(2) {
  // 					left: 29.5%;
  // 					animation-delay: 0.3s !important;
  // 				}

  // 				.kaibox-li:nth-child(3) {
  // 					left: 49%;
  // 					animation-delay: 0.45s !important;
  // 				}

  // 				.kaibox-li:nth-child(4) {
  // 					left: 68.5%;
  // 					animation-delay: 0.6s !important;
  // 				}
  // 			}
  // 		}

  // 		.kaibox-warp5 {

  // 			//width: 1500px;
  // 			.kaibox-ul {
  // 				.kaibox-li:nth-child(1) {
  // 					left: 0;
  // 					animation-delay: 0.15s !important;
  // 				}

  // 				.kaibox-li:nth-child(2) {
  // 					left: 19.9%;
  // 					animation-delay: 0.3s !important;
  // 				}

  // 				.kaibox-li:nth-child(3) {
  // 					left: 39.8%;
  // 					animation-delay: 0.45s !important;
  // 				}

  // 				.kaibox-li:nth-child(4) {
  // 					left: 59.7%;
  // 					animation-delay: 0.6s !important;
  // 				}

  // 				.kaibox-li:nth-child(5) {
  // 					left: 79.6%;
  // 					animation-delay: 0.75s !important;
  // 				}
  // 			}
  // 		}

  // 		// @keyframes run6 {
  // 		//   0% {
  // 		//     top: 0;
  // 		//   }
  // 		//   100% {
  // 		//     //50
  // 		//     top: -6000px;
  // 		//   }
  // 		// }
  // 	}
  // }

  //中奖后盒子
  .win-box {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.9);
    height: 100vh;
  }

  .topic {
    width: 15%;
    min-width: 160px;
    margin-bottom: 50px;
  }

  .kai-masked {
    width: 100%;
    min-height: 600px;

    /deep/ .el-loading-mask {
      background-color: inherit !important;

      .circular {
        width: 64px;
        height: 64px;
      }

      .el-loading-spinner .path {
        stroke: #ff9b0b;
      }

      .el-loading-spinner .el-loading-text {
        color: #ff9b0b;
        font-size: 18px;
        margin-top: 12px;
      }
    }
  }

  overflow: hidden;

  .kai-con {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 25px;
    .con-name {
      margin-top: -40px !important;
      font-size: 0.8vw;
      font-weight: 700;
      background-color: #ffc400;
      color: #000;
      margin: 20px auto;
      width: 200px;
      height: 45px;
      line-height: 45px;
      text-align: center;
    }

    .con-list {
      width: 100%;

      ul {
        width: 100%;
        display: flex;
        justify-content: center;

        li {
          width: 100%;
          max-width: 600px;
          .conlist-warp {
            // border-radius: 50%;
            position: relative;
            // background-color: rgba(65, 105, 161, 0.2);
            // padding: 14% 0;
            margin: 0 5px;
            text-align: center;
            display: flex;
            justify-content: center;

            .conlist-box {
              height: auto;
              text-align: center;
              background: url("../assets/new/bg2.gif") no-repeat;
              background-position: center 0;
              background-size: 40%;
              img {
                width: 100%;
                height: 100%;
                visibility: hidden;
              }
            }

            .conlist-box1 {
              width: 60%;
              position: absolute;
              left: 0;
              top: 10px;
              left: 20%;
              animation: boxhover 1.5s linear 0s infinite alternate;

              img {
                width: 40%;
                height: 80%;
              }
            }
          }
        }

        li:hover {
          cursor: pointer;
        }

        li:hover .conlist-box1 {
          position: absolute;
          top: 10%;
          animation: boxhover 1.5s linear 0s infinite alternate;
        }

        @keyframes boxhover {
          0% {
            top: 50px;
          }

          50% {
            top: 100px;
          }

          100% {
            top: 50px;
          }
        }
      }
    }

    .con-num {
      margin-top: 10px;
      width: 100%;
      max-width: 600px;
      text-align: center;

      ul {
        display: flex;
        justify-content: center;
        height: 100%;
        li.con-num-check {
          background: #ffc400;
        }
        li {
          width: 50px;
          height: 50px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 15px;
          border-radius: 50%;
          border-radius: 50%;
          background: #161c1a;
          border: 1px solid #ffc400;
          span {
            z-index: 88;
            font-size: 0.94vw;
            color: #fff;
            font-family: ninefont;
            font-weight: 600;
          }
        }

        li:hover {
          cursor: pointer;
          // background-color: #444659;
          opacity: 0.8 !important;
        }

        .con-num-check {
          // background-color: #ff9b0b;
          span {
            color: #000;
          }
        }
      }
    }

    .buy-container {
      margin-top: 20px;
      display: flex;
      align-items: center;
      position: relative;

      .img {
        cursor: pointer;
        height: 40px;
        position: absolute;
        top: 50%;
        right: calc(50% - 201px);
        transform: translate(-50%, -50%);
      }
    }

    .con-btn {
      display: flex;
      margin-right: 20px;
      justify-content: space-between;
      align-items: center;
      border-radius: 0px;
      // border: 1px solid #fff;
      border: 1px solid #ffc400;

      // background-image:linear-gradient(to right,#87cde0, #c537bc);
      background-color: #ffc400;
      .con-btn1 {
        height: 45px;
        width: 201px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ninefont !important;
        cursor: pointer;

        span {
          font-size: 20px;
          color: #141221;
          font-family: ninefont !important;
          font-weight: 600;
          margin-left: 5px;
        }

        img {
          width: auto;
          height: 25px;
        }
      }

      .con-btn2 {
        border: none;
        background-image: linear-gradient(to right, #ff571b, #ff9b0b);
        color: white;
        // padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        margin-right: -1px;
      }

      .con-btn2:hover {
        cursor: pointer;
      }
    }
  }

  .kai-conm {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .moblie-box-name {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #ffc400;
      height: 33px;
      width: 161px;
      text-align: center;
      line-height: 33px;
      font-weight: 600;
    }

    .con-name {
      margin-top: 20px;
      font-size: 0.8vw;
      color: #000;
      width: 200px;
      height: 45px;
      line-height: 45px;
      text-align: center;
    }

    .con-list {
      width: 100%;

      ul {
        width: 100%;
        display: flex;
        justify-content: center;

        li {
          width: 100%;
          max-width: 600px;

          .conlist-warp {
            // border-radius: 50%;
            position: relative;
            // background-color: rgba(65, 105, 161, 0.2);
            // padding: 14% 0;
            margin: 0 5px;
            text-align: center;
            display: flex;
            justify-content: center;

            .conlist-box {
              height: auto;
              text-align: center;
              background: url("../assets/new/bg2.gif") no-repeat;
              background-position: center 0;
              background-size: 40%;
              img {
                width: 70%;
                height: 100%;
                visibility: hidden;
              }
            }

            .conlist-box1 {
              width: 60%;
              position: absolute;
              left: 0;
              top: 0px;
              left: 20%;
              animation: boxhover 1.5s linear 0s infinite alternate;

              img {
                width: 50%;
                height: 80%;
              }
            }
          }
        }

        li:hover {
          cursor: pointer;
        }

        li:hover .conlist-box1 {
          position: absolute;
          top: 10%;
          animation: boxhover 1.5s linear 0s infinite alternate;
        }

        @keyframes boxhover {
          0% {
            top: 50px;
          }

          50% {
            top: 100px;
          }

          100% {
            top: 50px;
          }
        }
      }
    }

    .con-num {
      margin-top: 10px;
      height: 70px;
      width: 100%;
      max-width: 600px;
      text-align: center;

      ul {
        display: flex;
        justify-content: center;
        height: 100%;
        li.con-num-check {
          background: #ffc400;
        }
        li {
          width: 60px;
          height: 60px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background: #161c1a;
          border: 1px solid #ffc400;
          span {
            z-index: 88;
            font-size: 28px;
            color: #fff;
            font-family: ninefont;
          }
        }

        li:hover {
          cursor: pointer;
          // background-color: #444659;
          opacity: 0.8 !important;
        }

        .con-num-check {
          // background-color: #ff9b0b;
          span {
            color: #000;
          }
        }
      }
    }

    .buy-container {
      margin-top: 40px;
      display: flex;
      align-items: center;
      position: relative;
      .img {
        cursor: pointer;
        height: 40px;
        position: absolute;
        top: 50%;
        right: calc(50% - 161px);
        transform: translate(-50%, -50%);
      }
    }

    .con-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0px;
      // border: 1px solid #fff;
      border: 1px solid #ffc400;

      // background-image:linear-gradient(to right,#87cde0, #c537bc);
      background-color: #ffc400;
      .con-btn1 {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 162px;
        font-family: ninefont !important;
        height: 33px;

        span {
          font-size: 18px;
          color: #141221;
          font-weight: 600;
          font-family: ninefont !important;
          margin-left: 0px;
        }

        img {
          width: auto;
          height: 20px;
          margin-right: 10px;
        }
      }

      .con-btn2 {
        border: none;
        background-image: linear-gradient(to right, #ff571b, #ff9b0b);
        color: white;
        // padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        margin-right: -1px;
      }

      .con-btn2:hover {
        cursor: pointer;
      }
    }
  }

  .kai-num {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 16px;
      color: #848492;
      display: flex;
      align-items: center;
    }

    i {
      color: #0e0d0d;
      font-size: 20px;
    }

    h6 {
      font-size: 16px;
      color: #848492;
      font-weight: 200;
    }
  }

  .box-list {
    margin: 20px 16px 50px 16px;
    // padding: 0 16px 16px 16px;
    border-radius: 5px;

    .boxlist-top {
      padding: 0 16px 0 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 3px solid #ffc400;
      align-items: center;
      .left {
        span {
          font-size: 0.8vw;
          color: #fff;
          display: inline-block;
          padding: 10px 16px;
          border: 3px solid #ffc400;
          font-weight: 700;
          border-bottom: none;
        }

        .span1 {
          // border-bottom: 2px solid #f3ab34;
          // background-image: url("../assets/new/bg_border.png");
          background-color: #ffc400;
          color: #000;
        }

        span:hover {
          cursor: pointer;
        }
      }

      .right {
        display: flex;
        align-items: center;

        .right-one,
        .right-two {
          display: flex;
        }

        .right-data {
          display: flex;
          align-items: center;

          .percent {
            margin-right: 15px;
            display: flex;
            align-items: center;

            span {
              display: table;
              width: 26px;
              height: 7px;
              border-radius: 5px;
            }

            .span1 {
              background-color: #0f0f0f;
            }

            .span11 {
              color: #0e0d0d;
            }

            .span2 {
              background-color: #b969d4;
            }

            .span12 {
              color: #b969d4;
            }

            .span3 {
              background-color: #adc8cd;
            }

            .span13 {
              color: #adc8cd;
            }
          }
        }
      }
    }

    .boxlist-bot {
      zoom: 0.64;
      padding: 10px 0px;
      // 电脑端使用flex
      ul {
        // display: grid;
        // grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        // gap: 15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: flex-start;

        li {
          width: 250px;
          background-size: 100% auto;
          background-repeat: no-repeat;
          cursor: pointer;
          margin-right: 15px;
          margin-bottom: 15px;

          .boxlist-warp {
            // background-color: #24252f;
            margin: 8px;
            border-radius: 5px;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: space-between;
            height: calc(100%);

            .boxlist1-top {
              padding: 0 20px;
              background-size: 100% 100%;
              text-align: center;
              // border-bottom: 3px solid #f1a920;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;

              // box-shadow: 0px 5px 10px #f1a920;
              img {
                width: 100%;
                margin-top: 20px;
                height: auto;
                cursor: pointer;
              }
            }

            .boxlist1-bot {
              padding: 8px;
              color: #ffffff;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 18px;
              width: 150px;
              // word-wrap: break-word;
            }

            .boxlist1-bot1 {
              padding: 8px;
              display: flex;
              align-items: center;

              img {
                width: 25px;
                height: 25px;
                border-radius: 50%;
              }

              span {
                margin-left: 8px;
                color: #fff;
                font-size: 18px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }

            .list-pirce {
              padding: 0px 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .ico {
              display: block;
              margin: 10px 0;
              font-size: 18px;
              color: #f4bd50;
              padding: 2px 4px;
            }

            .pirce-left {
              flex: 1;
              display: flex;
              align-items: center;
              padding-right: 10px;

              img {
                width: auto;
                height: 15px;
                margin-right: 5px;
              }

              & > div {
                flex: 1;
                color: #f4bd50;
                font-size: 18px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                span:last-child {
                  color: #fff;
                }
              }
            }

            .pirce-right {
              color: #848492;
              font-size: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .boxlist-botm {
      zoom: 0.64;
      .increase-rose {
        height: 38px;
        margin-top: 20px;
        margin-bottom: 20px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        padding: 10px 20px;
        align-items: center;
        background-image: url("../assets/img/open-box/zjdl-bg.png");
        .rose-item {
          display: flex;
          align-items: center;
          margin-right: 15px;
          .point {
            height: 15px;
            width: 15px;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
      ul {
        width: 100%;
        display: grid;
        grid-gap: 15px;
        justify-content: space-between;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        li {
          width: 100%;
          background-size: 100% auto;
          background-repeat: no-repeat;
          cursor: pointer;

          .boxlist-warp {
            // background-color: #24252f;
            border-radius: 5px;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            .boxlist1-top {
              padding: 0 20px;
              background-size: 100% 100%;
              text-align: center;
              // border-bottom: 3px solid #f1a920;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;

              // box-shadow: 0px 5px 10px #f1a920;
              img {
                width: 100%;
                margin-top: 10%;
                height: auto;
                min-height: 100px;
                cursor: pointer;
              }
            }

            .boxlist1-bot {
              padding: 8px;
              width: 150px;
              color: #fff;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 18px;
              white-space: nowrap;
              // word-wrap: break-word;
            }

            .boxlist1-bot1 {
              padding: 8px;
              display: flex;
              align-items: center;

              img {
                width: 25px;
                height: 25px;
                border-radius: 50%;
              }

              span {
                margin-left: 8px;
                color: #fff;
                font-size: 18px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }

            .list-pirce {
              padding: 0px 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .ico {
              display: block;
              margin: 20px 0 10px 0;
              font-size: 18px;
              color: #f4bd50;
              padding: 2px 4px;
            }

            .pirce-left {
              flex: 1;
              display: flex;
              align-items: center;
              padding-right: 10px;

              img {
                width: auto;
                height: 15px;
                margin-right: 5px;
              }

              & > div {
                flex: 1;
                color: #f4bd50;
                font-size: 18px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                span:last-child {
                  color: #fff;
                }
              }
            }

            .pirce-right {
              color: #848492;
              font-size: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }

  .boxlist1-top-desc {
    padding: 10px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* .share-hide {
    //height: 300px;
  }*/
  .share-btn {
    display: flex;

    .btn {
      margin-left: 10px;
    }
  }

  /deep/ .el-dialog__footer {
    display: none;
  }

  /deep/ .el-dialog__title {
    color: #848492;
  }

  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }

  /deep/ .el-dialog {
    min-height: none;
  }
}
@media screen and (max-width: 320px) {
  .openbox .box-list .boxlist-botm {
    padding: 0 !important;
  }
}
@media screen and (max-width: 366px) {
  .openbox .box-list .boxlist-botm {
    padding: 0 !important;
  }
}
@media screen and (max-width: 767px) {
  .drop-item span {
    font-size: 16px;
  }
  .boxlist1-top-desc {
    // margin-top: -15px;
    padding: 10px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .openbox .box-list .boxlist-top .left span {
    font-size: 12px;
  }
  .openbox {
    // background-size: cover !important;
    // width: 166%;
    // transform: translate(-20%, 0);
    background-size: 240% 100%;
    background-position: center;
    .kai-box {
      padding: 0 !important;
      margin: 0;
    }

    .win-box {
      position: fixed;
      top: 0;
      left: 0 !important;
      height: 100vh;
      z-index: 1000;
      margin-left: 0 !important;
      background-color: rgba(0, 0, 0, 0.8);
    }
    .kai-conm .con-name {
      display: none;
    }
    .kai-conm .buy-container {
      margin-top: 15px;
    }
    .kai-conm .con-num {
      height: auto;
      ul li {
        height: 45px;
        width: 45px;
        margin-right: 5px;
        span {
          font-size: 16px;
        }
      }
    }
  }
  .openbox.yidong {
    height: 420px;
    padding-bottom: 15px;
  }
  .con-name {
    margin-top: 20px;
    font-size: 0.8vw;
    font-weight: 700;
    margin-top: 60px !important;
    width: 200px;
    text-align: center;
    background-color: #ffc400;
    color: #000;
  }
  .openbox .box-list .boxlist-top {
    margin: 0;
  }
  .openbox .box-list .boxlist-botm {
    // padding: 0 20px;
    p {
      font-size: 16px;
    }
  }
  @keyframes boxhover {
    0% {
      top: 20px;
    }

    50% {
      top: 50px;
    }

    100% {
      top: 20px;
    }
  }
}

.pk-openbox-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 56% 28%, rgba(255, 105, 0, 0.16), transparent 28%),
    radial-gradient(circle at 80% 18%, rgba(119, 71, 255, 0.18), transparent 24%),
    #1c1d29;
}

.pk-openbox-page > .openbox {
  width: calc(100% - 250px);
  min-height: 100vh;
  height: 100vh;
  margin-left: 250px;
  padding-top: 198px;
  padding-bottom: 60px;
  position: relative;
  z-index: 1;
  background-image: none !important;
  background-color: transparent !important;
  background-attachment: scroll;
  overflow-y: auto;
}

.pk-openbox-page > .openbox::before {
  content: "";
  position: fixed;
  left: 250px;
  right: 0;
  top: 198px;
  height: 380px;
  pointer-events: none;
  background:
    linear-gradient(180deg, rgba(255, 100, 0, 0.09), transparent 64%),
    repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.02) 0 1px, transparent 1px 82px);
}

.pk-openbox-page .openbox.yidong {
  height: auto;
  padding-bottom: 0;
  background: transparent !important;
}

.pk-openbox-page .kai-box {
  max-width: 1160px;
  margin: 30px auto 0;
  padding: 0 24px;
}

.pk-openbox-page .kai-masked {
  display: none !important;
}

.pk-openbox-page .kai-con {
  min-height: 420px;
  padding: 34px 34px 28px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 36%, rgba(255, 104, 0, 0.18), transparent 28%),
    linear-gradient(145deg, rgba(40, 43, 58, 0.98), rgba(27, 29, 41, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.28);
}

.pk-openbox-page .kai-con::before,
.pk-openbox-page .kai-con::after {
  content: "";
  width: 300px;
  height: 300px;
  position: absolute;
  top: 70px;
  border-radius: 50%;
  filter: blur(6px);
  pointer-events: none;
}

.pk-openbox-page .kai-con::before {
  left: 13%;
  background: radial-gradient(circle, rgba(67, 217, 255, 0.25), transparent 66%);
}

.pk-openbox-page .kai-con::after {
  right: 13%;
  background: radial-gradient(circle, rgba(255, 94, 0, 0.3), transparent 66%);
}

.pk-openbox-page .kai-con .con-name {
  width: auto;
  min-width: 240px;
  height: auto;
  margin: 0 auto 14px !important;
  padding: 0 34px;
  position: relative;
  z-index: 2;
  color: #fff;
  background: transparent;
  font-size: 30px;
  line-height: 1.25;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.pk-openbox-page .kai-con .con-name::before,
.pk-openbox-page .kai-con .con-name::after {
  content: "";
  width: 22px;
  height: 22px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-openbox-page .kai-con .con-name::before {
  left: 2px;
}

.pk-openbox-page .kai-con .con-name::after {
  right: 2px;
}

.pk-openbox-page .kai-con .con-list {
  position: relative;
  z-index: 2;
}

.pk-openbox-page .kai-con .con-list ul li {
  max-width: 540px;
}

.pk-openbox-page .kai-con .conlist-warp {
  min-height: 210px;
  align-items: center;
}

.pk-openbox-page .kai-con .conlist-box {
  width: 100%;
  background: radial-gradient(circle, rgba(255, 120, 0, 0.42), rgba(126, 60, 255, 0.22) 36%, transparent 68%) !important;
  filter: drop-shadow(0 22px 36px rgba(0, 0, 0, 0.45));
}

.pk-openbox-page .kai-con .conlist-box img {
  min-height: 210px;
}

.pk-openbox-page .kai-con .conlist-box1 {
  top: 24px !important;
  animation: pk-case-float 1.8s ease-in-out infinite alternate !important;
  filter: drop-shadow(0 24px 24px rgba(0, 0, 0, 0.52));
}

.pk-openbox-page .kai-con .conlist-box1 img {
  width: 54% !important;
  max-height: 250px;
  object-fit: contain;
}

@keyframes pk-case-float {
  from {
    transform: translateY(-8px);
  }
  to {
    transform: translateY(16px);
  }
}

.pk-openbox-page .kai-con .con-num {
  max-width: none;
  margin-top: 18px;
  position: relative;
  z-index: 2;
}

.pk-openbox-page .kai-con .con-num ul li {
  width: 54px;
  height: 42px;
  margin-right: 8px;
  background: #292c3a;
  border: 1px solid #3b4052;
  border-radius: 7px;
}

.pk-openbox-page .kai-con .con-num ul li span {
  color: #b7becd;
  font-size: 17px;
  font-family: inherit;
}

.pk-openbox-page .kai-con .con-num ul li.con-num-check,
.pk-openbox-page .kai-con .con-num ul .con-num-check {
  background: #f26900;
  border-color: #ff8b22;
  box-shadow: 0 10px 22px rgba(242, 105, 0, 0.25);
}

.pk-openbox-page .kai-con .con-num ul li.con-num-check span,
.pk-openbox-page .kai-con .con-num ul .con-num-check span {
  color: #fff;
}

.pk-openbox-page .kai-con .buy-container {
  margin-top: 20px;
  position: relative;
  z-index: 2;
}

.pk-openbox-page .kai-con .con-btn {
  min-width: 280px;
  height: 56px;
  margin-right: 0;
  padding: 0 24px;
  display: flex;
  gap: 18px;
  justify-content: center;
  background: #f26900;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 14px 30px rgba(242, 105, 0, 0.28);
}

.pk-openbox-page .kai-con .con-btn::before {
  content: "打开箱子";
  color: #fff;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.pk-openbox-page .kai-con .con-btn1 {
  width: auto;
  height: 100%;
  gap: 6px;
}

.pk-openbox-page .kai-con .con-btn1 img {
  width: 18px;
  height: 18px;
  display: block;
  content: url("../assets/pizzaking/pizza-token.svg");
}

.pk-openbox-page .kai-con .con-btn1 span {
  margin-left: 0;
  color: #fff;
  font-size: 18px;
  font-family: inherit !important;
}

.pk-openbox-page .kai-con .buy-container > .img {
  right: -54px;
  height: 38px;
  opacity: 0.75;
}

.pk-openbox-page .box-list {
  max-width: 1160px;
  margin: 24px auto 80px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.pk-openbox-page .box-list .boxlist-top {
  padding: 0;
  border: 0;
}

.pk-openbox-page .box-list .boxlist-top .left {
  display: flex;
  gap: 8px;
}

.pk-openbox-page .box-list .boxlist-top .left span {
  padding: 12px 20px;
  color: #8e98aa;
  background: #252836;
  border: 0;
  border-radius: 8px 8px 0 0;
  font-size: 14px;
  font-weight: 900;
}

.pk-openbox-page .box-list .boxlist-top .left .span1 {
  color: #fff;
  background: #f26900;
}

.pk-openbox-page .box-list .boxlist-bot,
.pk-openbox-page .box-list .boxlist-botm {
  zoom: 1;
  padding: 16px;
  background: #20222f;
  border-radius: 0 10px 10px 10px;
}

.pk-openbox-page .box-list .boxlist-bot ul,
.pk-openbox-page .box-list .boxlist-botm ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.pk-openbox-page .box-list .boxlist-bot ul li,
.pk-openbox-page .box-list .boxlist-botm ul li {
  width: auto;
  min-height: 205px;
  margin: 0;
  overflow: hidden;
  background-color: #282b39;
  background-size: cover;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 9px;
  transition: transform 0.18s ease, border-color 0.18s ease;
}

.pk-openbox-page .box-list .boxlist-bot ul li:hover,
.pk-openbox-page .box-list .boxlist-botm ul li:hover {
  transform: translateY(-3px);
  border-color: rgba(242, 105, 0, 0.58);
}

.pk-openbox-page .box-list .boxlist-warp {
  height: 100%;
  margin: 0;
  padding: 12px;
  border-radius: 9px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(0, 0, 0, 0.08));
}

.pk-openbox-page .box-list .boxlist1-top {
  min-height: 112px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pk-openbox-page .box-list .boxlist1-top .ico {
  margin: 0 0 8px;
  color: #7f8a9d;
  font-size: 12px;
  font-weight: 800;
}

.pk-openbox-page .box-list .boxlist1-top img {
  width: 100%;
  max-height: 96px;
  margin-top: 0;
  object-fit: contain;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.45));
}

.pk-openbox-page .box-list .boxlist1-top-desc {
  padding: 10px 0 0;
  align-items: flex-start;
}

.pk-openbox-page .box-list .list-pirce {
  width: 100%;
  padding: 0;
}

.pk-openbox-page .box-list .pirce-left {
  padding: 0;
}

.pk-openbox-page .box-list .pirce-left img {
  width: 15px;
  height: 15px;
  content: url("../assets/pizzaking/pizza-token.svg");
}

.pk-openbox-page .box-list .pirce-left > div {
  color: #f26900;
  font-size: 14px;
  font-weight: 900;
}

.pk-openbox-page .box-list .boxlist1-bot {
  width: 100%;
  padding: 7px 0 0;
  color: #f3f6fb;
  font-size: 14px;
  font-weight: 800;
}

.pk-case-preview {
  max-width: 1160px;
  margin: 30px auto 80px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.pk-case-hero {
  min-height: 430px;
  padding: 38px;
  display: grid;
  grid-template-columns: minmax(320px, 0.9fr) minmax(360px, 1.1fr);
  gap: 20px;
  align-items: center;
  overflow: hidden;
  background:
    radial-gradient(circle at 67% 46%, rgba(255, 105, 0, 0.3), transparent 33%),
    radial-gradient(circle at 68% 48%, rgba(120, 77, 255, 0.32), transparent 44%),
    linear-gradient(145deg, #282b39, #1f212d);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 0 24px 58px rgba(0, 0, 0, 0.32);
}

.pk-case-copy {
  position: relative;
  z-index: 2;
}

.pk-eyebrow {
  color: #f26900;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.pk-case-copy h1 {
  margin: 10px 0 8px;
  color: #fff;
  font-size: 42px;
  line-height: 1;
  text-transform: uppercase;
}

.pk-case-copy p {
  max-width: 360px;
  margin: 0 0 22px;
  color: #8792a4;
  font-size: 15px;
  line-height: 1.5;
}

.pk-preview-counts {
  display: flex;
  gap: 8px;
  margin-bottom: 18px;
}

.pk-preview-counts span {
  width: 54px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b7becd;
  background: #292c3a;
  border: 1px solid #3b4052;
  border-radius: 7px;
  font-size: 17px;
  font-weight: 900;
  cursor: pointer;
}

.pk-preview-counts span.active {
  color: #fff;
  background: #f26900;
  border-color: #ff8b22;
}

.pk-preview-open {
  height: 56px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  background: #f26900;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 14px 30px rgba(242, 105, 0, 0.28);
  cursor: pointer;
}

.pk-preview-open i,
.pk-preview-skins em i {
  width: 18px;
  height: 18px;
  display: block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-preview-open b,
.pk-preview-open strong {
  font-size: 16px;
  font-weight: 900;
}

.pk-case-art {
  min-height: 320px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pk-case-art::before {
  content: "";
  width: 440px;
  height: 260px;
  position: absolute;
  background: radial-gradient(circle, rgba(255, 104, 0, 0.6), rgba(126, 61, 255, 0.28) 38%, transparent 72%);
  filter: blur(8px);
}

.pk-case-art img {
  width: 420px;
  max-width: 92%;
  position: relative;
  mix-blend-mode: screen;
  filter: drop-shadow(0 28px 28px rgba(0, 0, 0, 0.52));
  animation: pk-case-float 1.8s ease-in-out infinite alternate;
}

.pk-preview-skins {
  margin-top: 24px;
  padding: 16px;
  background: #20222f;
  border-radius: 10px;
}

.pk-preview-title {
  margin-bottom: 14px;
  color: #f3f6fb;
  font-size: 16px;
  font-weight: 900;
}

.pk-preview-skins ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.pk-preview-skins li {
  min-height: 205px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    radial-gradient(circle at 50% 38%, rgba(119, 71, 255, 0.22), transparent 58%),
    #282b39;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 9px;
}

.pk-preview-skins li span {
  color: #7f8a9d;
  font-size: 12px;
  font-weight: 900;
}

.pk-preview-skins li img {
  width: 100%;
  height: 96px;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.45));
}

.pk-preview-skins li strong {
  color: #f3f6fb;
  font-size: 14px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pk-preview-skins em {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f26900;
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
}

@media screen and (max-width: 1024px) {
  .pk-openbox-page > .openbox {
    width: 100%;
    margin-left: 0;
    padding-top: 198px;
  }

  .pk-openbox-page > .openbox::before {
    left: 0;
  }

  .pk-openbox-page .kai-box,
  .pk-openbox-page .box-list,
  .pk-case-preview {
    max-width: none;
  }

  .pk-case-hero {
    grid-template-columns: 1fr;
  }
}

.pk-openbox-page > .openbox {
  padding-top: 354px !important;
}

.pk-openbox-page > .openbox::before {
  display: none !important;
}

.pk-openbox-page .kai-box,
.pk-openbox-page .kai-con,
.pk-openbox-page .kai-conm,
.pk-openbox-page .kai-num,
.pk-openbox-page .box-list {
  display: none !important;
}

.pk-target-case {
  max-width: 980px;
  margin: 0 auto 90px;
  padding: 0 16px;
  position: relative;
  z-index: 2;
  color: #dde3ef;
}

.pk-target-unavailable {
  min-height: 420px;
  display: grid;
  justify-items: center;
  align-content: center;
  gap: 12px;
  color: #a6afc0;
  background: radial-gradient(circle at 50% 18%, rgba(255, 138, 31, 0.16), transparent 34%), #1b1d28;
  text-align: center;
}

.pk-target-unavailable strong { color: #f4f6ff; font-size: 22px; }
.pk-target-unavailable button { min-width: 142px; height: 42px; margin-top: 8px; color: #fff3dd; background: linear-gradient(180deg, #ff9b28, #e25e00); border: 1px solid rgba(255, 198, 104, 0.64); border-radius: 7px; cursor: pointer; font: inherit; font-weight: 900; }

.pk-target-panel {
  min-height: 536px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 37%, rgba(95, 255, 163, 0.08), transparent 23%),
    radial-gradient(circle at 50% 86%, rgba(115, 120, 145, 0.22), transparent 42%),
    linear-gradient(180deg, #252733 0%, #20222d 100%);
  border: 1px solid #303342;
  border-radius: 10px;
}

.pk-target-panel::before {
  content: "";
  width: 530px;
  height: 260px;
  position: absolute;
  left: 50%;
  top: 68px;
  transform: translateX(-50%);
  background: radial-gradient(ellipse, rgba(64, 214, 118, 0.15), transparent 68%);
  filter: blur(7px);
}

.pk-target-panel h1 {
  margin: 24px 0 0;
  position: relative;
  z-index: 2;
  color: #fff;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  text-align: center;
}

.pk-target-back {
  height: 38px;
  padding: 0 14px;
  position: absolute;
  right: 18px;
  top: 16px;
  z-index: 4;
  color: #a8b0c0;
  background: #2a2d3a;
  border: 1px solid #393d4c;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.pk-target-back span {
  width: 14px;
  height: 14px;
  margin-left: 6px;
  display: inline-block;
  vertical-align: -2px;
  border: 2px solid currentColor;
  border-left: 0;
  border-bottom: 0;
  transform: rotate(45deg);
}

.pk-target-case-art {
  height: 182px;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.pk-target-case-art img {
  width: 310px;
  max-height: 178px;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 26px 28px rgba(0, 0, 0, 0.58));
  animation: pk-case-float 1.65s ease-in-out infinite alternate;
}

.pk-target-amounts {
  margin-top: 18px;
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  gap: 7px;
}

.pk-target-amounts button {
  width: 46px;
  height: 40px;
  color: #8f98aa;
  background: #2a2d39;
  border: 1px solid #363a49;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}

.pk-target-amounts button.active {
  color: #fff;
  background: #363948;
  border-color: #4a4f60;
}

.pk-target-reel {
  width: calc(100% - 70px);
  height: 126px;
  margin: 12px auto 0;
  position: relative;
  z-index: 3;
}

.pk-target-reel-line {
  height: 1px;
  position: absolute;
  left: 0;
  right: 0;
  top: 63px;
  z-index: 3;
  background: rgba(225, 222, 209, 0.46);
}

.pk-target-pointer {
  width: 0;
  height: 0;
  position: absolute;
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
}

.pk-target-pointer-top {
  top: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 12px solid #e4dfd0;
}

.pk-target-pointer-bottom {
  bottom: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 12px solid #e4dfd0;
}

.pk-target-reel-viewport {
  height: 104px;
  position: absolute;
  left: 0;
  right: 0;
  top: 11px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.pk-target-reel-track {
  height: 104px;
  display: flex;
  gap: 8px;
  transform: translate3d(var(--pk-target-reel-start), 0, 0);
}

.pk-target-reel-track.spinning {
  transform: translate3d(var(--pk-target-reel-end), 0, 0);
  transition: transform 5s cubic-bezier(0.3, 0.84, 0.44, 1);
}

.pk-target-reel-track.spinning.fast {
  transition: none;
}

.pk-target-reel-track.settled {
  transform: translate3d(var(--pk-target-reel-end), 0, 0);
}

.pk-target-reel-card {
  width: 142px;
  height: 104px;
  flex: 0 0 142px;
  position: relative;
  overflow: hidden;
  background: #292b37;
  border: 1px solid #343846;
  border-radius: 5px;
}

.pk-target-reel-card.winner {
  border-color: #343846;
  box-shadow: none;
}

.pk-target-reel-card img {
  width: 118px;
  height: 78px;
  position: absolute;
  left: 12px;
  top: 8px;
  z-index: 2;
  object-fit: contain;
  filter: none;
}

.pk-target-reel-card strong {
  width: 100%;
  padding: 0 8px;
  position: absolute;
  left: 0;
  bottom: 7px;
  z-index: 3;
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pk-target-splatter {
  width: 116px;
  height: 68px;
  position: absolute;
  left: 50%;
  top: 22px;
  z-index: 1;
  transform: translateX(-50%) rotate(-7deg);
  background:
    radial-gradient(circle at 15% 54%, rgba(219, 42, 41, 0.95) 0 11px, transparent 12px),
    radial-gradient(circle at 84% 45%, rgba(143, 26, 36, 0.95) 0 14px, transparent 15px),
    radial-gradient(circle at 48% 28%, rgba(255, 70, 54, 0.9) 0 16px, transparent 17px),
    linear-gradient(90deg, rgba(126, 24, 31, 0.95), rgba(238, 64, 54, 0.95));
  clip-path: polygon(4% 54%, 16% 20%, 34% 29%, 48% 0, 64% 27%, 86% 10%, 96% 47%, 86% 78%, 62% 70%, 45% 100%, 28% 72%, 8% 86%);
  opacity: 0.92;
}

.pk-target-actions {
  margin-top: 14px;
  position: relative;
  z-index: 4;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.pk-target-actions button {
  height: 45px;
  min-width: 142px;
  padding: 0 18px;
  color: #fff;
  background: #f26900;
  border: 0;
  border-radius: 5px;
  box-shadow: inset 0 -2px 0 rgba(115, 38, 0, 0.26);
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
}

.pk-target-actions i,
.pk-target-contains h2 i {
  width: 16px;
  height: 16px;
  margin-left: 7px;
  display: inline-block;
  vertical-align: -3px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-target-contract {
  margin-top: 26px;
}

.pk-target-contract-copy {
  text-align: center;
}

.pk-target-contract-copy h2 {
  margin: 0;
  display: inline-block;
  color: #3fbdff;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.pk-target-contract-copy p {
  margin: 6px 0 14px;
  color: #7f899b;
  font-size: 13px;
  font-weight: 700;
}

.pk-target-contract-box {
  min-height: 220px;
  padding: 18px 18px 20px;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 100%, rgba(158, 32, 42, 0.2), transparent 42%),
    linear-gradient(180deg, rgba(55, 32, 38, 0.72), rgba(32, 34, 45, 0.98));
  border: 1px solid rgba(155, 58, 58, 0.7);
  border-radius: 9px;
}

.pk-target-contract-box h3,
.pk-target-contains h2 {
  margin: 0 0 17px;
  color: #f1f4fb;
  font-size: 16px;
  font-weight: 900;
  text-align: center;
}

.pk-target-contract-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.pk-target-contract-list article {
  height: 158px;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(0, 0, 0, 0)),
    #2b2c38;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.pk-target-contract-list img {
  width: 178px;
  height: 100px;
  position: absolute;
  left: 50%;
  top: 14px;
  z-index: 2;
  transform: translateX(-50%);
  object-fit: contain;
  filter: drop-shadow(0 16px 14px rgba(0, 0, 0, 0.58));
}

.pk-target-contract-list strong,
.pk-target-contract-list em {
  position: absolute;
  left: 10px;
  right: 10px;
  z-index: 3;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pk-target-contract-list strong {
  bottom: 27px;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
}

.pk-target-contract-list em {
  bottom: 9px;
  color: #e2a749;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
}

.pk-target-contains {
  margin-top: 28px;
}

.pk-target-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.pk-target-card {
  min-height: 216px;
  overflow: hidden;
  background: #292b37;
  border: 1px solid #343846;
  border-radius: 6px;
}

.pk-target-card-art {
  height: 132px;
  position: relative;
}

.pk-target-card-art img {
  width: 150px;
  height: 106px;
  position: absolute;
  left: 50%;
  top: 14px;
  z-index: 2;
  transform: translateX(-50%);
  object-fit: contain;
  filter: drop-shadow(0 16px 14px rgba(0, 0, 0, 0.55));
}

.pk-target-card-copy {
  padding: 0 13px 12px;
}

.pk-target-card-copy span {
  height: 17px;
  display: block;
  color: #f19b35;
  font-size: 12px;
  font-weight: 900;
}

.pk-target-card-copy strong,
.pk-target-card-copy b,
.pk-target-card-copy em {
  display: block;
  color: #f2f5fb;
  font-size: 13px;
  font-weight: 900;
  font-style: normal;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pk-target-card-copy b {
  color: #cdd4e1;
}

.pk-target-card-copy em {
  color: #697386;
  font-size: 12px;
}

@keyframes pk-target-reel-spin {
  0% {
    transform: translate3d(-300px, 0, 0);
  }
  12% {
    transform: translate3d(-1450px, 0, 0);
  }
  72% {
    transform: translate3d(calc(var(--pk-target-reel-end) + 420px), 0, 0);
  }
  100% {
    transform: translate3d(var(--pk-target-reel-end), 0, 0);
  }
}

@media screen and (max-width: 1024px) {
  .pk-openbox-page > .openbox {
    padding-top: 270px !important;
  }

  .pk-target-case {
    padding: 0 10px;
  }

  .pk-target-panel {
    min-height: 516px;
  }

  .pk-target-reel {
    width: calc(100% - 20px);
  }

  .pk-target-contract-list {
    grid-template-columns: repeat(2, 1fr);
  }

  .pk-target-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.pk-openbox-page > .openbox {
  padding-top: 354px !important;
}

.pk-target-battles {
  height: 137px;
  position: absolute;
  left: 76px;
  right: 0;
  top: 198px;
  z-index: 4;
  display: flex;
  gap: 10px;
  overflow: hidden;
}

.pk-target-battle-card {
  width: 394px;
  height: 137px;
  flex: 0 0 394px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(45, 48, 63, 0.95), rgba(32, 34, 45, 0.95));
  border: 1px solid rgba(80, 85, 106, 0.7);
  border-radius: 8px;
}

.pk-target-battle-head {
  height: 66px;
  padding: 14px 20px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.pk-target-battle-head span {
  display: block;
  color: #8b94a6;
  font-size: 10px;
  font-weight: 900;
}

.pk-target-battle-head strong {
  display: block;
  margin-top: 5px;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
}

.pk-target-battle-head button {
  width: 62px;
  height: 22px;
  color: #fff;
  background: #2e3240;
  border: 1px solid #5f657a;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 900;
}

.pk-target-battle-head i {
  width: 12px;
  height: 12px;
  display: inline-block;
  vertical-align: -2px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-target-battle-cases {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #dbe3ef;
  font-size: 18px;
  font-weight: 900;
}

.pk-target-case {
  width: 100% !important;
  max-width: none !important;
  margin: 0 0 90px !important;
  padding: 0 !important;
}

.pk-target-panel {
  min-height: 360px !important;
  border-radius: 0 !important;
  border-left: 1px solid #303342;
  border-right: 0;
  border-top: 1px solid #303342;
  border-bottom: 1px solid #303342;
  background:
    radial-gradient(ellipse at 50% 34%, rgba(94, 242, 151, 0.16), transparent 23%),
    radial-gradient(ellipse at 50% 62%, rgba(107, 111, 132, 0.2), transparent 42%),
    linear-gradient(180deg, #222431 0%, #20222d 100%) !important;
}

.pk-target-panel h1 {
  margin-top: 20px !important;
  font-size: 15px !important;
}

.pk-target-case-art {
  height: 152px !important;
}

.pk-target-case-art img {
  width: 280px !important;
  max-height: 150px !important;
}

.pk-target-amounts {
  margin-top: 10px !important;
}

.pk-target-amounts button {
  width: 42px !important;
  height: 28px !important;
  border-radius: 3px !important;
  font-size: 12px !important;
}

.pk-target-reel {
  width: 909px !important;
  height: 98px !important;
  margin-top: 12px !important;
}

.pk-target-reel-viewport {
  height: 86px !important;
  top: 6px !important;
}

.pk-target-reel-track {
  height: 86px !important;
}

.pk-target-reel-line {
  top: 49px !important;
}

.pk-target-reel-card {
  width: 142px !important;
  height: 86px !important;
  flex-basis: 142px !important;
  border-radius: 4px !important;
}

.pk-target-reel-card .pk-target-grade-bg {
  width: 92px;
  height: 92px;
  position: absolute;
  left: 25px;
  top: -2px;
  object-fit: contain;
}

.pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 118px !important;
  height: 74px !important;
  left: 12px !important;
  top: 2px !important;
}

.pk-target-reel-card strong {
  bottom: 5px !important;
  font-size: 9px !important;
}

.pk-target-actions {
  margin-top: 8px !important;
}

.pk-target-actions button {
  height: 34px !important;
  min-width: 122px !important;
  padding: 0 14px !important;
  border-radius: 3px !important;
  font-size: 12px !important;
}

.pk-target-contract {
  width: 909px;
  margin: 22px auto 0 !important;
}

.pk-target-contract-copy h2 {
  font-size: 13px !important;
}

.pk-target-contract-copy p {
  margin-top: 5px !important;
  font-size: 10px !important;
}

.pk-target-contract-box {
  min-height: 178px !important;
  padding: 17px 18px 18px !important;
  border-color: rgba(142, 49, 62, 0.72) !important;
  border-radius: 5px !important;
}

.pk-target-contract-box h3 {
  margin-bottom: 16px !important;
  font-size: 12px !important;
}

.pk-target-contract-list {
  gap: 12px !important;
}

.pk-target-contract-list article {
  height: 110px !important;
  background: #292b37 !important;
  border: 0 !important;
}

.pk-target-contract-list .pk-target-grade-bg {
  width: 130px;
  height: 130px;
  position: absolute;
  left: 50%;
  top: -6px;
  transform: translateX(-50%);
}

.pk-target-contract-list img:not(.pk-target-grade-bg) {
  width: 170px !important;
  height: 88px !important;
  top: 2px !important;
}

.pk-target-contract-list strong,
.pk-target-contract-list em {
  display: none !important;
}

.pk-target-contains {
  width: 909px;
  margin: 26px auto 0 !important;
}

.pk-target-contains h2 {
  margin-bottom: 20px !important;
  font-size: 11px !important;
  text-align: left !important;
}

.pk-target-grid {
  width: 909px !important;
  display: grid !important;
  grid-template-columns: repeat(5, 174px) !important;
  gap: 10px !important;
}

.pk-target-card {
  min-height: 200px !important;
  position: relative;
  background: #292b37 !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.pk-target-card-art {
  height: 120px !important;
}

.pk-target-card-art .pk-target-grade-bg {
  width: 120px;
  height: 120px;
  position: absolute;
  left: 27px;
  top: 10px;
  object-fit: contain;
}

.pk-target-card-art img:not(.pk-target-grade-bg) {
  width: 120px !important;
  height: 120px !important;
  left: 27px !important;
  top: 10px !important;
  transform: none !important;
}

.pk-target-card-price {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.pk-target-card-price span {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #aeb8c9;
  font-size: 10px;
  font-weight: 900;
}

.pk-target-card-price strong {
  position: absolute;
  left: 0;
  right: 0;
  top: 122px;
  color: #e7a640;
  font-size: 10px;
  font-weight: 900;
  text-align: center;
}

.pk-target-card-copy {
  padding: 0 8px 12px !important;
  text-align: center !important;
}

.pk-target-card-copy span {
  height: 12px !important;
  color: #f19b35 !important;
  font-size: 10px !important;
}

.pk-target-card-copy strong,
.pk-target-card-copy b,
.pk-target-card-copy em {
  color: #fff !important;
  font-size: 10px !important;
  line-height: 1.25 !important;
  text-align: center !important;
}

.pk-target-card-copy b {
  color: #d7dee9 !important;
}

.pk-target-card-copy em {
  color: #8c96a8 !important;
}

.pk-target-drop-activity {
  width: 909px;
  margin: 26px auto 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.pk-target-drop-panel {
  min-height: 260px;
  padding: 18px;
  background: linear-gradient(180deg, #292b37, #22242f);
  border: 1px solid rgba(101, 108, 130, 0.34);
  border-radius: 5px;
}

.pk-target-drop-panel header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 16px;
}

.pk-target-drop-panel header span {
  color: #f0a941;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.pk-target-drop-panel h2 {
  margin: 3px 0 0;
  color: #f4f6fa;
  font-size: 15px;
  font-weight: 900;
}

.pk-target-drop-panel header em {
  color: #9099aa;
  font-size: 10px;
  font-style: normal;
}

.pk-target-best-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.pk-target-best-card {
  height: 84px;
  position: relative;
  overflow: hidden;
  background: #20222d;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.pk-target-best-card .pk-target-grade-bg {
  width: 105px;
  height: 105px;
  position: absolute;
  left: 7px;
  top: -10px;
  object-fit: contain;
}

.pk-target-best-card img:not(.pk-target-grade-bg) {
  width: 106px;
  height: 68px;
  position: absolute;
  left: 4px;
  top: 5px;
  object-fit: contain;
}

.pk-target-best-card strong {
  position: absolute;
  right: 8px;
  top: 8px;
  color: #f2ae46;
  font-size: 10px;
  font-weight: 900;
}

.pk-target-best-card span {
  position: absolute;
  right: 8px;
  bottom: 8px;
  left: 104px;
  color: #e5eaf2;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.25;
}

.pk-target-recent-list {
  display: grid;
  gap: 7px;
}

.pk-target-recent-item {
  min-height: 42px;
  position: relative;
  display: grid;
  grid-template-columns: 28px 52px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  overflow: hidden;
  background: #20222d;
  border: 1px solid rgba(255, 255, 255, 0.045);
}

.pk-target-drop-avatar {
  width: 28px;
  height: 28px;
  position: relative;
  z-index: 2;
  border-radius: 50%;
  object-fit: cover;
}

.pk-target-recent-item .pk-target-grade-bg {
  width: 58px;
  height: 58px;
  position: absolute;
  left: 34px;
  top: -7px;
  object-fit: contain;
}

.pk-target-drop-skin {
  width: 52px;
  height: 34px;
  position: relative;
  z-index: 1;
  object-fit: contain;
}

.pk-target-recent-item div {
  min-width: 0;
}

.pk-target-recent-item strong,
.pk-target-recent-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-target-recent-item strong {
  color: #f4f6fa;
  font-size: 10px;
}

.pk-target-recent-item span,
.pk-target-recent-item em {
  color: #aab3c3;
  font-size: 9px;
  font-style: normal;
}

.pk-target-recent-item em {
  color: #f0a941;
  font-weight: 900;
}

.pk-target-drop-empty {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: #8892a4;
  font-size: 12px;
}

@media screen and (max-width: 980px) {
  .pk-target-drop-activity {
    width: calc(100% - 20px);
    grid-template-columns: 1fr;
  }
}

.pk-openbox-page > .openbox {
  padding-top: 0 !important;
}

.pk-target-battles {
  width: 100% !important;
  margin-top: 198px !important;
  padding-left: 76px !important;
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  z-index: 2 !important;
  box-sizing: border-box;
}

.pk-target-panel {
  border-bottom: 0 !important;
}

.pk-target-case-art {
  height: 170px !important;
}

.pk-target-case-art img {
  width: 340px !important;
  max-height: 188px !important;
  animation:
    pk-target-case-drop 0.72s cubic-bezier(0.16, 0.84, 0.32, 1.18) both,
    pk-case-float 1.65s ease-in-out 0.72s infinite alternate !important;
}

@keyframes pk-target-case-drop {
  0% {
    opacity: 0;
    transform: translateY(-180px) scale(0.92);
  }
  68% {
    opacity: 1;
    transform: translateY(10px) scale(1.04);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.pk-openbox-page {
  min-height: 100vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.pk-openbox-page > .openbox {
  width: 100% !important;
  margin-left: 0 !important;
  height: auto !important;
  min-height: 100vh !important;
  overflow: visible !important;
  padding-bottom: 96px !important;
}

.pk-target-battles {
  margin-top: 0 !important;
}

.pk-target-panel {
  min-height: 396px !important;
  overflow: visible !important;
  padding-bottom: 28px !important;
}

.pk-target-reels {
  width: calc(100% - 200px) !important;
  max-width: 1143px !important;
  margin: 20px auto 0 !important;
  position: relative;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  column-gap: 100px;
  row-gap: 20px;
}

.pk-target-reels.amount-5,
.pk-target-reels.amount-10 {
  margin-top: 46px !important;
}

.pk-target-reel {
  width: auto !important;
  height: 154px !important;
  margin: 0 !important;
  flex: 0 0 100%;
}

.pk-target-reel.full {
  flex-basis: 100% !important;
}

.pk-target-reel.half {
  flex-basis: calc((100% - 100px) / 2) !important;
}

.pk-target-reel-viewport {
  height: 130px !important;
  top: 12px !important;
}

.pk-target-reel-track {
  height: 130px !important;
  width: max-content;
  position: relative;
  left: auto;
  gap: var(--pk-target-card-gap) !important;
  transform: translate3d(var(--pk-target-reel-start), 0, 0) !important;
  transition: none;
  will-change: transform;
}

.pk-target-reel-line {
  top: 77px !important;
}

.pk-target-reel-card {
  width: var(--pk-target-card-width) !important;
  height: 130px !important;
  flex-basis: var(--pk-target-card-width) !important;
  border-radius: 6px !important;
}

.pk-target-reel-card .pk-target-grade-bg {
  width: 100px !important;
  height: 100px !important;
  left: 50% !important;
  top: 8px !important;
  transform: translateX(-50%);
}

.pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 100px !important;
  height: 100px !important;
  left: 50% !important;
  top: 8px !important;
  transform: translateX(-50%);
}

.pk-target-reel-card strong {
  bottom: 10px !important;
  font-size: 10px !important;
}

.pk-target-reel-track.settled {
  transform: translate3d(var(--pk-target-reel-end), 0, 0) !important;
}

@media screen and (max-width: 1180px) {
  .pk-target-reels {
    width: calc(100% - 40px) !important;
    column-gap: 20px;
  }

  .pk-target-reel.half {
    flex-basis: calc((100% - 20px) / 2) !important;
  }
}

.pk-target-panel h1 {
  margin-top: 18px !important;
  font-size: 18px !important;
}

.pk-target-panel::before {
  width: 640px !important;
  height: 330px !important;
  left: 50% !important;
  top: 52px !important;
  z-index: 1 !important;
  transform: translateX(-50%) !important;
  background:
    radial-gradient(ellipse at 50% 28%, rgba(255, 226, 153, 0.12), transparent 25%),
    radial-gradient(ellipse at 50% 46%, rgba(83, 232, 148, 0.17), transparent 40%),
    radial-gradient(ellipse at 50% 82%, rgba(236, 216, 184, 0.07), transparent 58%) !important;
  filter: blur(19px) !important;
  pointer-events: none !important;
}

.pk-target-panel::after {
  content: "" !important;
  width: 1120px !important;
  height: 300px !important;
  position: absolute !important;
  left: 50% !important;
  top: 216px !important;
  z-index: 0 !important;
  transform: translateX(-50%) !important;
  border-radius: 50% 50% 0 0 !important;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(244, 216, 166, 0.07), transparent 28%),
    radial-gradient(ellipse at 50% 20%, rgba(69, 124, 88, 0.11), transparent 48%),
    linear-gradient(180deg, rgba(66, 68, 83, 0.22), rgba(31, 33, 45, 0) 76%) !important;
  box-shadow: inset 0 1px 0 rgba(244, 216, 166, 0.05) !important;
  filter: blur(1px) !important;
  pointer-events: none !important;
}

.pk-target-case-art {
  height: 300px !important;
  margin-top: -8px !important;
  align-items: center !important;
}

.pk-target-case-art img {
  width: 330px !important;
  height: 299px !important;
  max-height: none !important;
  object-fit: contain !important;
  opacity: 0 !important;
  transform: translateY(-270px) scale(0.9) rotate(-2deg);
  animation: none !important;
}

.pk-target-case-art img.dropping {
  opacity: 1 !important;
  animation:
    pk-target-case-drop 1.18s cubic-bezier(0.16, 0.84, 0.28, 1.16) both,
    pk-case-float 2.1s ease-in-out 1.18s infinite alternate !important;
}

.pk-target-amounts {
  margin-top: -2px !important;
}

.pk-target-reels.amount-5,
.pk-target-reels.amount-10 {
  margin-top: 50px !important;
}

.pk-target-reel::before,
.pk-target-reel::after {
  content: "" !important;
  width: 280px !important;
  height: 18px !important;
  position: absolute !important;
  left: 50% !important;
  z-index: 4 !important;
  transform: translateX(-50%) !important;
  filter: blur(6px) !important;
  opacity: 0.5 !important;
  pointer-events: none !important;
}

.pk-target-reel::before {
  top: 4px !important;
  background: radial-gradient(ellipse at 50% 50%, rgba(255, 235, 190, 0.42), rgba(236, 216, 184, 0.11) 38%, transparent 76%) !important;
}

.pk-target-reel::after {
  bottom: 4px !important;
  background: radial-gradient(ellipse at 50% 50%, rgba(255, 235, 190, 0.36), rgba(236, 216, 184, 0.09) 38%, transparent 76%) !important;
}

.pk-target-reel-line {
  height: 1px !important;
  background: linear-gradient(90deg, transparent 0%, rgba(236, 216, 184, 0.035) 25%, rgba(236, 216, 184, 0.32) 50%, rgba(236, 216, 184, 0.035) 75%, transparent 100%) !important;
  opacity: 0.32 !important;
  box-shadow: 0 0 9px rgba(236, 216, 184, 0.1) !important;
}

.pk-target-contract,
.pk-target-contains,
.pk-target-grid {
  width: 1143px !important;
  max-width: calc(100% - 200px) !important;
}

.pk-target-contract {
  margin-top: 28px !important;
}

.pk-target-grid {
  grid-template-columns: repeat(6, 1fr) !important;
}

@keyframes pk-target-case-drop {
  0% {
    opacity: 0;
    transform: translateY(-330px) scale(0.9) rotate(-2deg);
  }
  18% {
    opacity: 1;
    transform: translateY(-330px) scale(0.9) rotate(-2deg);
  }
  68% {
    opacity: 1;
    transform: translateY(16px) scale(1.04) rotate(1deg);
  }
  84% {
    transform: translateY(-7px) scale(0.995) rotate(-0.5deg);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media screen and (max-width: 1180px) {
  .pk-target-contract,
  .pk-target-contains,
  .pk-target-grid {
    max-width: calc(100% - 40px) !important;
  }

  .pk-target-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
</style>


<style lang="less">
/* 2026-09-24: align the open-case composition with the HotPizza reference. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
  width: calc(100% - 280px) !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  left: 140px !important;
  top: 18px !important;
  z-index: 8 !important;
  overflow: hidden !important;
  color: #f7f0e2 !important;
  font-size: 22px !important;
  line-height: 46px !important;
  text-align: center !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
  width: 116px !important;
  height: 46px !important;
  padding: 0 16px !important;
  position: absolute !important;
  right: 22px !important;
  top: 17px !important;
  z-index: 10 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #f5e6c7 !important;
  background: rgba(34, 37, 50, 0.94) !important;
  border: 1px solid rgba(245, 218, 167, 0.76) !important;
  border-radius: 10px !important;
  font-size: 15px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
  height: 300px !important;
  margin-top: 46px !important;
  align-items: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  width: 310px !important;
  height: 270px !important;
  max-width: 310px !important;
  max-height: 270px !important;
  object-fit: contain !important;
  mix-blend-mode: normal !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel::after {
  content: none !important;
  display: none !important;
  background: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card .pk-target-grade-bg {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art {
  position: relative !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
  width: 156px !important;
  height: 156px !important;
  left: 50% !important;
  top: 50% !important;
  z-index: 0 !important;
  opacity: 0.86 !important;
  transform: translate(-50%, -50%) !important;
  object-fit: contain !important;
  object-position: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art img:not(.pk-target-grade-bg) {
  left: 50% !important;
  top: 50% !important;
  z-index: 1 !important;
  transform: translate(-50%, -50%) !important;
  object-position: center !important;
}

@media screen and (max-width: 600px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
    width: calc(100% - 220px) !important;
    left: 14px !important;
    top: 11px !important;
    font-size: 18px !important;
    line-height: 42px !important;
    text-align: left !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
    width: 100px !important;
    height: 42px !important;
    right: 12px !important;
    top: 11px !important;
    padding: 0 12px !important;
    font-size: 15px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
    height: 252px !important;
    margin-top: 50px !important;
    align-items: center !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    width: 236px !important;
    height: 220px !important;
    max-width: 236px !important;
    max-height: 220px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
    width: 144px !important;
    height: 144px !important;
  }
}

/* 2026-09-26 plain case stage: keep the case art readable without the colored halo layers. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
  background: linear-gradient(180deg, #202330 0%, #1f222e 58%, #1d202b 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art::before {
  content: none !important;
  display: none !important;
  background: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel::after {
  background: linear-gradient(180deg, rgba(69, 71, 85, 0.3), rgba(30, 33, 45, 0) 80%) !important;
  box-shadow: none !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  filter: drop-shadow(0 28px 24px rgba(0, 0, 0, 0.38)) !important;
}

@media (prefers-reduced-motion: reduce) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    animation: none !important;
  }
}
</style>

<style lang="less">
/* Match the selected case amount to the winning-item gold focus treatment. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button.active {
  position: relative !important;
  isolation: isolate;
  color: #fff4d7 !important;
  background:
    radial-gradient(ellipse at 50% 48%, rgba(255, 196, 85, 0.2), transparent 64%),
    #303341 !important;
  box-shadow:
    inset 0 0 0 1px rgba(255, 226, 171, 0.7),
    0 0 0 1px rgba(255, 174, 48, 0.22),
    0 0 16px rgba(255, 180, 62, 0.28),
    0 8px 20px rgba(0, 0, 0, 0.18) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button.active::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button.active::after {
  content: "";
  width: calc(100% - 16px);
  height: 1px;
  position: absolute;
  left: 8px;
  pointer-events: none;
  background: linear-gradient(90deg, transparent, rgba(255, 210, 130, 0.68), #fff1ca 50%, rgba(255, 210, 130, 0.68), transparent);
  box-shadow: 0 0 6px rgba(255, 199, 94, 0.72), 0 0 14px rgba(255, 149, 30, 0.24);
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button.active::before {
  top: -1px;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button.active::after {
  bottom: -1px;
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: case detail hero and reel final alignment. */
body:has(.pk-openbox-page) .pk-openbox-page {
  padding-bottom: 100px !important;
  background:
    radial-gradient(ellipse at 50% 312px, rgba(236, 216, 184, 0.1), transparent 560px),
    radial-gradient(ellipse at 50% 285px, rgba(36, 174, 112, 0.14), transparent 420px),
    #191b26 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero {
  min-height: 434px !important;
  padding-top: 10px !important;
  margin-bottom: 0 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-title {
  margin-bottom: -12px !important;
  color: #f5f7fc !important;
  font-size: 24px !important;
  line-height: 30px !important;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.35) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-img {
  width: 540px !important;
  height: 374px !important;
  margin-top: -10px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts {
  margin-top: -18px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts button {
  width: 74px !important;
  height: 54px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
  width: 100% !important;
  max-width: none !important;
  margin-top: 42px !important;
  height: 214px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-row {
  height: 164px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-item {
  height: 164px !important;
  min-width: 224px !important;
  border-radius: 7px !important;
  background:
    radial-gradient(circle at 50% 48%, rgba(253, 107, 1, 0.08), transparent 58%),
    #20222f !important;
  border-color: #2b2d3c !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-item img {
  max-height: 106px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions {
  margin-top: 12px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains {
  margin-top: 46px !important;
}

.pk-target-hidden-reward { min-height: 154px; margin-top: 16px; padding: 24px 120px 24px 28px; position: relative; overflow: hidden; border: 1px solid rgba(255, 200, 88, .55); border-radius: 12px; background: radial-gradient(circle at 78% 50%, rgba(255, 176, 36, .32), transparent 26%), linear-gradient(110deg, #39301f, #242631); box-shadow: inset 0 0 38px rgba(255, 189, 55, .08); }
.pk-target-hidden-reward span { display: block; color: #ffd46a; font-size: 11px; font-weight: 1000; letter-spacing: .16em; }
.pk-target-hidden-reward strong { display: block; margin: 8px 0; color: #fff3cb; font-size: 23px; }
.pk-target-hidden-reward p { max-width: 570px; margin: 0; color: #d8ccb0; line-height: 1.7; }
.pk-target-hidden-reward i { width: 82px; height: 82px; position: absolute; right: 34px; top: 34px; border: 4px solid #ffe697; border-radius: 50%; box-shadow: 0 0 0 9px rgba(255, 195, 58, .16), 0 0 30px rgba(255, 192, 45, .66); }
.pk-target-hidden-reward i::before, .pk-target-hidden-reward i::after { content: ''; width: 39px; height: 4px; position: absolute; left: 18px; top: 35px; border-radius: 6px; background: #ffe697; }
.pk-target-hidden-reward i::after { transform: rotate(90deg); }
</style>

<style lang="less">
/* 2026-07-02 openbox visual parity pass: override only, keep backend bindings intact. */
body:has(.pk-openbox-page) {
  background: #1c1f2b !important;
}

.pk-openbox-page .openbox {
  padding-bottom: 110px !important;
  background:
    radial-gradient(ellipse at 50% 420px, rgba(38, 74, 58, 0.2), transparent 34%),
    linear-gradient(180deg, #1d202c 0%, #1d202b 48%, #1b1e29 100%) !important;
}

.pk-openbox-page .pk-target-battles,
.pk-openbox-page .pk-target-case,
.pk-openbox-page .pk-target-panel,
.pk-openbox-page .pk-target-contract,
.pk-openbox-page .pk-target-contains,
.pk-openbox-page .pk-target-grid,
.pk-openbox-page .pk-target-reels {
  width: 100% !important;
  max-width: min(1580px, calc(100vw - 276px)) !important;
  box-sizing: border-box !important;
}

.pk-openbox-page .pk-target-battles {
  margin: 0 auto 0 !important;
  padding: 0 20px !important;
  gap: 14px !important;
}

.pk-openbox-page .pk-target-case {
  margin: 0 auto !important;
}

.pk-openbox-page .pk-target-panel {
  min-height: 650px !important;
  padding: 0 0 34px !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background:
    radial-gradient(ellipse at 50% 265px, rgba(83, 123, 97, 0.26), transparent 38%),
    radial-gradient(ellipse at 50% 455px, rgba(246, 214, 152, 0.12), transparent 28%),
    linear-gradient(180deg, #1f2230 0%, #202331 51%, #1e212d 100%) !important;
}

.pk-openbox-page .pk-target-panel::before {
  content: "" !important;
  position: absolute !important;
  left: 50% !important;
  top: 45px !important;
  width: 960px !important;
  max-width: calc(100% - 240px) !important;
  height: 450px !important;
  transform: translateX(-50%) !important;
  pointer-events: none !important;
  z-index: 0 !important;
  opacity: 1 !important;
  filter: blur(18px) !important;
  background:
    radial-gradient(ellipse at 50% 23%, rgba(255, 218, 142, 0.25), transparent 22%),
    radial-gradient(ellipse at 50% 44%, rgba(65, 214, 135, 0.26), transparent 42%),
    radial-gradient(ellipse at 50% 78%, rgba(248, 226, 180, 0.16), transparent 62%) !important;
}

.pk-openbox-page .pk-target-panel::after {
  content: "" !important;
  position: absolute !important;
  left: 50% !important;
  top: 260px !important;
  width: 1160px !important;
  max-width: calc(100% - 170px) !important;
  height: 300px !important;
  transform: translateX(-50%) !important;
  border-radius: 50% 50% 0 0 / 100% 100% 0 0 !important;
  pointer-events: none !important;
  z-index: 0 !important;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(255, 221, 154, 0.18), transparent 26%),
    linear-gradient(180deg, rgba(69, 71, 85, 0.38), rgba(30, 33, 45, 0) 80%) !important;
}

.pk-openbox-page .pk-target-panel h1 {
  position: relative !important;
  z-index: 3 !important;
  margin: 0 !important;
  padding-top: 12px !important;
  color: #f6f4ed !important;
  font-size: 22px !important;
  line-height: 30px !important;
  font-weight: 900 !important;
  text-align: center !important;
}

.pk-openbox-page .pk-target-back {
  top: 16px !important;
  right: 18px !important;
  z-index: 6 !important;
  width: 92px !important;
  height: 46px !important;
  color: #f3e3c2 !important;
  border-color: rgba(255, 231, 184, 0.72) !important;
  background: rgba(44, 47, 62, 0.88) !important;
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgba(255, 184, 86, 0.1) !important;
}

.pk-openbox-page .pk-target-case-art {
  position: relative !important;
  z-index: 3 !important;
  height: 390px !important;
  margin-top: -2px !important;
  overflow: visible !important;
}

.pk-openbox-page .pk-target-case-art::before {
  content: "" !important;
  position: absolute !important;
  left: 50% !important;
  bottom: 26px !important;
  width: 620px !important;
  height: 150px !important;
  transform: translateX(-50%) !important;
  border-radius: 50% !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(255, 216, 142, 0.28), transparent 35%),
    radial-gradient(ellipse at 50% 50%, rgba(73, 218, 141, 0.18), transparent 64%) !important;
  filter: blur(18px) !important;
}

.pk-openbox-page .pk-target-case-art img {
  width: 456px !important;
  height: 382px !important;
  object-fit: contain !important;
  transform-origin: 50% 70% !important;
  filter:
    drop-shadow(0 42px 34px rgba(0, 0, 0, 0.56))
    drop-shadow(0 0 42px rgba(73, 222, 140, 0.33))
    drop-shadow(0 0 26px rgba(255, 213, 132, 0.24)) !important;
}

.pk-openbox-page .pk-target-case-art img.dropping {
  animation:
    pk-target-case-drop-hotpizza 0.98s cubic-bezier(0.15, 0.86, 0.28, 1.12) both,
    pk-target-case-float-hotpizza 3.2s ease-in-out 1.02s infinite !important;
}

.pk-openbox-page .pk-target-amounts {
  margin-top: -1px !important;
  gap: 7px !important;
}

.pk-openbox-page .pk-target-amounts button {
  width: 82px !important;
  height: 56px !important;
  color: #f5d59d !important;
  background: #282b39 !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: inset 0 0 0 1px rgba(68, 73, 94, 0.72) !important;
}

.pk-openbox-page .pk-target-amounts button.active {
  color: #fff3d6 !important;
  background: #303341 !important;
  box-shadow:
    inset 0 0 0 1px rgba(123, 129, 153, 0.82),
    0 8px 20px rgba(0, 0, 0, 0.18) !important;
}

.pk-openbox-page .pk-target-reels {
  margin: 66px auto 0 !important;
  padding: 0 36px !important;
  column-gap: clamp(64px, 7.4vw, 132px) !important;
  row-gap: 34px !important;
}

.pk-openbox-page .pk-target-reel {
  height: 196px !important;
  overflow: visible !important;
}

.pk-openbox-page .pk-target-reel-viewport {
  height: 168px !important;
  top: 14px !important;
  overflow: hidden !important;
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%) !important;
  mask-image: linear-gradient(90deg, transparent 0%, #000 10%, #000 90%, transparent 100%) !important;
}

.pk-openbox-page .pk-target-reel-track {
  height: 168px !important;
  gap: 10px !important;
}

.pk-openbox-page .pk-target-reel-card {
  width: 226px !important;
  height: 168px !important;
  flex: 0 0 226px !important;
  background: rgba(41, 44, 58, 0.95) !important;
  border: 1px solid rgba(98, 105, 128, 0.26) !important;
  border-radius: 6px !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.02) !important;
}

.pk-openbox-page .pk-target-reel-card .pk-target-grade-bg {
  width: 174px !important;
  height: 144px !important;
  left: 26px !important;
  top: 12px !important;
  opacity: 0.82 !important;
}

.pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 186px !important;
  height: 122px !important;
  left: 20px !important;
  top: 18px !important;
}

.pk-openbox-page .pk-target-reel-card strong {
  bottom: 13px !important;
  width: calc(100% - 22px) !important;
  color: #f1f0ec !important;
  font-size: 12px !important;
  line-height: 15px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55) !important;
}

.pk-openbox-page .pk-target-reel-line {
  top: 98px !important;
  height: 1px !important;
  opacity: 0.54 !important;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 224, 166, 0.56) 36%, rgba(255, 246, 216, 0.78) 50%, rgba(255, 224, 166, 0.56) 64%, transparent 100%) !important;
  box-shadow: 0 0 22px rgba(255, 216, 141, 0.22) !important;
}

.pk-openbox-page .pk-target-reel::before,
.pk-openbox-page .pk-target-reel::after {
  width: 430px !important;
  background: radial-gradient(ellipse at center, rgba(255, 222, 150, 0.26), transparent 62%) !important;
  opacity: 0.78 !important;
}

.pk-openbox-page .pk-target-pointer {
  z-index: 8 !important;
  filter:
    drop-shadow(0 0 7px rgba(255, 240, 198, 0.82))
    drop-shadow(0 0 18px rgba(255, 197, 99, 0.42)) !important;
}

.pk-openbox-page .pk-target-pointer-top {
  top: -7px !important;
}

.pk-openbox-page .pk-target-pointer-bottom {
  bottom: -7px !important;
}

.pk-openbox-page .pk-target-actions {
  margin-top: 28px !important;
  gap: 12px !important;
}

.pk-openbox-page .pk-target-actions button {
  min-width: 178px !important;
  height: 52px !important;
  border-radius: 5px !important;
  color: #fff !important;
  font-size: 17px !important;
  font-weight: 900 !important;
  background: linear-gradient(180deg, #ff8a0a 0%, #ff7600 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.22),
    0 13px 20px rgba(255, 112, 0, 0.18) !important;
}

.pk-openbox-page .pk-target-contract,
.pk-openbox-page .pk-target-contains {
  margin-top: 36px !important;
}

@keyframes pk-target-case-drop-hotpizza {
  0% {
    opacity: 0;
    transform: translateY(-230px) scale(0.86);
  }
  56% {
    opacity: 1;
    transform: translateY(16px) scale(1.035);
  }
  76% {
    transform: translateY(-10px) scale(0.988);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pk-target-case-float-hotpizza {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

@media screen and (max-width: 1180px) {
  .pk-openbox-page .pk-target-battles,
  .pk-openbox-page .pk-target-case,
  .pk-openbox-page .pk-target-panel,
  .pk-openbox-page .pk-target-contract,
  .pk-openbox-page .pk-target-contains,
  .pk-openbox-page .pk-target-grid,
  .pk-openbox-page .pk-target-reels {
    max-width: calc(100vw - 28px) !important;
  }

  .pk-openbox-page .pk-target-panel {
    min-height: 610px !important;
  }

  .pk-openbox-page .pk-target-case-art img {
    width: 390px !important;
    height: 330px !important;
  }

  .pk-openbox-page .pk-target-reels {
    padding: 0 14px !important;
  }
}
</style>

<style lang="less">
html:has(.pk-openbox-page),
body:has(.pk-openbox-page) {
  height: auto !important;
  overflow-y: auto !important;
}

body:has(.pk-openbox-page) #app,
body:has(.pk-openbox-page) .home.index-shell-page,
body:has(.pk-openbox-page) .maringtop75.backColor,
body:has(.pk-openbox-page) .bot-right {
  height: auto !important;
  min-height: 100vh !important;
  overflow: visible !important;
}

body:has(.pk-openbox-page) .pk-openbox-page {
  height: auto !important;
  overflow: visible !important;
}
</style>

<style lang="less">
.pk-openbox-page .openbox > .box-list {
  display: none !important;
}

.pk-openbox-page .pk-target-case,
.pk-openbox-page .pk-target-panel,
.pk-openbox-page .pk-target-contract,
.pk-openbox-page .pk-target-contains,
.pk-openbox-page .pk-target-grid {
  width: calc(100% - 96px) !important;
  max-width: 1540px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.pk-openbox-page .pk-target-panel {
  min-height: 486px !important;
  padding-top: 26px !important;
  overflow: visible !important;
  background:
    radial-gradient(ellipse at 50% 43%, rgba(44, 74, 62, 0.5), transparent 34%),
    linear-gradient(180deg, #202231 0%, #1c1e2a 100%) !important;
}

.pk-openbox-page .pk-target-panel::before {
  width: 860px !important;
  height: 420px !important;
  top: 58px !important;
  background:
    radial-gradient(ellipse at 50% 26%, rgba(255, 220, 142, 0.22), transparent 22%),
    radial-gradient(ellipse at 50% 43%, rgba(81, 230, 149, 0.24), transparent 44%),
    radial-gradient(ellipse at 50% 75%, rgba(236, 216, 184, 0.15), transparent 62%) !important;
  filter: blur(24px) !important;
}

.pk-openbox-page .pk-target-panel::after {
  width: 1420px !important;
  height: 360px !important;
  top: 226px !important;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(255, 222, 160, 0.13), transparent 24%),
    radial-gradient(ellipse at 50% 24%, rgba(66, 126, 88, 0.18), transparent 48%),
    linear-gradient(180deg, rgba(66, 68, 83, 0.34), rgba(31, 33, 45, 0) 78%) !important;
}

.pk-openbox-page .pk-target-panel h1 {
  margin-top: 8px !important;
  font-size: 22px !important;
  text-shadow: 0 2px 18px rgba(255, 255, 255, 0.18) !important;
}

.pk-openbox-page .pk-target-case-art {
  height: 332px !important;
  margin-top: -4px !important;
}

.pk-openbox-page .pk-target-case-art img {
  width: 390px !important;
  height: 332px !important;
  filter:
    drop-shadow(0 32px 32px rgba(0, 0, 0, 0.55))
    drop-shadow(0 0 34px rgba(82, 230, 148, 0.34))
    drop-shadow(0 0 18px rgba(255, 213, 126, 0.22)) !important;
}

.pk-openbox-page .pk-target-amounts {
  margin-top: 6px !important;
  position: relative !important;
  z-index: 4 !important;
}

.pk-openbox-page .pk-target-amounts button {
  width: 64px !important;
  height: 40px !important;
  color: #f2d79f !important;
  background: #272938 !important;
  border-color: rgba(119, 129, 159, 0.42) !important;
  border-radius: 7px !important;
  font-size: 18px !important;
}

.pk-openbox-page .pk-target-amounts button.active {
  color: #fff !important;
  background: #313442 !important;
  border-color: rgba(245, 220, 170, 0.32) !important;
}

.pk-openbox-page .pk-target-reels {
  width: calc(100% - 96px) !important;
  max-width: 1540px !important;
  margin-top: 56px !important;
  column-gap: 112px !important;
  row-gap: 30px !important;
}

.pk-openbox-page .pk-target-reel {
  height: 178px !important;
}

.pk-openbox-page .pk-target-reel-viewport {
  height: 152px !important;
  top: 13px !important;
}

.pk-openbox-page .pk-target-reel-track {
  height: 152px !important;
  gap: 10px !important;
}

.pk-openbox-page .pk-target-reel-card {
  width: 206px !important;
  height: 152px !important;
  flex-basis: 206px !important;
  background: #282b39 !important;
  border-color: rgba(111, 119, 144, 0.28) !important;
  border-radius: 5px !important;
}

.pk-openbox-page .pk-target-reel-card .pk-target-grade-bg {
  width: 154px !important;
  height: 132px !important;
  left: 26px !important;
  top: 10px !important;
}

.pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 170px !important;
  height: 110px !important;
  left: 18px !important;
  top: 16px !important;
}

.pk-openbox-page .pk-target-reel-card strong {
  bottom: 12px !important;
  font-size: 12px !important;
}

.pk-openbox-page .pk-target-reel-line {
  top: 90px !important;
  background: linear-gradient(90deg, transparent, rgba(244, 222, 181, 0.48), transparent) !important;
  opacity: 0.42 !important;
  box-shadow: 0 0 14px rgba(244, 222, 181, 0.2) !important;
}

.pk-openbox-page .pk-target-reel::before,
.pk-openbox-page .pk-target-reel::after {
  width: 360px !important;
  opacity: 0.72 !important;
}

.pk-openbox-page .pk-target-pointer {
  filter: drop-shadow(0 0 10px rgba(255, 227, 174, 0.5)) !important;
}

.pk-openbox-page .pk-target-actions {
  margin-top: 24px !important;
  position: relative !important;
  z-index: 4 !important;
}

.pk-openbox-page .pk-target-contract {
  margin-top: 34px !important;
}

.pk-openbox-page .pk-target-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 14px !important;
}

.pk-openbox-page .pk-target-case,
.pk-openbox-page .pk-target-panel,
.pk-openbox-page .pk-target-contract,
.pk-openbox-page .pk-target-contains,
.pk-openbox-page .pk-target-grid,
.pk-openbox-page .pk-target-reels {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: min(1540px, calc(100vw - 346px)) !important;
}

.pk-openbox-page .pk-target-panel::before {
  width: min(860px, calc(100vw - 420px)) !important;
  max-width: calc(100% + 80px) !important;
}

.pk-openbox-page .pk-target-panel::after {
  width: min(1120px, calc(100vw - 360px)) !important;
  max-width: calc(100% + 180px) !important;
}

.pk-openbox-page .pk-target-reels {
  column-gap: clamp(40px, 6vw, 112px) !important;
}

@media screen and (max-width: 1180px) {
  .pk-openbox-page .pk-target-case,
  .pk-openbox-page .pk-target-panel,
  .pk-openbox-page .pk-target-contract,
  .pk-openbox-page .pk-target-contains,
  .pk-openbox-page .pk-target-grid,
  .pk-openbox-page .pk-target-reels {
    width: calc(100% - 28px) !important;
    max-width: calc(100% - 28px) !important;
  }

  .pk-openbox-page .pk-target-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
</style>

<style lang="less">
/* 2026-07-02 final openbox clamp: this block must stay after legacy overrides. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels {
  width: 100% !important;
  max-width: min(1580px, calc(100vw - 276px)) !important;
  box-sizing: border-box !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
  min-height: 650px !important;
  padding: 0 0 34px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background:
    radial-gradient(ellipse at 50% 265px, rgba(83, 123, 97, 0.26), transparent 38%),
    radial-gradient(ellipse at 50% 455px, rgba(246, 214, 152, 0.12), transparent 28%),
    linear-gradient(180deg, #1f2230 0%, #202331 51%, #1e212d 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel::before {
  top: 45px !important;
  width: 960px !important;
  max-width: calc(100% - 240px) !important;
  height: 450px !important;
  background:
    radial-gradient(ellipse at 50% 23%, rgba(255, 218, 142, 0.25), transparent 22%),
    radial-gradient(ellipse at 50% 44%, rgba(65, 214, 135, 0.26), transparent 42%),
    radial-gradient(ellipse at 50% 78%, rgba(248, 226, 180, 0.16), transparent 62%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel::after {
  top: 260px !important;
  width: 1160px !important;
  max-width: calc(100% - 170px) !important;
  height: 300px !important;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(255, 221, 154, 0.18), transparent 26%),
    linear-gradient(180deg, rgba(69, 71, 85, 0.38), rgba(30, 33, 45, 0) 80%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
  height: 390px !important;
  margin-top: -2px !important;
  overflow: visible !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  width: 456px !important;
  height: 382px !important;
  object-fit: contain !important;
  filter:
    drop-shadow(0 42px 34px rgba(0, 0, 0, 0.56))
    drop-shadow(0 0 42px rgba(73, 222, 140, 0.33))
    drop-shadow(0 0 26px rgba(255, 213, 132, 0.24)) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img.dropping {
  animation:
    pk-target-case-drop-hotpizza-final 0.98s cubic-bezier(0.15, 0.86, 0.28, 1.12) both,
    pk-target-case-float-hotpizza-final 3.2s ease-in-out 1.02s infinite !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts {
  margin-top: -1px !important;
  gap: 7px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button {
  width: 82px !important;
  height: 56px !important;
  border: 0 !important;
  border-radius: 8px !important;
  color: #f5d59d !important;
  background: #282b39 !important;
  box-shadow: inset 0 0 0 1px rgba(68, 73, 94, 0.72) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels {
  margin: 66px auto 0 !important;
  padding: 0 36px !important;
  column-gap: clamp(64px, 7.4vw, 132px) !important;
  row-gap: 34px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
  height: 196px !important;
  overflow: visible !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track {
  height: 168px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card {
  width: 226px !important;
  height: 168px !important;
  flex: 0 0 226px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 186px !important;
  height: 122px !important;
  left: 20px !important;
  top: 18px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-line {
  top: 98px !important;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 224, 166, 0.56) 36%, rgba(255, 246, 216, 0.78) 50%, rgba(255, 224, 166, 0.56) 64%, transparent 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions {
  margin-top: 28px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
  min-width: 178px !important;
  height: 52px !important;
  background: linear-gradient(180deg, #ff8a0a 0%, #ff7600 100%) !important;
}

@keyframes pk-target-case-drop-hotpizza-final {
  0% {
    opacity: 0;
    transform: translateY(-230px) scale(0.86);
  }
  56% {
    opacity: 1;
    transform: translateY(16px) scale(1.035);
  }
  76% {
    transform: translateY(-10px) scale(0.988);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pk-target-case-float-hotpizza-final {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
</style>

<style lang="less">
/* 2026-07-03 openbox detail pass: battle strip, reel finish state and drop list. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles {
  height: 162px !important;
  margin: 0 auto !important;
  padding: 10px 20px 0 !important;
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 13px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card {
  height: 132px !important;
  overflow: hidden !important;
  position: relative !important;
  border: 1px solid rgba(92, 99, 126, 0.64) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 50% 112%, rgba(255, 128, 0, 0.16), transparent 44%),
    linear-gradient(180deg, #303342 0%, #272a38 48%, #202331 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.025),
    0 18px 38px rgba(0, 0, 0, 0.16) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card::before {
  content: "" !important;
  position: absolute !important;
  left: -1px !important;
  right: -1px !important;
  bottom: -1px !important;
  height: 2px !important;
  background: linear-gradient(90deg, #ff7a00, rgba(255, 122, 0, 0.08), transparent 70%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head {
  height: 78px !important;
  padding: 16px 24px 0 !important;
  display: grid !important;
  grid-template-columns: 1fr 126px 1fr !important;
  align-items: start !important;
  gap: 16px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head > div:last-child {
  text-align: right !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head span {
  color: #a5adbf !important;
  font-size: 13px !important;
  line-height: 16px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head strong {
  margin-top: 6px !important;
  color: #f5f7ff !important;
  font-size: 19px !important;
  line-height: 22px !important;
  font-weight: 1000 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head > div:last-child strong {
  color: #ffbd42 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head button {
  width: 126px !important;
  height: 42px !important;
  margin: 4px auto 0 !important;
  color: #f9f2df !important;
  border: 1px solid rgba(255, 232, 190, 0.72) !important;
  border-radius: 6px !important;
  background: rgba(47, 50, 65, 0.9) !important;
  box-shadow: 0 0 28px rgba(255, 183, 71, 0.07) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head button::after {
  content: "" !important;
  width: 25px !important;
  height: 15px !important;
  margin-left: 9px !important;
  display: inline-block !important;
  vertical-align: -2px !important;
  border: 3px solid #f8efd9 !important;
  border-radius: 50% !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-cases {
  height: 50px !important;
  padding-bottom: 14px !important;
  padding: 0 18px !important;
  display: flex !important;
  align-items: end !important;
  justify-content: center !important;
  gap: 22px !important;
  color: #dce2ef !important;
  font-size: 21px !important;
  line-height: 1 !important;
  font-weight: 1000 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-cases span {
  min-width: 34px !important;
  text-align: center !important;
  filter: drop-shadow(0 0 12px rgba(255, 199, 103, 0.16)) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::after {
  height: 96px !important;
  top: 50px !important;
  width: 520px !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(255, 231, 180, 0.32), transparent 27%),
    radial-gradient(ellipse at 50% 50%, rgba(255, 165, 63, 0.16), transparent 62%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track.spinning {
  animation: none !important;
  transform: translate3d(var(--pk-target-reel-end), 0, 0) !important;
  transition: transform 5s cubic-bezier(0.3, 0.84, 0.44, 1) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track.spinning.fast {
  transition: none !important;
}

@media screen and (max-width: 1470px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
    height: 120px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card {
    height: 100px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport {
    top: 10px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card .pk-target-grade-bg,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
    width: 80px !important;
    height: 80px !important;
    top: 0 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card strong {
    bottom: 10px !important;
  }
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card.winner {
  border-color: #343846 !important;
  background: #292b37 !important;
  box-shadow: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains {
  margin-top: 42px !important;
  padding: 0 20px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract {
  display: grid !important;
  grid-template-columns: 310px minmax(0, 1fr) !important;
  gap: 20px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-copy,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-box {
  border: 1px solid rgba(83, 90, 116, 0.48) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 130, 0, 0.1), transparent 38%),
    #242735 !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-copy {
  min-height: 210px !important;
  padding: 28px 26px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-copy h2,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-box h3,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains h2 {
  color: #f6f4ed !important;
  font-size: 18px !important;
  line-height: 22px !important;
  font-weight: 1000 !important;
  text-align: left !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-copy p {
  margin-top: 13px !important;
  color: #858da1 !important;
  font-size: 13px !important;
  line-height: 1.7 !important;
  font-weight: 800 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-box {
  min-height: 210px !important;
  padding: 22px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-list {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 14px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-list article {
  height: 158px !important;
  border: 1px solid rgba(78, 86, 110, 0.42) !important;
  border-radius: 6px !important;
  background:
    radial-gradient(circle at 50% 42%, rgba(157, 45, 67, 0.24), transparent 44%),
    #292c3a !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains {
  padding-bottom: 90px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains h2 {
  height: 48px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
  margin-top: 16px !important;
  display: grid !important;
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  gap: 14px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card {
  min-height: 244px !important;
  position: relative !important;
  overflow: hidden !important;
  border: 1px solid rgba(77, 84, 108, 0.52) !important;
  border-radius: 7px !important;
  background:
    radial-gradient(circle at 50% 38%, rgba(132, 28, 51, 0.32), transparent 46%),
    linear-gradient(180deg, #2b2e3d 0%, #242735 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card::before {
  content: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card.pk-dark-gold::before {
  content: "★" !important;
  position: absolute !important;
  left: 10px !important;
  top: 9px !important;
  z-index: 4 !important;
  color: #dca746 !important;
  font-size: 16px !important;
  line-height: 1 !important;
  font-weight: 1000 !important;
  text-shadow: 0 0 9px rgba(220, 167, 70, 0.58) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art {
  height: 148px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
  width: 178px !important;
  height: 146px !important;
  opacity: 0.72 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art img:not(.pk-target-grade-bg) {
  width: 178px !important;
  height: 116px !important;
  top: 21px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-price {
  height: 30px !important;
  padding: 0 13px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  color: #ffbd42 !important;
  font-weight: 1000 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-copy {
  padding: 4px 14px 14px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-copy strong,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-copy b {
  color: #f5f7ff !important;
  font-size: 13px !important;
  line-height: 17px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-copy em {
  color: #858da1 !important;
  font-size: 12px !important;
}

@media screen and (max-width: 1280px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract {
    grid-template-columns: 1fr !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
}

/* 2026-07-05 exact-pass: open case detail hero/reel density and glow. */
body:has(.pk-openbox-page) .pk-openbox-page {
  background:
    radial-gradient(ellipse at 50% 270px, rgba(255, 178, 72, 0.13), transparent 440px),
    linear-gradient(180deg, #20222f 0, #1c1e29 420px, #171923 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-main,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains {
  max-width: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero {
  min-height: 408px !important;
  padding-top: 16px !important;
  position: relative !important;
  overflow: visible !important;
  background:
    radial-gradient(ellipse at 50% 70%, rgba(255, 184, 67, 0.17), transparent 42%),
    radial-gradient(ellipse at 50% 48%, rgba(44, 207, 135, 0.2), transparent 38%),
    radial-gradient(ellipse at 50% 95%, rgba(255, 255, 255, 0.055), transparent 58%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero::after {
  content: "" !important;
  position: absolute !important;
  left: 50% !important;
  bottom: 48px !important;
  width: 760px !important;
  height: 180px !important;
  pointer-events: none !important;
  border-radius: 50% !important;
  background: radial-gradient(ellipse, rgba(255, 201, 95, 0.18), rgba(80, 255, 165, 0.08) 42%, transparent 70%) !important;
  transform: translateX(-50%) !important;
  filter: blur(4px) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-img {
  width: 500px !important;
  height: 350px !important;
  margin-top: -8px !important;
  animation:
    pk-target-case-drop-hotpizza-final 0.82s cubic-bezier(0.12, 0.86, 0.18, 1) both,
    pk-target-case-float-hotpizza-final 3.8s ease-in-out 0.9s infinite !important;
  filter:
    drop-shadow(0 30px 38px rgba(0, 0, 0, 0.42))
    drop-shadow(0 0 38px rgba(62, 255, 164, 0.28))
    drop-shadow(0 0 34px rgba(255, 178, 59, 0.2)) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts {
  margin-top: -8px !important;
  gap: 10px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts button {
  width: 66px !important;
  height: 52px !important;
  border-radius: 7px !important;
  background: #252837 !important;
  color: #ecd8b8 !important;
  font-size: 20px !important;
  font-weight: 900 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts button.active,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts button:hover {
  color: #fff7df !important;
  border-color: rgba(236, 216, 184, 0.36) !important;
  background: #343746 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
  margin-top: 30px !important;
  padding: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::after {
  z-index: 4 !important;
  height: 122px !important;
  top: 38px !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(255, 232, 176, 0.46), transparent 24%),
    radial-gradient(ellipse at 50% 50%, rgba(255, 166, 54, 0.22), transparent 62%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-pointer {
  filter:
    drop-shadow(0 0 10px rgba(255, 230, 169, 0.82))
    drop-shadow(0 0 22px rgba(255, 152, 24, 0.5)) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-line {
  height: 2px !important;
  top: 96px !important;
  background: linear-gradient(90deg, transparent 0, rgba(236, 216, 184, 0.18) 18%, rgba(255, 239, 197, 0.82) 50%, rgba(236, 216, 184, 0.18) 82%, transparent 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
  min-width: 190px !important;
  height: 48px !important;
  border-radius: 6px !important;
  color: #fff7df !important;
  font-size: 18px !important;
  box-shadow: 0 12px 24px rgba(255, 111, 0, 0.24) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)) !important;
}

/* The shared mode bar occupies the second 80px row; keep battles in normal flow below it. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles {
  margin-top: 80px !important;
  min-height: 162px !important;
  overflow: hidden !important;
}

/* Keep rarity color visible when the backend has no dedicated background image. */
.pk-openbox-page .pk-grade-1 { --pk-grade-glow: rgba(108, 184, 255, 0.22); }
.pk-openbox-page .pk-grade-2 { --pk-grade-glow: rgba(79, 135, 255, 0.24); }
.pk-openbox-page .pk-grade-3 { --pk-grade-glow: rgba(151, 91, 255, 0.25); }
.pk-openbox-page .pk-grade-4 { --pk-grade-glow: rgba(234, 73, 182, 0.24); }
.pk-openbox-page .pk-grade-5 { --pk-grade-glow: rgba(244, 74, 91, 0.24); }
.pk-openbox-page .pk-grade-6 { --pk-grade-glow: rgba(246, 177, 61, 0.24); }
.pk-openbox-page .pk-grade-7 { --pk-grade-glow: rgba(255, 211, 96, 0.28); }

.pk-openbox-page .pk-target-reel-card[class*="pk-grade-"],
.pk-openbox-page .pk-target-contract-list article[class*="pk-grade-"],
.pk-openbox-page .pk-target-card[class*="pk-grade-"] {
  background:
    radial-gradient(circle at 50% 42%, var(--pk-grade-glow, rgba(99, 211, 164, 0.18)), transparent 62%),
    #292b37 !important;
}

/* Final desktop constraints: legacy fixed card widths must not turn the live strip into a cropped carousel. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  grid-auto-rows: 132px !important;
  align-items: stretch !important;
  height: 162px !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card {
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  height: 132px !important;
  margin: 0 !important;
  flex: none !important;
}

/* Some existing item assets include an opaque black bitmap background. Screen preserves the artwork while exposing the rarity glow beneath it. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  mix-blend-mode: screen !important;
}

/* Match the target roulette metrics after every legacy visual override. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
  height: 154px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card {
  height: 130px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track {
  gap: var(--pk-target-card-gap) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card {
  width: var(--pk-target-card-width) !important;
  flex: 0 0 var(--pk-target-card-width) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: 100px !important;
  height: 100px !important;
  left: 50% !important;
  top: 8px !important;
  transform: translateX(-50%) !important;
}

@media screen and (max-width: 1470px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
    height: 120px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card {
    height: 100px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card .pk-target-grade-bg,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
    width: 80px !important;
    height: 80px !important;
    top: 0 !important;
  }
}

@media screen and (min-width: 1181px) {
  /* The shared desktop sidebar is 250px wide; the room strip belongs to the content column, not beneath it. */
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles {
    width: calc(100% - 250px) !important;
    max-width: none !important;
    margin-left: 250px !important;
    margin-right: 0 !important;
  }
}

@media screen and (min-width: 1181px) and (max-width: 1400px) {
  /* Keep the live-room header on one line while three cards share the mid-size desktop content column. */
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head {
    padding: 14px 14px 0 !important;
    grid-template-columns: minmax(0, 1fr) 100px minmax(0, 1fr) !important;
    gap: 8px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head button {
    width: 100px !important;
    height: 40px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head span {
    font-size: 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head strong {
    font-size: 17px !important;
    white-space: nowrap !important;
  }
}

/* The live-room summary needs visible case art rather than a blank quantity row. */
@media screen and (min-width: 981px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head {
    height: 66px !important;
    padding: 12px 20px 0 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-cases {
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    height: 66px !important;
    padding: 0 12px !important;
    display: flex !important;
    align-items: flex-end !important;
    justify-content: space-around !important;
    gap: 0 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-cases span {
    position: relative !important;
    min-width: 82px !important;
    padding-top: 4px !important;
    color: #e7ebf4 !important;
    font-size: 11px !important;
    z-index: 1 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-cases span::before {
    content: "" !important;
    display: block !important;
    width: 78px !important;
    height: 62px !important;
    margin: 0 auto -12px !important;
    background: url("../assets/hotpizza/hp-case-orange.png") center / contain no-repeat !important;
    filter: drop-shadow(0 5px 8px rgba(255, 139, 52, 0.38)) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card:nth-child(3n + 2) .pk-target-battle-cases span::before {
    background-image: url("../assets/hotpizza/hp-case-green.png") !important;
    filter: drop-shadow(0 5px 8px rgba(39, 216, 173, 0.34)) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card:nth-child(3n) .pk-target-battle-cases span::before {
    background-image: url("../assets/hotpizza/hp-case-fire.png") !important;
    filter: drop-shadow(0 5px 8px rgba(255, 96, 65, 0.34)) !important;
  }
}

/* On a phone, preserve each live battle card instead of squeezing three desktop cards into one row. */
@media screen and (max-width: 980px) {
  body:has(.pk-openbox-page) .pk-openbox-page,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-main {
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles {
    height: 144px !important;
    min-height: 144px !important;
    margin-top: 80px !important;
    padding: 0 12px !important;
    display: flex !important;
    grid-template-columns: none !important;
    grid-auto-rows: auto !important;
    gap: 12px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scroll-snap-type: x mandatory;
    -ms-overflow-style: none;
    scrollbar-width: none;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battles::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-card {
    width: calc(100vw - 24px) !important;
    min-width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px) !important;
    height: 132px !important;
    flex: 0 0 calc(100vw - 24px) !important;
    scroll-snap-align: start;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head {
    height: 66px !important;
    padding: 12px 16px 0 !important;
    grid-template-columns: minmax(0, 1fr) 96px minmax(0, 1fr) !important;
    gap: 8px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head button {
    width: 96px !important;
    height: 34px !important;
    font-size: 14px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head span {
    font-size: 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-battle-head strong {
    font-size: 17px !important;
    white-space: nowrap !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero {
    min-height: 354px !important;
    padding-top: 12px !important;
    overflow: hidden !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-hero::after {
    width: 430px !important;
    height: 128px !important;
    bottom: 36px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-img {
    width: 100% !important;
    max-width: 390px !important;
    height: 250px !important;
    margin-top: -4px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts {
    margin-top: -2px !important;
    gap: 6px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-counts button {
    width: 52px !important;
    height: 42px !important;
    font-size: 16px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel {
    margin-top: 20px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions {
    width: 100% !important;
    padding: 0 12px !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 8px !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
    min-width: 0 !important;
    width: 100% !important;
    height: 46px !important;
    font-size: 16px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains {
    margin-top: 26px !important;
    padding: 0 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-list,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card {
    min-height: 210px !important;
  }
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button:disabled {
  opacity: 0.58;
  cursor: wait;
  filter: saturate(0.5);
}

/* Keep the selector light localized around the arrows instead of drawing a seam across every card. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-line {
  display: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::after {
  width: 640px !important;
  max-width: 58vw !important;
  height: 96px !important;
  left: 50% !important;
  opacity: 0.72 !important;
  filter: blur(13px) !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(255, 235, 189, 0.33) 0%, rgba(255, 187, 78, 0.14) 32%, rgba(255, 151, 40, 0.045) 52%, transparent 72%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before {
  top: -30px !important;
  bottom: auto !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::after {
  top: auto !important;
  bottom: -30px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-pointer {
  filter:
    drop-shadow(0 0 7px rgba(255, 244, 211, 0.92))
    drop-shadow(0 0 18px rgba(255, 184, 67, 0.72))
    drop-shadow(0 0 34px rgba(255, 137, 22, 0.34)) !important;
}
</style>

<style lang="less">
/* Center the open-case content inside the desktop area to the right of the shared sidebar. */
@media screen and (min-width: 981px) {
  body:has(.pk-openbox-page) .pk-openbox-page > .openbox {
    width: calc(100% - 250px) !important;
    margin-left: 250px !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-openbox-page) .pk-openbox-page > .openbox {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
</style>

<style lang="less">
/* HotPizza multi-open composition: five uses 2-1-2, ten uses five compact double rows. */
@media screen and (min-width: 981px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 {
    padding: 0 70px !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    grid-auto-flow: row !important;
    column-gap: 36px !important;
    align-items: start !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 {
    row-gap: 18px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 {
    row-gap: 14px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel {
    width: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
    overflow: visible !important;
    flex: none !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel.full {
    grid-column-start: 1 !important;
    grid-column-end: -1 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel {
    height: 132px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-card {
    height: 110px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-viewport {
    top: 11px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-card .pk-target-grade-bg,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-card img:not(.pk-target-grade-bg) {
    width: 86px !important;
    height: 86px !important;
    top: 2px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-card strong {
    bottom: 7px !important;
    font-size: 10px !important;
  }
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel::after {
  width: 330px !important;
  max-width: 72% !important;
  height: 2px !important;
  left: 50% !important;
  opacity: 0.92 !important;
  filter: none !important;
  background: linear-gradient(90deg, transparent 0%, rgba(224, 196, 139, 0.08) 8%, rgba(246, 220, 166, 0.62) 43%, #fff0ca 50%, rgba(246, 220, 166, 0.62) 57%, rgba(224, 196, 139, 0.08) 92%, transparent 100%) !important;
  box-shadow: 0 0 7px rgba(255, 216, 139, 0.28), 0 0 18px rgba(255, 166, 49, 0.12) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel::before {
  top: 7px !important;
  bottom: auto !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel::after {
  top: auto !important;
  bottom: 7px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-pointer,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-pointer {
  z-index: 9 !important;
  filter: drop-shadow(0 0 6px rgba(255, 244, 213, 0.82)) drop-shadow(0 0 14px rgba(255, 183, 73, 0.5)) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-pointer-top,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-pointer-top {
  top: 0 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-pointer-bottom,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-pointer-bottom {
  bottom: 0 !important;
}

@media screen and (max-width: 1470px) and (min-width: 981px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 {
    padding: 0 28px !important;
    column-gap: 22px !important;
    row-gap: 16px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel {
    height: 112px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel-card {
    height: 92px !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 {
    padding: 0 12px !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 14px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-5 .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-10 .pk-target-reel {
    width: 100% !important;
    margin: 0 !important;
    overflow: visible !important;
    flex: none !important;
  }
}

@media screen and (max-width: 600px) {
  body:has(.pk-openbox-page) .pk-openbox-page > .openbox {
    padding-top: 0 !important;
    padding-bottom: 94px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case {
    margin-bottom: 34px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
    min-height: 0 !important;
    padding-bottom: 42px !important;
    border-top-color: rgba(74, 78, 98, 0.72) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    left: 0 !important;
    top: 18px !important;
    font-size: 18px !important;
    line-height: 24px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
    right: 10px !important;
    top: 10px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
    width: 100% !important;
    height: 300px !important;
    margin: 0 !important;
    align-items: flex-end !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    width: 280px !important;
    max-width: 280px !important;
    height: 254px !important;
    max-height: 254px !important;
    object-fit: contain !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts {
    height: 40px !important;
    margin-top: 10px !important;
    gap: 4px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button {
    width: 50px !important;
    height: 40px !important;
    font-size: 16px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels {
    width: 100% !important;
    max-width: none !important;
    margin: 40px auto 0 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 {
    height: 120px !important;
    padding: 0 16px !important;
    display: block !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel {
    width: 100% !important;
    height: 120px !important;
    margin: 0 !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card {
    height: 100px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-viewport {
    top: 10px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card {
    width: 140px !important;
    flex-basis: 140px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions {
    width: 100% !important;
    height: 40px !important;
    margin-top: 40px !important;
    padding: 0 15px !important;
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
    width: 100% !important;
    min-width: 0 !important;
    height: 40px !important;
    padding: 0 8px !important;
    font-size: 14px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-activity {
    width: 100% !important;
    box-sizing: border-box !important;
  }
}

/* Box contents reveal the current item's price and display probability on interaction. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-price {
  opacity: 0 !important;
  visibility: hidden !important;
  transform: translateY(4px) !important;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card:hover .pk-target-card-price,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card:focus .pk-target-card-price {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card:focus-visible {
  outline: 1px solid rgba(255, 184, 55, 0.72) !important;
  outline-offset: -1px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-price strong {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-price strong i {
  width: 12px !important;
  height: 12px !important;
  display: inline-block !important;
  flex: 0 0 12px !important;
  position: static !important;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat !important;
  filter: drop-shadow(0 0 5px rgba(255, 156, 31, 0.38)) !important;
}

/* Keep one-to-four opening reels aligned with the JavaScript landing calculation. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 {
  --pk-reel-row-height: 172px;
  --pk-reel-card-height: 148px;
  --pk-reel-viewport-offset: 12px;
  --pk-reel-grade-size: 152px;
  --pk-reel-art-width: 163px;
  --pk-reel-art-height: 107px;
  --pk-reel-art-top: 15px;
  --pk-reel-label-bottom: 11px;
  --pk-reel-label-size: 11px;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel {
  height: var(--pk-reel-row-height) !important;
  min-width: 0 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-viewport,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-viewport,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-viewport,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-viewport {
  height: var(--pk-reel-card-height) !important;
  top: var(--pk-reel-viewport-offset) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-track,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-track,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-track,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-track {
  height: var(--pk-reel-card-height) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card {
  width: var(--pk-target-card-width) !important;
  height: var(--pk-reel-card-height) !important;
  flex: 0 0 var(--pk-target-card-width) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card .pk-target-grade-bg {
  width: var(--pk-reel-grade-size) !important;
  height: var(--pk-reel-grade-size) !important;
  left: 50% !important;
  top: 0 !important;
  transform: translateX(-50%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card img:not(.pk-target-grade-bg),
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card img:not(.pk-target-grade-bg),
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card img:not(.pk-target-grade-bg),
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card img:not(.pk-target-grade-bg) {
  width: var(--pk-reel-art-width) !important;
  height: var(--pk-reel-art-height) !important;
  left: 50% !important;
  top: var(--pk-reel-art-top) !important;
  transform: translateX(-50%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card strong,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card strong,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card strong,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card strong {
  bottom: var(--pk-reel-label-bottom) !important;
  font-size: var(--pk-reel-label-size) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-line,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-line,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-line,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-line {
  top: 50% !important;
}

@media screen and (max-width: 1920px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 {
    --pk-reel-row-height: 156px;
    --pk-reel-card-height: 132px;
    --pk-reel-viewport-offset: 12px;
    --pk-reel-grade-size: 136px;
    --pk-reel-art-width: 146px;
    --pk-reel-art-height: 96px;
    --pk-reel-art-top: 13px;
    --pk-reel-label-bottom: 9px;
    --pk-reel-label-size: 10px;
  }
}

@media screen and (max-width: 1470px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 {
    --pk-reel-row-height: 128px;
    --pk-reel-card-height: 104px;
    --pk-reel-viewport-offset: 12px;
    --pk-reel-grade-size: 108px;
    --pk-reel-art-width: 116px;
    --pk-reel-art-height: 76px;
    --pk-reel-art-top: 10px;
    --pk-reel-label-bottom: 8px;
    --pk-reel-label-size: 9px;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 {
    padding: 0 12px !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 14px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel {
    width: 100% !important;
    margin: 0 !important;
    flex: none !important;
  }
}
</style>

<style lang="less">
/* 2026-09-11 annotated open-case composition: restore case/effect layers and fill the content stage. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
  background:
    radial-gradient(ellipse at 50% 30%, rgba(62, 84, 76, 0.17), transparent 32%),
    radial-gradient(ellipse at 50% 68%, rgba(88, 87, 91, 0.16), transparent 48%),
    linear-gradient(180deg, #202330 0%, #1f222e 58%, #1d202b 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  mix-blend-mode: normal !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels {
  padding-right: 36px !important;
  padding-left: 36px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before {
  content: "" !important;
  width: 430px !important;
  max-width: 52vw !important;
  height: calc(100% + 92px) !important;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  bottom: auto !important;
  z-index: 1 !important;
  opacity: 0.68 !important;
  transform: translate(-50%, -50%) !important;
  filter: drop-shadow(0 0 20px rgba(255, 189, 74, 0.18)) !important;
  background-image: var(--pk-target-effect-image) !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  pointer-events: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::after {
  display: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport {
  z-index: 2 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
  left: 50% !important;
  top: 50% !important;
  z-index: 0 !important;
  transform: translate(-50%, -50%) !important;
  object-position: center !important;
  opacity: 0.58 !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art img:not(.pk-target-grade-bg) {
  left: 50% !important;
  top: 50% !important;
  z-index: 1 !important;
  transform: translate(-50%, -50%) !important;
  object-position: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel::before {
  content: none !important;
  display: none !important;
  background-image: none !important;
}

@media screen and (min-width: 601px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    left: 0 !important;
    top: 20px !important;
    z-index: 8 !important;
    color: #f7f0e2 !important;
    font-size: 22px !important;
    line-height: 30px !important;
    text-shadow: 0 2px 18px rgba(255, 214, 145, 0.2) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
    width: 112px !important;
    height: 44px !important;
    padding: 0 15px !important;
    position: absolute !important;
    right: 24px !important;
    top: 14px !important;
    z-index: 9 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #f5e6c7 !important;
    background: rgba(37, 40, 54, 0.92) !important;
    border: 1px solid rgba(245, 218, 167, 0.72) !important;
    border-radius: 9px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
    height: 334px !important;
    margin-top: 32px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art::before {
    width: 520px !important;
    height: 132px !important;
    bottom: 20px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    width: 360px !important;
    height: 314px !important;
    max-width: 360px !important;
    max-height: 314px !important;
  }
}

@media screen and (max-width: 980px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel::before {
    width: 330px !important;
    max-width: 82% !important;
    height: calc(100% + 66px) !important;
  }
}
</style>

<style lang="less">
/* 2026-09-24 final open-case composition override. */
@media screen and (min-width: 601px) {
  body:has(.pk-openbox-page) .pk-openbox-page > .openbox {
    padding-top: 85px !important;
  }
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
  padding-top: 66px !important;
  box-sizing: border-box !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
  width: calc(100% - 280px) !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  left: 140px !important;
  top: 12px !important;
  z-index: 8 !important;
  overflow: hidden !important;
  color: #f7f0e2 !important;
  font-size: 22px !important;
  line-height: 46px !important;
  text-align: center !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
  width: 116px !important;
  height: 46px !important;
  padding: 0 16px !important;
  position: absolute !important;
  right: 22px !important;
  top: 11px !important;
  z-index: 10 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #f5e6c7 !important;
  background: rgba(34, 37, 50, 0.94) !important;
  border: 1px solid rgba(245, 218, 167, 0.76) !important;
  border-radius: 10px !important;
  font-size: 15px !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
  height: 300px !important;
  margin-top: 0 !important;
  align-items: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  width: 310px !important;
  height: 270px !important;
  max-width: 310px !important;
  max-height: 270px !important;
  object-fit: contain !important;
  mix-blend-mode: normal !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel::after,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel::after {
  content: none !important;
  display: none !important;
  background: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-1 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-2 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-3 .pk-target-reel-card .pk-target-grade-bg,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels.amount-4 .pk-target-reel-card .pk-target-grade-bg {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art {
  position: relative !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
  width: 156px !important;
  height: 156px !important;
  left: 50% !important;
  top: 50% !important;
  z-index: 0 !important;
  opacity: 0.86 !important;
  transform: translate(-50%, -50%) !important;
  object-fit: contain !important;
  object-position: center !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art img:not(.pk-target-grade-bg) {
  left: 50% !important;
  top: 50% !important;
  z-index: 1 !important;
  transform: translate(-50%, -50%) !important;
  object-position: center !important;
}

@media screen and (max-width: 600px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
    padding-top: 64px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel h1 {
    width: calc(100% - 140px) !important;
    left: 14px !important;
    top: 11px !important;
    font-size: 18px !important;
    line-height: 42px !important;
    text-align: left !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back {
    width: 100px !important;
    height: 42px !important;
    right: 12px !important;
    top: 11px !important;
    padding: 0 12px !important;
    font-size: 15px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art {
    height: 252px !important;
    margin-top: 0 !important;
    align-items: center !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    width: 236px !important;
    height: 220px !important;
    max-width: 236px !important;
    max-height: 220px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-art .pk-target-grade-bg {
    width: 144px !important;
    height: 144px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
    animation: none !important;
  }
}
</style>

<style lang="less">
/* 2026-09-27 final cleanup: plain case artwork and crisp reel item images. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
  background: linear-gradient(180deg, #202330 0%, #1f222e 58%, #1d202b 100%) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel::before,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art::before {
  content: none !important;
  display: none !important;
  background: none !important;
  box-shadow: none !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case-art img {
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card img:not(.pk-target-grade-bg) {
  opacity: 1 !important;
  mix-blend-mode: normal !important;
  filter: none !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card .pk-target-grade-bg {
  filter: none !important;
}
</style>

<style lang="less">
/* 2026-10-01 mobile interaction pass: reels never block controls and touch-only users see item metadata. */
@media screen and (max-width: 600px) {
  body:has(.pk-openbox-page) .pk-openbox-page,
  body:has(.pk-openbox-page) .pk-openbox-page > .openbox,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-case,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
    width: 100% !important;
    max-width: 100vw !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page > .openbox {
    padding-bottom: calc(108px + env(safe-area-inset-bottom)) !important;
    overflow-x: hidden !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-panel {
    padding-bottom: 28px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts {
    width: 100% !important;
    min-height: 44px !important;
    padding: 0 8px !important;
    overflow-x: auto !important;
    justify-content: flex-start !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts::-webkit-scrollbar {
    display: none;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-back,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
    min-height: 44px !important;
    touch-action: manipulation !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-amounts button {
    width: 52px !important;
    height: 44px !important;
    flex: 0 0 52px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reels,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-viewport,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-pointer {
    pointer-events: none !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions {
    height: auto !important;
    min-height: 44px !important;
    margin-top: 24px !important;
    position: relative !important;
    z-index: 20 !important;
    grid-template-columns: minmax(0, 1fr) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-actions button {
    height: 48px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contains,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-activity {
    min-width: 0 !important;
    padding-right: 12px !important;
    padding-left: 12px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-list {
    padding-right: 0 !important;
    padding-left: 0 !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card {
    min-width: 0 !important;
    min-height: 220px !important;
    touch-action: manipulation !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-card-price {
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-activity {
    width: 100% !important;
    margin: 20px auto 0 !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 12px !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-panel {
    width: 100% !important;
    min-width: 0 !important;
    padding: 14px !important;
    box-sizing: border-box !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-best-list {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-recent-item {
    min-width: 0 !important;
    grid-template-columns: 28px 48px minmax(0, 1fr) auto !important;
    gap: 6px !important;
    padding: 6px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-skin {
    width: 48px !important;
  }

  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-drop-panel header {
    align-items: flex-start !important;
    gap: 8px !important;
  }
}

@media screen and (max-width: 380px) {
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-grid,
  body:has(.pk-openbox-page) .pk-openbox-page .pk-target-contract-list {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}
</style>

<style lang="less">
/* Mobile roulette stability: one composited track, with the rarity art painted on each card. */
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-track {
  contain: layout paint;
  will-change: transform;
  backface-visibility: hidden;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card,
body:has(.pk-openbox-page) .pk-openbox-page .pk-target-reel-card.winner {
  background-color: #292b37 !important;
  background-image: var(--pk-target-grade-image) !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  backface-visibility: hidden;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-target-currency-icon {
  width: 18px;
  height: 18px;
  margin-left: 6px;
  object-fit: contain;
  vertical-align: -4px;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-cheese-case .pk-target-actions button {
  color: #251a02;
  background: #ffc13b !important;
  border-color: #ffda7b !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-hidden-gold-card {
  background: #292b37 !important;
  background-image: none !important;
  border-color: rgba(244, 187, 53, 0.58) !important;
}

body:has(.pk-openbox-page) .pk-openbox-page .pk-hidden-gold-card .pk-target-card-copy span,
body:has(.pk-openbox-page) .pk-openbox-page .pk-hidden-gold-card .pk-target-card-copy b {
  color: #f4bb35 !important;
}
</style>
